var _defs, _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g2, _path15, _g3, _path16, _g4, _path17, _path18, _path19, _path20, _path21, _g5, _g6, _g7, _g8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKıds100X200Wm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "283.77pt",
    height: "567.23pt",
    viewBox: "0 0 283.77 567.23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.3594 4.0938c-0.48047-0.125-0.83984-0.34375-1.0781-0.65625-0.24219-0.30469-0.35938-0.67188-0.35938-1.1094 0-0.71094 0.21875-1.2266 0.65625-1.5469 0.44531-0.3125 0.97656-0.46875 1.5938-0.46875 0.6875 0 1.2227 0.1875 1.6094 0.5625 0.39453 0.375 0.59375 0.85938 0.59375 1.4531 0 0.41406-0.10938 0.76953-0.32812 1.0625-0.21094 0.30078-0.52344 0.51562-0.9375 0.64062l-0.125-0.5625c0.30078-0.09375 0.52344-0.24219 0.67188-0.4375 0.14453-0.1875 0.21875-0.42188 0.21875-0.70312 0-0.46875-0.15625-0.82812-0.46875-1.0781-0.30469-0.24219-0.71094-0.35938-1.2188-0.35938-0.60547 0-1.0547 0.125-1.3438 0.375-0.29297 0.25781-0.4375 0.59766-0.4375 1.0156 0 0.33203 0.085938 0.60156 0.26562 0.8125 0.1875 0.20703 0.46094 0.35156 0.82812 0.4375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 4.5469v-0.54688h3.5938v-0.015625l-3.5938-1.2344v-0.5l3.6562-1.2344v-0.015625h-3.6562v-0.54688h4.2969v0.85938l-3.0469 1.0156c-0.33594 0.11328-0.54297 0.17578-0.625 0.1875v0.015625c0.16406 0.050781 0.39453 0.12891 0.6875 0.23438l2.9844 1.0156v0.76562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 4.0156v-0.65625l1.3125-0.5v-1.7969l-1.3125-0.46875v-0.59375l4.2969 1.6406v0.60938zm1.7656-1.3281c0.92578-0.35547 1.4531-0.55469 1.5781-0.59375 0.125-0.042969 0.28906-0.089844 0.5-0.14062v-0.015625c-0.29297-0.0625-0.55859-0.13672-0.79688-0.21875l-1.2812-0.48438z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 3.8594v-0.59375l3.375-2.2344v-0.015625h-3.375v-0.54688h4.2969v0.59375l-3.375 2.2344v0.015625h3.375v0.54688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.7812 3.5312v-1.4219h-3.7812v-0.5625h3.7812v-1.4219h0.51562v3.4062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 3.6875v-3.2188h4.2969v3.1094h-0.51562v-2.5312h-1.3125v2.375h-0.5v-2.375h-1.4531v2.6406z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 3.1406v-2.6875h4.2969v0.5625h-3.7812v2.125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 1.125v-0.57812h4.2969v0.57812z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.2969 0.48438v1.4844c0 0.25781-0.015625 0.48438-0.046875 0.67188-0.023438 0.1875-0.085938 0.36328-0.1875 0.53125-0.10547 0.16406-0.24609 0.3125-0.42188 0.4375-0.17969 0.13281-0.38672 0.23828-0.625 0.3125-0.23047 0.070313-0.51172 0.10938-0.84375 0.10938-0.63672 0-1.1562-0.15234-1.5625-0.45312-0.40625-0.30469-0.60938-0.82031-0.60938-1.5469v-1.5469zm-3.7812 0.5625v0.92188c0 0.1875 0.007813 0.35156 0.03125 0.5 0.019531 0.14453 0.082031 0.28906 0.1875 0.4375 0.10156 0.15625 0.26953 0.28516 0.5 0.39062 0.23828 0.10156 0.55469 0.15625 0.95312 0.15625 0.20703 0 0.40625-0.023437 0.59375-0.0625 0.1875-0.042969 0.35938-0.11719 0.51562-0.21875 0.15625-0.09375 0.26562-0.21094 0.32812-0.34375 0.070312-0.13672 0.11328-0.26562 0.125-0.39062 0.019531-0.125 0.03125-0.28906 0.03125-0.48438v-0.90625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.2969 3.9688-4.2969-1.6875v-0.57812l4.2969-1.6719v0.60938l-3.125 1.125c-0.19922 0.082031-0.43359 0.15625-0.70312 0.21875v0.015625c0.22656 0.0625 0.46094 0.13281 0.70312 0.21875l3.125 1.1719z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.8125 3.8594c-0.21875 0-0.42188-0.015625-0.60938-0.046875-0.1875-0.023438-0.38281-0.085938-0.57812-0.1875-0.19922-0.10547-0.36719-0.27734-0.5-0.51562-0.13281-0.23047-0.20312-0.54297-0.20312-0.9375 0-0.38672 0.058594-0.69922 0.17188-0.9375 0.125-0.23047 0.27344-0.40234 0.45312-0.51562 0.1875-0.10547 0.37891-0.17188 0.57812-0.20312 0.20703-0.03125 0.4375-0.046875 0.6875-0.046875h2.4844v0.57812h-2.4844c-0.25 0-0.46875 0.015625-0.65625 0.046875-0.1875 0.039062-0.35547 0.14062-0.5 0.29688-0.14844 0.15625-0.21875 0.39844-0.21875 0.73438 0 0.33203 0.054688 0.58203 0.17188 0.75 0.11328 0.16406 0.26562 0.27344 0.45312 0.32812 0.19531 0.050781 0.44531 0.078125 0.75 0.078125h2.4844v0.57812z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.2969 1.6719-4.4375-1.25v-0.42188l4.4375 1.25z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.375 2.3438c0 0.60156-0.21094 1.0938-0.625 1.4688-0.40625 0.38281-0.94531 0.57812-1.6094 0.57812-0.66797 0-1.2031-0.19531-1.6094-0.57812-0.40625-0.38672-0.60938-0.875-0.60938-1.4688 0-0.625 0.20703-1.125 0.625-1.5 0.42578-0.375 0.94141-0.5625 1.5469-0.5625 0.70703 0 1.2656 0.1875 1.6719 0.5625 0.40625 0.38281 0.60938 0.88281 0.60938 1.5zm-3.9688-0.015625c0 0.4375 0.14844 0.78906 0.45312 1.0625 0.3125 0.26953 0.73828 0.40625 1.2812 0.40625 0.5625 0 0.98828-0.14062 1.2812-0.42188 0.30078-0.27344 0.45312-0.61719 0.45312-1.0312 0-0.42969-0.14844-0.78125-0.4375-1.0625-0.29297-0.27344-0.74609-0.40625-1.3594-0.40625-0.49219 0-0.89062 0.13281-1.2031 0.40625-0.3125 0.26953-0.46875 0.61719-0.46875 1.0469z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 3.8594v-0.57812h2.0156v-2.2344h-2.0156v-0.5625h4.2969v0.5625h-1.7656v2.2344h1.7656v0.57812z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.0312 3.0156c0.28125-0.023437 0.48828-0.12109 0.625-0.29688 0.13281-0.17969 0.20312-0.42969 0.20312-0.75 0-0.29297-0.058594-0.53125-0.17188-0.71875-0.10547-0.17969-0.26172-0.26562-0.46875-0.26562-0.1875 0-0.32812 0.066406-0.42188 0.20312-0.085937 0.14453-0.17188 0.41406-0.26562 0.8125-0.074219 0.35156-0.15234 0.64453-0.23438 0.875-0.085937 0.22656-0.21484 0.42188-0.39062 0.57812-0.16797 0.15625-0.39844 0.23438-0.6875 0.23438-0.375 0-0.6875-0.14844-0.9375-0.4375-0.24219-0.29297-0.35938-0.67969-0.35938-1.1562 0-0.59375 0.13281-1.043 0.40625-1.3438 0.26953-0.30469 0.61719-0.46484 1.0469-0.48438l0.046875 0.54688c-0.34375 0.019531-0.59375 0.14844-0.75 0.39062-0.15625 0.23828-0.23438 0.53125-0.23438 0.875 0 0.32031 0.0625 0.57812 0.1875 0.76562 0.13281 0.19531 0.31641 0.29688 0.54688 0.29688 0.22656 0 0.39453-0.10547 0.5-0.3125 0.11328-0.19922 0.22266-0.54297 0.32812-1.0312 0.10156-0.48047 0.25-0.82812 0.4375-1.0469 0.1875-0.21094 0.42969-0.3125 0.73438-0.3125 0.34375 0 0.62891 0.13281 0.85938 0.40625 0.22656 0.26953 0.34375 0.64062 0.34375 1.1094s-0.11719 0.84766-0.34375 1.1406c-0.21875 0.28906-0.53906 0.44531-0.95312 0.46875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.2969 0.46875v1.6094c0 0.25781-0.015625 0.47656-0.046875 0.65625-0.023438 0.1875-0.085938 0.35938-0.1875 0.51562-0.10547 0.16406-0.25 0.28516-0.4375 0.35938-0.17969 0.082031-0.37109 0.125-0.57812 0.125-0.39844 0-0.71484-0.13281-0.95312-0.39062-0.24219-0.25-0.35938-0.65625-0.35938-1.2188v-1.0938h-1.7344v-0.5625zm-2.0469 0.5625v1.1094c0 0.67578 0.25781 1.0156 0.78125 1.0156 0.17578 0 0.32812-0.046875 0.45312-0.14062 0.13281-0.085937 0.21875-0.19531 0.25-0.32812 0.03125-0.125 0.046875-0.3125 0.046875-0.5625v-1.0938z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.2812 2.8906c-0.085938 0.26953-0.21875 0.46875-0.40625 0.59375-0.17969 0.13281-0.38672 0.20312-0.625 0.20312-0.24219 0-0.46484-0.0625-0.67188-0.1875-0.19922-0.11719-0.34375-0.28906-0.4375-0.51562-0.09375-0.21875-0.14062-0.51562-0.14062-0.89062v-1.6406h4.2969v1.6094c0 0.51953-0.11719 0.88281-0.34375 1.0938-0.23047 0.21875-0.48047 0.32812-0.75 0.32812-0.1875 0-0.36719-0.054687-0.53125-0.15625-0.15625-0.09375-0.28906-0.24219-0.39062-0.4375zm0.21875-1.875v0.9375c0 0.1875 0.00781 0.34375 0.03125 0.46875 0.019531 0.13281 0.078125 0.25 0.17188 0.34375 0.09375 0.10156 0.23438 0.15625 0.42188 0.15625 0.20703 0 0.35938-0.054687 0.45312-0.15625 0.09375-0.09375 0.14844-0.21484 0.17188-0.35938 0.019531-0.13672 0.03125-0.3125 0.03125-0.53125v-0.85938zm-1.9844 0v1.0625c0 0.38281 0.0625 0.64844 0.1875 0.79688 0.13281 0.15625 0.31641 0.23438 0.54688 0.23438 0.22656 0 0.40625-0.085937 0.53125-0.25 0.13281-0.15625 0.20312-0.4375 0.20312-0.84375v-1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.59375 4.2812c-0.44922-0.54297-0.67188-1.1328-0.67188-1.7656 0-0.66797 0.19531-1.2031 0.59375-1.6094 0.40625-0.39844 0.94141-0.59375 1.6094-0.59375 0.40625 0 0.78516 0.082031 1.1406 0.25 0.35156 0.16406 0.625 0.40625 0.8125 0.71875 0.19531 0.32031 0.29688 0.71875 0.29688 1.1875 0 0.47656-0.10938 0.86328-0.32812 1.1562-0.21094 0.28906-0.52734 0.48828-0.95312 0.59375l-0.14062-0.51562c0.3125-0.074219 0.53906-0.21484 0.6875-0.42188 0.15625-0.21094 0.23438-0.48047 0.23438-0.8125 0-0.52344-0.15625-0.91406-0.46875-1.1719-0.3125-0.26172-0.72656-0.39062-1.2344-0.39062-0.38672 0-0.71094 0.0625-0.96875 0.1875-0.25 0.125-0.44531 0.3125-0.57812 0.5625-0.125 0.25-0.1875 0.52344-0.1875 0.82812 0 0.44531 0.14453 0.86328 0.4375 1.25h0.79688v-1.2656h0.51562v1.8125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 4.2656v-0.71875c0.67578-0.42969 1.0938-0.69531 1.25-0.79688 0.15625-0.10547 0.28516-0.21484 0.39062-0.32812 0.11328-0.11719 0.17969-0.22656 0.20312-0.32812 0.03125-0.09375 0.046875-0.22656 0.046875-0.39062v-0.65625h-1.8906v-0.5625h4.2969v1.8906c0 0.25781-0.015625 0.47656-0.046875 0.65625-0.03125 0.17578-0.10547 0.33203-0.21875 0.46875-0.10547 0.13281-0.24219 0.23438-0.40625 0.29688-0.15625 0.070313-0.32422 0.10938-0.5 0.10938-0.32422 0-0.58594-0.10547-0.78125-0.3125-0.19922-0.19922-0.32422-0.49609-0.375-0.89062h-0.015625c-0.125 0.28906-0.38672 0.5625-0.78125 0.8125zm2.4062-3.2188v1.2188c0 0.25 0.019531 0.44141 0.0625 0.57812 0.039062 0.14453 0.11719 0.25781 0.23438 0.34375 0.125 0.09375 0.26562 0.14062 0.42188 0.14062 0.1875 0 0.34766-0.074219 0.48438-0.21875 0.14453-0.14844 0.21875-0.38281 0.21875-0.70312v-1.3594z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 3.5v-3.3906h0.53125l2.75 2.2031s0.0625 0.050781 0.1875 0.15625c0.125 0.10156 0.22656 0.19531 0.3125 0.28125v-2.3906h0.51562v3.0781h-0.51562l-2.9688-2.4219-0.29688-0.25v2.7344z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.2969 1.8125v-1.625h0.51562v1.625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 3.3281v-3.0469h0.59375l1.6406 1.4062 1.4844-1.4062h0.57812v2.9219h-0.51562v-2.2969l-1.5469 1.4531-1.7188-1.4531v2.4219z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 3.6875v-3.2188h4.2969v3.1094h-0.51562v-2.5312h-1.3125v2.375h-0.5v-2.375h-1.4531v2.6406z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.7812 3.5312v-1.4219h-3.7812v-0.5625h3.7812v-1.4219h0.51562v3.4062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.2969 0.46875v1.6094c0 0.25781-0.015625 0.47656-0.046875 0.65625-0.023438 0.1875-0.085938 0.35938-0.1875 0.51562-0.10547 0.16406-0.25 0.28516-0.4375 0.35938-0.17969 0.082031-0.37109 0.125-0.57812 0.125-0.39844 0-0.71484-0.13281-0.95312-0.39062-0.24219-0.25-0.35938-0.65625-0.35938-1.2188v-1.0938h-1.7344v-0.5625zm-2.0469 0.5625v1.1094c0 0.67578 0.25781 1.0156 0.78125 1.0156 0.17578 0 0.32812-0.046875 0.45312-0.14062 0.13281-0.085937 0.21875-0.19531 0.25-0.32812 0.03125-0.125 0.046875-0.3125 0.046875-0.5625v-1.0938z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 4.0156v-0.65625l1.3125-0.5v-1.7969l-1.3125-0.46875v-0.59375l4.2969 1.6406v0.60938zm1.7656-1.3281c0.92578-0.35547 1.4531-0.55469 1.5781-0.59375 0.125-0.042969 0.28906-0.089844 0.5-0.14062v-0.015625c-0.29297-0.0625-0.55859-0.13672-0.79688-0.21875l-1.2812-0.48438z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 3.8594v-0.57812h3.7812v-2.2344h-3.7812v-0.5625h4.2969v3.375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 3.5v-3.3906h0.53125l2.75 2.2031s0.0625 0.050781 0.1875 0.15625c0.125 0.10156 0.22656 0.19531 0.3125 0.28125v-2.3906h0.51562v3.0781h-0.51562l-2.9688-2.4219-0.29688-0.25v2.7344z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.375 2.3438c0 0.60156-0.21094 1.0938-0.625 1.4688-0.40625 0.38281-0.94531 0.57812-1.6094 0.57812-0.66797 0-1.2031-0.19531-1.6094-0.57812-0.40625-0.38672-0.60938-0.875-0.60938-1.4688 0-0.625 0.20703-1.125 0.625-1.5 0.42578-0.375 0.94141-0.5625 1.5469-0.5625 0.70703 0 1.2656 0.1875 1.6719 0.5625 0.40625 0.38281 0.60938 0.88281 0.60938 1.5zm-3.9688-0.015625c0 0.4375 0.14844 0.78906 0.45312 1.0625 0.3125 0.26953 0.73828 0.40625 1.2812 0.40625 0.5625 0 0.98828-0.14062 1.2812-0.42188 0.30078-0.27344 0.45312-0.61719 0.45312-1.0312 0-0.42969-0.14844-0.78125-0.4375-1.0625-0.29297-0.27344-0.74609-0.40625-1.3594-0.40625-0.49219 0-0.89062 0.13281-1.2031 0.40625-0.3125 0.26953-0.46875 0.61719-0.46875 1.0469z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 4.5469v-0.54688h3.5938v-0.015625l-3.5938-1.2344v-0.5l3.6562-1.2344v-0.015625h-3.6562v-0.54688h4.2969v0.85938l-3.0469 1.0156c-0.33594 0.11328-0.54297 0.17578-0.625 0.1875v0.015625c0.16406 0.050781 0.39453 0.12891 0.6875 0.23438l2.9844 1.0156v0.76562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 3.8594v-0.59375l3.375-2.2344v-0.015625h-3.375v-0.54688h4.2969v0.59375l-3.375 2.2344v0.015625h3.375v0.54688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 1.125v-0.57812h4.2969v0.57812z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 3.9531v-0.60938l3.125-1.1094c0.26953-0.10547 0.50391-0.18359 0.70312-0.23438-0.24219-0.0625-0.47656-0.14062-0.70312-0.23438l-3.125-1.1562v-0.57812l4.2969 1.6875v0.57812z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 5.6719v-2.8125h1.25v-1.6562l-1.25-0.57812v-0.625l4.2969 2.0781v3.5156h-0.51562v-2.1562h-1.3125v2h-0.5v-2h-1.4688v2.2344zm1.75-2.8125h2.0312v-0.42188l-2.0312-0.98438z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 3.9844v-0.75l2.1719-1.5156-0.6875-0.70312h-1.4844v-0.57812h4.2969v0.57812h-2.125l2.125 2.125v0.76562l-1.7344-1.7969z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.9531 4.9219v-3.9531h0.53125v3.9531zm-1.125 0.3125c-0.074219 0-0.25781-0.089844-0.54688-0.26562-0.29297-0.17969-0.53906-0.34375-0.73438-0.5-0.19922-0.15625-0.39062-0.33594-0.57812-0.53125-0.17969-0.19922-0.34375-0.41406-0.5-0.64062-0.15625-0.21875-0.30469-0.46094-0.4375-0.71875-0.13281-0.25-0.25781-0.52344-0.375-0.8125l0.51562-0.32812c0.51953 1.5625 1.3945 2.625 2.625 3.1875v-4h0.54688v4.6094z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.6406 2.6719-0.46875-0.3125c0.41406-0.49219 0.70312-1.0625 0.85938-1.7188l0.5 0.32812c-0.25 0.69531-0.54688 1.2656-0.89062 1.7031zm-0.60938 2.7031c-1.0117-0.6875-1.7461-1.3711-2.2031-2.0469-0.44922-0.67969-0.79297-1.4453-1.0312-2.2969l0.54688-0.34375c0.22656 1.0625 0.59375 1.9141 1.0938 2.5625 0.50781 0.65625 1.1719 1.2227 1.9844 1.7031z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.4375 5.5312v-2.125c-1.4297 0-2.3516-0.54688-2.7656-1.6406l0.48438-0.46875c0.14453 0.53125 0.38281 0.92188 0.71875 1.1719 0.34375 0.25 0.86328 0.37891 1.5625 0.39062v-2.3438h0.54688v2.3438h0.79688c-0.09375-0.51172-0.15234-1.1016-0.17188-1.7656l0.60938-0.25c-0.023438 0.16406-0.03125 0.35156-0.03125 0.5625 0 0.47656 0.066406 1.0195 0.20312 1.625 0.13281 0.60156 0.29688 1.0391 0.48438 1.3125l-0.45312 0.39062c-0.21875-0.375-0.39062-0.82031-0.51562-1.3281h-0.92188v2.125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.14062 4.5938v-0.5h0.21875v-2.8594h0.5v2.8594h0.89062v-2.6719h0.5v2.6719h0.78125v-2.75h0.5v3.25z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-45"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.1094 5.3281-2.6875-2c-0.25 0.25781-0.65234 0.59375-1.2031 1l-0.40625-0.4375c0.92578-0.59375 1.7734-1.4023 2.5469-2.4219l0.40625 0.375c-0.30469 0.38281-0.62109 0.74219-0.95312 1.0781l2.0156 1.5156v-3.7656h0.54688v4.2969z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.0938 3.25-0.20312-0.48438c0.50781-0.11719 0.92969-0.28906 1.2656-0.51562l0.17188 0.5c-0.44922 0.22656-0.85938 0.39453-1.2344 0.5zm1.1094 1.2656c-1.6562-0.0625-2.8203-0.87109-3.4844-2.4219l0.45312-0.35938c0.26953 0.73828 0.65625 1.2969 1.1562 1.6719 0.50781 0.38281 1.0938 0.57812 1.75 0.57812h0.21875zm-1.4062-2.3125-0.1875-0.5c0.53906-0.14844 0.96094-0.33594 1.2656-0.5625l0.1875 0.48438c-0.46875 0.30078-0.89062 0.49219-1.2656 0.57812z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-47"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.5156 5.0938-0.4375-0.39062c0.58203-0.5625 1.0977-1.3711 1.5469-2.4219h-2.9062v-0.53125h5v0.53125h-1.8281l0.23438 0.25c-0.46094 1.0938-0.99609 1.9453-1.6094 2.5625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.8594 5h3.1875v0.4375h-3.1875zm2.9219-2.2812c-0.085938-0.054688-0.24219-0.089844-0.46875-0.10938l-0.28125-0.015625c-0.13672 0-0.375 0.13281-0.71875 0.40625-0.34375 0.26953-0.64844 0.64062-0.90625 1.1094-0.085938-0.14844-0.21484-0.26562-0.39062-0.35938 0.375-0.58594 0.82812-1.0586 1.3594-1.4219-0.59375-0.33594-1.0742-0.78125-1.4375-1.3438 0.13281-0.074219 0.25781-0.1875 0.375-0.34375 0.22656 0.41406 0.53906 0.77344 0.9375 1.0781 0.40625 0.30078 0.9375 0.44531 1.5938 0.4375zm-5.1406 2.2812h1.4688v-3.4688h0.46875v3.9062h-1.9375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.2188 5.6094v-0.95312h-1.3594v-0.45312h3.1875v0.45312h-1.3594v0.95312zm-0.98438-1.9219c-0.09375-0.63672-0.14062-1.6367-0.14062-3h2.5938v2.625h-0.46875v-2.1406h-0.53125v2.0156h-0.46875v-2.0156h-0.65625c-0.011719 1.0703 0.035156 1.9102 0.14062 2.5156zm-2.5938 0.53125h1.4844v-3.0781h0.46875v3.5156h-1.9531z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-50"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.40625 5.4375v-0.45312h2.5469v-0.73438h-2.2188v-0.46875h4.8281v0.46875h-2.1406v0.73438h2.4375v0.45312zm4.6094-2.2969h-3.7656v-2.375h3.7656zm-0.48438-1.9219h-2.8125v1.4688h2.8125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-51"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.4688 4.9531v-3.8438h2.8438v3.7812h-0.48438v-3.2812h-0.70312v3.0938h-0.46875v-3.0938h-0.70312v3.3438zm-1.1562 0.70312v-5.3125h0.46875v5.3125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9062 4.0781-0.0625-0.51562c0.19531-0.0625 0.29688-0.26172 0.29688-0.59375 0-0.14844-0.03125-0.27734-0.09375-0.39062-0.0625-0.10547-0.14844-0.15625-0.25-0.15625-0.0625 0-0.13281 0.03125-0.20312 0.09375-0.0625 0.070313-0.16406 0.25-0.29688 0.53125-0.19922 0.40625-0.37109 0.66406-0.51562 0.78125-0.14844 0.125-0.29297 0.1875-0.4375 0.1875-0.30469 0-0.55469-0.16406-0.76562-0.48438-0.20703-0.3125-0.3125-0.79688-0.3125-1.4531 0-0.58594 0.10547-1.0469 0.3125-1.3906 0.21094-0.33594 0.50391-0.5 0.89062-0.5 0.19531 0 0.42578 0.046875 0.6875 0.14062l-0.10938 0.46875c-0.21094-0.0625-0.39844-0.09375-0.5625-0.09375-0.21875 0-0.38281 0.10156-0.48438 0.3125-0.10156 0.20703-0.15625 0.5625-0.15625 1.0625 0 0.46875 0.046875 0.82031 0.14062 1.0625 0.09375 0.23828 0.21094 0.35938 0.35938 0.35938 0.070312 0 0.14453-0.039062 0.21875-0.10938 0.082031-0.074219 0.19531-0.25781 0.34375-0.54688 0.19531-0.39844 0.35938-0.65234 0.48438-0.76562 0.13281-0.10547 0.26953-0.15625 0.40625-0.15625 0.22656 0 0.4375 0.097656 0.625 0.29688 0.19531 0.19531 0.29688 0.44531 0.29688 0.75 0 0.61328-0.27344 0.98438-0.8125 1.1094zm-3.3281-1.125v-0.42188h0.42188v0.42188zm0-0.78125v-0.4375h0.42188v0.4375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.625 1.3438c-0.71094 0.57031-1.1992 0.85938-1.4688 0.85938-0.36719 0-0.65234-0.15625-0.85938-0.46875-0.19922-0.30469-0.29688-0.74609-0.29688-1.3281v-0.17188h0.57812v0.15625c0 0.875 0.19141 1.3125 0.57812 1.3125 0.25 0 0.73828-0.32422 1.4688-0.96875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 2.625v-0.015625c0-0.24219 0.046875-0.41406 0.14062-0.51562-0.44531-0.09375-0.78906-0.3125-1.0312-0.65625-0.25-0.34375-0.375-0.78125-0.375-1.3125 0-0.13281 0.015625-0.32812 0.046875-0.57812l0.51562 0.10938c-0.03125 0.17969-0.046875 0.33984-0.046875 0.48438 0 0.98828 0.46484 1.4844 1.3906 1.4844 0.22656 0 0.49219-0.046875 0.79688-0.14062v0.5625c-0.1875 0.039063-0.35938 0.066406-0.51562 0.078125-0.23047 0.03125-0.34375 0.1875-0.34375 0.46875v0.03125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-55"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.25 1.8281c-0.042969-0.14844-0.0625-0.25781-0.0625-0.32812 0-0.3125 0.085938-0.57422 0.26562-0.78125 0.1875-0.21094 0.45703-0.3125 0.8125-0.3125 0.28906 0 0.53906 0.09375 0.75 0.28125 0.21875 0.19531 0.32812 0.41406 0.32812 0.65625 0 0.26953-0.15625 0.51562-0.46875 0.73438-0.3125 0.22656-0.69922 0.34375-1.1562 0.34375-0.54297 0-0.96484-0.21484-1.2656-0.64062-0.30469-0.42969-0.45312-1.0234-0.45312-1.7812h0.57812c0 0.51953 0.050781 0.92188 0.15625 1.2031 0.10156 0.28125 0.27344 0.48828 0.51562 0.625zm0.5625 0.078125c0.23828 0 0.45703-0.058594 0.65625-0.17188 0.19531-0.11719 0.29688-0.24609 0.29688-0.39062 0-0.125-0.046875-0.23047-0.14062-0.3125-0.09375-0.074219-0.21484-0.10938-0.35938-0.10938-0.15625 0-0.28125 0.050781-0.375 0.15625-0.09375 0.10156-0.14062 0.23438-0.14062 0.39062 0 0.13281 0.019531 0.28125 0.0625 0.4375zm2.3125-0.4375v-0.51562h0.51562v0.51562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 2.875v-0.015625c0-0.28125 0.0625-0.5 0.1875-0.65625 0.125-0.14844 0.3125-0.25 0.5625-0.3125-0.10547-0.054687-0.19922-0.15234-0.28125-0.29688-0.074219-0.13672-0.10938-0.28125-0.10938-0.4375 0-0.21875 0.070313-0.40625 0.21875-0.5625 0.14453-0.14844 0.34375-0.21875 0.59375-0.21875 0.26953 0 0.51562 0.10156 0.73438 0.3125 0.22656 0.21875 0.39844 0.54688 0.51562 0.98438l0.25-0.03125v0.5l-1.0469 0.14062c-0.36719 0.039062-0.58594 0.066406-0.65625 0.078125-0.074219 0.019531-0.14062 0.050781-0.20312 0.09375-0.0625 0.039063-0.10938 0.09375-0.14062 0.15625s-0.046875 0.13281-0.046875 0.21875v0.046875zm2.0156-1.1562c-0.15625-0.52344-0.43359-0.78125-0.82812-0.78125-0.074219 0-0.13672 0.023438-0.1875 0.078125-0.054688 0.0625-0.078125 0.13281-0.078125 0.21875 0 0.11328 0.050781 0.23438 0.15625 0.35938 0.10156 0.125 0.21094 0.1875 0.32812 0.1875 0.019531 0 0.22266-0.023438 0.60938-0.0625zm1.3281 0.32812v-0.42188h0.42188v0.42188zm0-0.78125v-0.4375h0.42188v0.4375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-57"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.1562 1.1562c-0.375 0-0.66406-0.10156-0.85938-0.29688-0.19922-0.19922-0.29688-0.48438-0.29688-0.85938h0.57812v0.21875c0 0.28906 0.19531 0.4375 0.59375 0.4375h3.125v0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-58"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.625 1.875c-0.03125-0.10547-0.046875-0.20312-0.046875-0.29688 0-0.3125 0.097656-0.58984 0.29688-0.82812 0.19531-0.24219 0.47656-0.35938 0.84375-0.35938 0.32031 0 0.59375 0.09375 0.8125 0.28125 0.21875 0.19531 0.32812 0.42578 0.32812 0.6875 0 0.28125-0.16797 0.53125-0.5 0.75-0.33594 0.22656-0.75781 0.34375-1.2656 0.34375-0.39844 0-0.77734-0.11719-1.1406-0.34375-0.375-0.23047-0.67188-0.54297-0.89062-0.9375-0.21875-0.39844-0.32812-0.8125-0.32812-1.25 0-0.13281 0.015625-0.32031 0.046875-0.5625l0.57812 0.09375c-0.03125 0.17969-0.046875 0.33984-0.046875 0.48438 0 0.46875 0.13281 0.87891 0.39062 1.2344 0.25 0.36328 0.55469 0.59766 0.92188 0.70312zm0.57812 0.0625c0.26953-0.011719 0.51562-0.078125 0.73438-0.20312 0.22656-0.11719 0.34375-0.24219 0.34375-0.375 0-0.11719-0.058594-0.22656-0.17188-0.32812-0.10547-0.09375-0.23438-0.14062-0.39062-0.14062s-0.29297 0.0625-0.40625 0.1875c-0.10547 0.125-0.15625 0.28125-0.15625 0.46875 0 0.15625 0.015625 0.28516 0.046875 0.39062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 1.6406v-0.1875c0-0.35547 0.09375-0.60938 0.28125-0.76562 0.1875-0.14844 0.47656-0.21875 0.875-0.21875h3.1406v0.51562h-3.125c-0.39844 0-0.59375 0.14453-0.59375 0.4375v0.21875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.96875 0.98438c1.0938 0.73828 1.6406 1.3672 1.6406 1.8906 0 0.33203-0.11719 0.60938-0.34375 0.82812-0.23047 0.21875-0.52344 0.32812-0.875 0.32812-0.42969 0-0.76562-0.19531-1.0156-0.57812-0.25-0.375-0.375-0.89062-0.375-1.5469v-1.9062h0.57812v0.46875h3.5312v0.51562zm-0.39062 0.26562v0.65625c0 0.5 0.066406 0.89062 0.20312 1.1719 0.14453 0.28906 0.34375 0.4375 0.59375 0.4375 0.1875 0 0.34375-0.0625 0.46875-0.1875 0.13281-0.125 0.20312-0.27734 0.20312-0.45312 0-0.38672-0.49219-0.92969-1.4688-1.625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.48438 2.8125c-0.25-0.60547-0.41406-1.4336-0.48438-2.4844h0.57812v0.3125c0.007813 0.16406 0.019531 0.26953 0.03125 0.3125 0.082031-0.17969 0.20312-0.32031 0.35938-0.42188 0.15625-0.10547 0.33203-0.15625 0.53125-0.15625 0.28125 0 0.51953 0.097656 0.71875 0.29688 0.20703 0.20703 0.3125 0.48438 0.3125 0.82812 0 0.66406-0.30469 1.0547-0.90625 1.1719l-0.0625-0.53125c0.26953-0.054687 0.40625-0.26562 0.40625-0.64062 0-0.19922-0.046875-0.35547-0.14062-0.46875-0.09375-0.10547-0.21875-0.15625-0.375-0.15625-0.30469 0-0.55469 0.20703-0.75 0.625 0.070313 0.46875 0.19141 0.90625 0.35938 1.3125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 4.4062v-0.1875c0-0.38672 0.11328-0.65234 0.34375-0.79688-0.23047-0.38672-0.34375-0.89062-0.34375-1.5156v-1.9062h0.57812v0.46875h3.5312v0.51562h-3.1406c1.0938 0.73828 1.6406 1.3672 1.6406 1.8906 0 0.33203-0.11719 0.60938-0.34375 0.82812-0.23047 0.21875-0.52344 0.32812-0.875 0.32812-0.24219 0-0.45312-0.0625-0.64062-0.1875-0.11719 0.0625-0.17188 0.17578-0.17188 0.34375v0.21875zm0.57812-3.1562v0.65625c0 0.5 0.066406 0.89062 0.20312 1.1719 0.14453 0.28906 0.34375 0.4375 0.59375 0.4375 0.1875 0 0.34375-0.0625 0.46875-0.1875 0.13281-0.125 0.20312-0.27734 0.20312-0.45312 0-0.38672-0.49219-0.92969-1.4688-1.625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.59375 3.1406c-0.17969-0.54297-0.32422-1.1055-0.4375-1.6875-0.10547-0.58594-0.15625-1.0703-0.15625-1.4531h0.57812c0 0.25781 0.023437 0.59766 0.078125 1.0156 0.10156-0.1875 0.25-0.33984 0.4375-0.45312 0.19531-0.10547 0.39844-0.15625 0.60938-0.15625 0.375 0 0.67578 0.11719 0.90625 0.35938 0.22656 0.23828 0.34375 0.55078 0.34375 0.9375 0 0.73828-0.32031 1.1719-0.95312 1.2969l-0.078125-0.51562c0.30078-0.074219 0.45312-0.33594 0.45312-0.78125 0-0.23047-0.0625-0.42188-0.1875-0.57812-0.11719-0.14844-0.27734-0.21875-0.48438-0.21875-0.19922 0-0.38672 0.0625-0.5625 0.1875-0.16797 0.13281-0.29297 0.3125-0.375 0.53125 0.082031 0.41406 0.21875 0.92188 0.40625 1.5156zm3.1875-1.3125v-0.51562h0.51562v0.51562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0.09375h0.4375l2.2969 1.8594c0.15625 0.125 0.29688 0.24219 0.42188 0.35938v-2h0.42188v2.5781h-0.42188l-2.4844-2.0156-0.25-0.21875v2.2969h-0.42188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 3.5781 1.375v0.51562l-3.5781 1.4688v-0.54688l1.0781-0.40625v-1.5156l-1.0781-0.39062zm1.4688 1.0312v1.2188l1-0.375c0.28906-0.11719 0.53516-0.19922 0.73438-0.25-0.23047-0.054688-0.46094-0.12109-0.6875-0.20312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0.39062h3.5781v1.6094c0 0.3125-0.03125 0.55078-0.09375 0.71875-0.0625 0.16406-0.17969 0.30078-0.34375 0.40625-0.16797 0.10156-0.34375 0.15625-0.53125 0.15625-0.26172 0-0.48047-0.085938-0.65625-0.25-0.16797-0.16797-0.27734-0.42188-0.32812-0.76562-0.0625 0.125-0.12109 0.21875-0.17188 0.28125-0.125 0.13281-0.28906 0.26562-0.48438 0.39062l-0.96875 0.625v-0.59375l0.75-0.46875c0.20703-0.14844 0.36719-0.26562 0.48438-0.35938 0.11328-0.085937 0.19141-0.16406 0.23438-0.23438 0.050781-0.074219 0.085938-0.14844 0.10938-0.21875 0.007813-0.054688 0.015625-0.14062 0.015625-0.26562v-0.54688h-1.5938zm2 0.48438v1.0156c0 0.21875 0.019531 0.39062 0.0625 0.51562 0.050781 0.125 0.125 0.21875 0.21875 0.28125s0.20312 0.09375 0.32812 0.09375c0.16406 0 0.30078-0.0625 0.40625-0.1875 0.11328-0.125 0.17188-0.32031 0.17188-0.57812v-1.1406z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0.40625h3.5781v0.46875h-1.4688v1.875h1.4688v0.48438h-3.5781v-0.48438h1.6875v-1.875h-1.6875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.75 0.25c0.59375 0 1.0547 0.15625 1.3906 0.46875 0.33203 0.32031 0.5 0.73828 0.5 1.25 0 0.33203-0.078125 0.62891-0.23438 0.89062-0.15625 0.26953-0.375 0.47266-0.65625 0.60938-0.28125 0.14453-0.60547 0.21875-0.96875 0.21875-0.36719 0-0.69531-0.074219-0.98438-0.21875-0.28125-0.14844-0.49609-0.35547-0.64062-0.625-0.14844-0.27344-0.21875-0.5625-0.21875-0.875 0-0.34375 0.078125-0.65234 0.23438-0.92188 0.16406-0.26172 0.39062-0.46094 0.67188-0.59375 0.28125-0.13672 0.58203-0.20312 0.90625-0.20312zm-0.015625 0.48438c-0.42969 0-0.76562 0.11328-1.0156 0.34375-0.25 0.23828-0.375 0.53516-0.375 0.89062 0 0.35156 0.125 0.64453 0.375 0.875 0.25 0.23828 0.60156 0.35938 1.0625 0.35938 0.28906 0 0.54688-0.054687 0.76562-0.15625 0.21875-0.09375 0.38281-0.24219 0.5-0.4375 0.125-0.1875 0.1875-0.40234 0.1875-0.64062 0-0.33594-0.11719-0.625-0.34375-0.875-0.23047-0.24219-0.61719-0.35938-1.1562-0.35938z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0.375h3.5781v0.71875l-2.5312 0.84375c-0.24219 0.082031-0.41797 0.14062-0.53125 0.17188 0.125 0.039063 0.31641 0.10938 0.57812 0.20312l2.4844 0.85938v0.64062h-3.5781v-0.46875h3l-3-1.0469v-0.42188l3.0469-1.0469h-3.0469z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0.39062h3.5781v2.6094h-0.42188v-2.125h-1.0938v1.9844h-0.42188v-1.9844h-1.2188v2.2031h-0.42188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.1562 0.21875 0.03125 0.45312c-0.17969 0.019531-0.32422 0.066406-0.4375 0.14062-0.11719 0.082031-0.21094 0.20703-0.28125 0.375-0.074219 0.16406-0.10938 0.34766-0.10938 0.54688 0 0.1875 0.023437 0.34766 0.078125 0.48438 0.0625 0.13281 0.14062 0.23828 0.23438 0.3125 0.09375 0.070312 0.19141 0.10938 0.29688 0.10938 0.11328 0 0.21094-0.039063 0.29688-0.10938 0.082031-0.0625 0.15625-0.16797 0.21875-0.3125 0.03125-0.10547 0.082031-0.32422 0.15625-0.65625 0.082031-0.32422 0.16016-0.55469 0.23438-0.6875 0.09375-0.17969 0.20312-0.30859 0.32812-0.39062 0.13281-0.085937 0.28516-0.125 0.45312-0.125 0.17578 0 0.34375 0.050781 0.5 0.15625 0.15625 0.10156 0.27344 0.25391 0.35938 0.45312 0.082031 0.19531 0.125 0.41406 0.125 0.65625 0 0.26953-0.042969 0.50391-0.125 0.70312-0.085937 0.20703-0.21094 0.36328-0.375 0.46875-0.16797 0.11328-0.35547 0.17578-0.5625 0.1875l-0.046875-0.45312c0.22656-0.03125 0.39844-0.12109 0.51562-0.26562 0.11328-0.13672 0.17188-0.33984 0.17188-0.60938 0-0.29297-0.054688-0.50781-0.15625-0.64062-0.10547-0.125-0.23047-0.1875-0.375-0.1875-0.125 0-0.23047 0.046875-0.3125 0.14062-0.085938 0.082031-0.17188 0.31641-0.26562 0.70312-0.085937 0.39453-0.15625 0.66406-0.21875 0.8125-0.10547 0.20703-0.23047 0.35938-0.375 0.45312-0.14844 0.10156-0.3125 0.15625-0.5 0.15625-0.19922 0-0.38281-0.058594-0.54688-0.17188-0.16797-0.10547-0.29688-0.26172-0.39062-0.46875-0.09375-0.21094-0.14062-0.4375-0.14062-0.6875 0-0.33594 0.046875-0.60938 0.14062-0.82812s0.23438-0.39062 0.42188-0.51562c0.19531-0.125 0.41406-0.19531 0.65625-0.20312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0.39062h3.5781v1.3594c0 0.23828-0.011719 0.42188-0.03125 0.54688-0.03125 0.17578-0.089844 0.32031-0.17188 0.4375-0.085938 0.125-0.19922 0.22266-0.34375 0.29688-0.14844 0.070312-0.30859 0.10938-0.48438 0.10938-0.30469 0-0.5625-0.10156-0.78125-0.29688-0.21094-0.19922-0.3125-0.55469-0.3125-1.0625v-0.92188h-1.4531zm1.875 0.46875v0.9375c0 0.30078 0.054688 0.51562 0.17188 0.64062 0.11328 0.13281 0.27344 0.20312 0.48438 0.20312 0.14453 0 0.26953-0.039063 0.375-0.10938 0.11328-0.074219 0.1875-0.17188 0.21875-0.29688 0.019531-0.085937 0.03125-0.23438 0.03125-0.45312v-0.92188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0.39062h3.5781v0.48438l-2.8125 1.8906h2.8125v0.45312h-3.5781v-0.48438l2.8125-1.8906h-2.8125zm3.7969 0.67188c0.17578 0 0.3125 0.046875 0.40625 0.14062 0.10156 0.09375 0.15625 0.21094 0.15625 0.35938 0 0.10156-0.042969 0.24219-0.125 0.42188-0.054687 0.09375-0.078125 0.16406-0.078125 0.21875 0 0.050781 0.00781 0.09375 0.03125 0.125 0.03125 0.03125 0.09375 0.050781 0.1875 0.0625v0.3125c-0.1875 0-0.32812-0.046875-0.42188-0.14062-0.09375-0.085938-0.14062-0.19922-0.14062-0.34375 0-0.09375 0.046875-0.23047 0.14062-0.40625 0.050781-0.10547 0.078125-0.18359 0.078125-0.23438 0-0.054687-0.015625-0.10156-0.046875-0.14062-0.042969-0.03125-0.10547-0.046875-0.1875-0.046875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0.45312h0.5v0.5h-0.5c-0.1875 0-0.33203-0.039063-0.4375-0.10938-0.11328-0.0625-0.20312-0.16406-0.26562-0.29688l0.1875-0.125c0.042969 0.09375 0.10547 0.16016 0.1875 0.20312 0.074219 0.039062 0.18359 0.066406 0.32812 0.078125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0.45312h0.5v0.5h-0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 1.4219 3.5781-1.4062v0.51562l-2.5938 0.9375c-0.21094 0.082031-0.40625 0.14453-0.59375 0.1875 0.19531 0.0625 0.39453 0.12891 0.59375 0.20312l2.5938 0.96875v0.48438l-3.5781-1.4062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0.39062h3.5781v1.2344c0 0.28125-0.015625 0.49219-0.046875 0.64062-0.054688 0.20703-0.14062 0.38281-0.26562 0.53125-0.15625 0.1875-0.35938 0.32812-0.60938 0.42188s-0.53125 0.14062-0.84375 0.14062c-0.27344 0-0.51562-0.03125-0.73438-0.09375-0.21094-0.0625-0.38281-0.14844-0.51562-0.25-0.13672-0.09375-0.24609-0.20312-0.32812-0.32812-0.074219-0.11719-0.13281-0.25781-0.17188-0.42188-0.042969-0.16797-0.0625-0.35938-0.0625-0.57812zm0.42188 0.46875v0.78125c0 0.22656 0.019531 0.41016 0.0625 0.54688 0.039063 0.13281 0.10156 0.24219 0.1875 0.32812 0.11328 0.11328 0.26562 0.20312 0.45312 0.26562s0.41406 0.09375 0.6875 0.09375c0.375 0 0.66016-0.0625 0.85938-0.1875 0.20703-0.125 0.34375-0.27734 0.40625-0.45312 0.050781-0.125 0.078125-0.32812 0.078125-0.60938v-0.76562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0.46875h3.5781v0.48438h-3.5781z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.5781 2.75v0.48438h-2.0625c-0.36719 0-0.65234-0.042969-0.85938-0.125-0.21094-0.085937-0.38281-0.23438-0.51562-0.45312-0.13672-0.21094-0.20312-0.48438-0.20312-0.82812s0.058594-0.625 0.17188-0.84375c0.11328-0.21094 0.28125-0.35938 0.5-0.45312s0.51953-0.14062 0.90625-0.14062h2.0625v0.48438h-2.0625c-0.3125 0-0.54297 0.023438-0.6875 0.078125-0.14844 0.0625-0.26172 0.16016-0.34375 0.29688-0.085937 0.14453-0.125 0.32031-0.125 0.53125 0 0.34375 0.078125 0.58594 0.23438 0.73438 0.16406 0.15625 0.47266 0.23438 0.92188 0.23438z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 1.2969h3.1562v-1.1719h0.42188v2.8438h-0.42188v-1.1875h-3.1562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.25 2.9531-0.10938 0.48438c-0.39844-0.10547-0.69922-0.28906-0.90625-0.54688-0.19922-0.26172-0.29688-0.57812-0.29688-0.95312 0-0.38672 0.078125-0.70312 0.23438-0.95312 0.15625-0.24219 0.37891-0.42188 0.67188-0.54688 0.30078-0.125 0.625-0.1875 0.96875-0.1875 0.375 0 0.69531 0.070312 0.96875 0.21875 0.28125 0.14453 0.49219 0.34766 0.64062 0.60938 0.14453 0.25781 0.21875 0.55078 0.21875 0.875 0 0.35156-0.09375 0.65625-0.28125 0.90625-0.17969 0.25-0.43359 0.42188-0.76562 0.51562l-0.10938-0.46875c0.25781-0.085938 0.44531-0.21094 0.5625-0.375 0.125-0.15625 0.1875-0.35547 0.1875-0.59375 0-0.27344-0.070313-0.5-0.20312-0.6875-0.125-0.1875-0.30469-0.32422-0.53125-0.40625-0.21875-0.074219-0.44922-0.10938-0.6875-0.10938-0.30469 0-0.57031 0.046875-0.79688 0.14062-0.21875 0.09375-0.38672 0.23438-0.5 0.42188-0.11719 0.1875-0.17188 0.39062-0.17188 0.60938 0 0.25781 0.070312 0.48438 0.21875 0.67188 0.15625 0.1875 0.38281 0.3125 0.6875 0.375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.75 0.25c0.59375 0 1.0547 0.15625 1.3906 0.46875 0.33203 0.32031 0.5 0.73828 0.5 1.25 0 0.33203-0.078125 0.62891-0.23438 0.89062-0.15625 0.26953-0.375 0.47266-0.65625 0.60938-0.28125 0.14453-0.60547 0.21875-0.96875 0.21875-0.36719 0-0.69531-0.074219-0.98438-0.21875-0.28125-0.14844-0.49609-0.35547-0.64062-0.625-0.14844-0.27344-0.21875-0.5625-0.21875-0.875 0-0.34375 0.078125-0.65234 0.23438-0.92188 0.16406-0.26172 0.39062-0.46094 0.67188-0.59375 0.28125-0.13672 0.58203-0.20312 0.90625-0.20312zm-0.015625 0.48438c-0.42969 0-0.76562 0.11328-1.0156 0.34375-0.25 0.23828-0.375 0.53516-0.375 0.89062 0 0.35156 0.125 0.64453 0.375 0.875 0.25 0.23828 0.60156 0.35938 1.0625 0.35938 0.28906 0 0.54688-0.054687 0.76562-0.15625 0.21875-0.09375 0.38281-0.24219 0.5-0.4375 0.125-0.1875 0.1875-0.40234 0.1875-0.64062 0-0.33594-0.11719-0.625-0.34375-0.875-0.23047-0.24219-0.61719-0.35938-1.1562-0.35938zm2.0781 0.9375 0.67188 0.32812v0.57812l-0.67188-0.54688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0.39062h3.5781v0.48438l-2.8125 1.8906h2.8125v0.45312h-3.5781v-0.48438l2.8125-1.8906h-2.8125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0.015625 1.8594 1.4062 1.7188-1.2344v0.5625l-0.92188 0.65625c-0.1875 0.13281-0.33594 0.23438-0.4375 0.29688 0.13281 0.070313 0.26953 0.16406 0.40625 0.28125l0.95312 0.71875v0.51562l-1.6875-1.2656-1.8906 1.375v-0.59375l1.2812-0.90625c0.070312-0.054687 0.14844-0.10547 0.23438-0.15625-0.125-0.085937-0.21484-0.14062-0.26562-0.17188l-1.25-0.90625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0.40625h3.5781v2.4375h-0.42188v-1.9531h-1.1094v1.6875h-0.42188v-1.6875h-1.625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.0781 0.15625h0.4375v1.3594h-0.4375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 1.875v-0.4375h2.7969c-0.09375-0.11719-0.19531-0.26172-0.29688-0.4375-0.10547-0.16797-0.18359-0.32031-0.23438-0.45312h0.4375c0.11328 0.25 0.25 0.46094 0.40625 0.64062 0.16406 0.1875 0.32812 0.32031 0.48438 0.40625v0.28125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.9375 0.20312 0.046875 0.46875c-0.23047 0.03125-0.40234 0.10938-0.51562 0.23438-0.11719 0.125-0.17188 0.27344-0.17188 0.45312 0 0.21875 0.078125 0.39844 0.23438 0.54688 0.16406 0.14453 0.37891 0.21875 0.64062 0.21875 0.25 0 0.44531-0.074219 0.59375-0.21875 0.14453-0.13672 0.21875-0.32031 0.21875-0.54688 0-0.14844-0.03125-0.27734-0.09375-0.39062-0.0625-0.11719-0.14844-0.20312-0.25-0.26562l0.046875-0.42188 1.8438 0.35938v1.7812h-0.42188v-1.4375l-0.95312-0.1875c0.14453 0.21875 0.21875 0.44141 0.21875 0.67188 0 0.32031-0.10938 0.58594-0.32812 0.79688-0.21875 0.21875-0.49609 0.32812-0.82812 0.32812-0.32422 0-0.60547-0.09375-0.84375-0.28125-0.29297-0.23047-0.4375-0.54688-0.4375-0.95312 0-0.32422 0.085938-0.58984 0.26562-0.79688 0.1875-0.21094 0.42969-0.32812 0.73438-0.35938z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.9375 0.21875 0.0625 0.4375c-0.25 0.050781-0.43359 0.13281-0.54688 0.25-0.10547 0.125-0.15625 0.27344-0.15625 0.45312 0 0.20703 0.070313 0.37891 0.21875 0.51562 0.14453 0.14453 0.32031 0.21875 0.53125 0.21875 0.19531 0 0.36328-0.070312 0.5-0.20312 0.13281-0.125 0.20312-0.29297 0.20312-0.5 0-0.085937-0.023438-0.1875-0.0625-0.3125l0.39062 0.046875v0.078125c0 0.1875 0.046875 0.35156 0.14062 0.5 0.10156 0.15625 0.25391 0.23438 0.45312 0.23438 0.16406 0 0.30078-0.058594 0.40625-0.17188 0.10156-0.10547 0.15625-0.24609 0.15625-0.42188 0-0.16797-0.058594-0.30859-0.17188-0.42188-0.10547-0.11719-0.26172-0.1875-0.46875-0.21875l0.078125-0.45312c0.28906 0.0625 0.51562 0.1875 0.67188 0.375 0.16406 0.1875 0.25 0.42578 0.25 0.71875 0 0.19531-0.042969 0.375-0.125 0.53125-0.085938 0.16406-0.19922 0.28906-0.34375 0.375-0.14844 0.09375-0.30469 0.14062-0.46875 0.14062-0.14844 0-0.28906-0.042969-0.42188-0.125-0.125-0.085937-0.22656-0.21094-0.29688-0.375-0.054688 0.21875-0.15625 0.38281-0.3125 0.5-0.14844 0.11328-0.33594 0.17188-0.5625 0.17188-0.3125 0-0.57812-0.11719-0.79688-0.34375-0.21875-0.23047-0.32812-0.51562-0.32812-0.85938 0-0.32422 0.09375-0.58984 0.28125-0.79688 0.1875-0.21094 0.42578-0.32422 0.71875-0.34375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 1.625h0.85938v-1.5625h0.40625l2.3125 1.6406v0.35938h-2.3125v0.5h-0.40625v-0.5h-0.85938zm1.2656 0h1.6094l-1.6094-1.125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.7656 0.20312c0.42578 0 0.76562 0.039063 1.0156 0.125 0.25781 0.09375 0.45703 0.22266 0.59375 0.39062 0.14453 0.17578 0.21875 0.39844 0.21875 0.67188 0 0.1875-0.042969 0.35156-0.125 0.5-0.074219 0.14453-0.18359 0.26562-0.32812 0.35938-0.14844 0.09375-0.32422 0.16406-0.53125 0.21875-0.21094 0.0625-0.49219 0.09375-0.84375 0.09375-0.41797 0-0.75781-0.046875-1.0156-0.14062-0.26172-0.085937-0.46484-0.21484-0.60938-0.39062-0.13672-0.16797-0.20312-0.38281-0.20312-0.64062 0-0.35547 0.125-0.63281 0.375-0.82812 0.28906-0.24219 0.77344-0.35938 1.4531-0.35938zm0 0.45312c-0.58594 0-0.97656 0.066406-1.1719 0.20312-0.19922 0.14453-0.29688 0.32031-0.29688 0.53125 0 0.19531 0.097656 0.36328 0.29688 0.5 0.19531 0.14453 0.58594 0.21875 1.1719 0.21875 0.59375 0 0.98438-0.074219 1.1719-0.21875 0.19531-0.13672 0.29688-0.30859 0.29688-0.51562 0-0.19922-0.089844-0.35938-0.26562-0.48438-0.21875-0.15625-0.62109-0.23438-1.2031-0.23438z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.7031 2.5-0.03125-0.4375c0.16406-0.042969 0.28906-0.10156 0.375-0.17188 0.125-0.11719 0.1875-0.26172 0.1875-0.4375 0-0.13672-0.042969-0.26172-0.125-0.375-0.09375-0.13672-0.24219-0.24609-0.4375-0.32812-0.1875-0.074219-0.46484-0.11719-0.82812-0.125 0.16406 0.10156 0.28516 0.23438 0.35938 0.39062 0.082031 0.15625 0.125 0.31641 0.125 0.48438 0 0.30078-0.10938 0.55078-0.32812 0.75-0.21875 0.20703-0.5 0.3125-0.84375 0.3125-0.21875 0-0.42969-0.046875-0.625-0.14062-0.1875-0.09375-0.33594-0.23047-0.4375-0.40625-0.10156-0.16797-0.15625-0.35938-0.15625-0.57812 0-0.36719 0.13281-0.66797 0.40625-0.90625 0.26953-0.23047 0.71094-0.34375 1.3281-0.34375 0.69531 0 1.2031 0.12891 1.5156 0.39062 0.26953 0.21875 0.40625 0.51953 0.40625 0.90625 0 0.28125-0.078125 0.50781-0.23438 0.6875-0.15625 0.1875-0.375 0.29688-0.65625 0.32812zm-1.5469-1.7969c-0.14844 0-0.29297 0.03125-0.4375 0.09375-0.13672 0.0625-0.24219 0.14844-0.3125 0.26562-0.074219 0.11328-0.10938 0.23828-0.10938 0.375 0 0.1875 0.070313 0.34375 0.21875 0.46875 0.15625 0.13281 0.36328 0.20312 0.625 0.20312 0.23828 0 0.42969-0.070313 0.57812-0.20312 0.14453-0.125 0.21875-0.28906 0.21875-0.48438 0-0.21094-0.074219-0.38281-0.21875-0.51562-0.14844-0.13672-0.33594-0.20312-0.5625-0.20312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0.375h3.5781v0.46875h-3.1562v1.7812h-0.42188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.4062 2.0781h0.42188v1.5156h-1.3281c-0.1875-0.23047-0.32812-0.46875-0.42188-0.71875s-0.14062-0.50781-0.14062-0.76562c0-0.35547 0.070312-0.67969 0.21875-0.96875 0.15625-0.29297 0.375-0.51172 0.65625-0.65625 0.28906-0.14844 0.60938-0.21875 0.95312-0.21875 0.35156 0 0.67969 0.070313 0.98438 0.21875 0.30078 0.14453 0.52344 0.35156 0.67188 0.625 0.14453 0.28125 0.21875 0.60156 0.21875 0.96875 0 0.25781-0.042969 0.49219-0.125 0.70312-0.085937 0.20703-0.20312 0.36719-0.35938 0.48438-0.14844 0.125-0.33984 0.21875-0.57812 0.28125l-0.10938-0.4375c0.17578-0.054687 0.31641-0.12109 0.42188-0.20312 0.10156-0.074219 0.1875-0.1875 0.25-0.34375 0.0625-0.14844 0.09375-0.30859 0.09375-0.48438 0-0.21875-0.039063-0.41406-0.10938-0.57812-0.0625-0.15625-0.14844-0.28125-0.25-0.375-0.10547-0.09375-0.22656-0.17188-0.35938-0.23438-0.21875-0.085937-0.46094-0.125-0.71875-0.125-0.3125 0-0.57812 0.050781-0.79688 0.15625-0.21875 0.11328-0.38281 0.27344-0.48438 0.48438-0.10547 0.20703-0.15625 0.42969-0.15625 0.67188 0 0.20703 0.039063 0.41016 0.125 0.60938 0.082031 0.19531 0.16406 0.34375 0.25 0.4375h0.67188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0.375h3.5781v1.3438c0 0.26953-0.039063 0.48828-0.10938 0.65625-0.074219 0.16406-0.1875 0.29688-0.34375 0.39062-0.14844 0.09375-0.30469 0.14062-0.46875 0.14062-0.14844 0-0.28906-0.042969-0.42188-0.125-0.13672-0.085938-0.24609-0.21094-0.32812-0.375-0.0625 0.21875-0.17188 0.38281-0.32812 0.5-0.15625 0.125-0.33984 0.1875-0.54688 0.1875-0.16797 0-0.32422-0.039062-0.46875-0.10938-0.13672-0.074219-0.24609-0.16406-0.32812-0.26562-0.074219-0.10547-0.13281-0.24219-0.17188-0.40625-0.042969-0.15625-0.0625-0.35156-0.0625-0.57812zm2.0781 0.46875v0.78125c0 0.20703 0.00781 0.35938 0.03125 0.45312 0.039063 0.125 0.10156 0.21094 0.1875 0.26562 0.082031 0.0625 0.1875 0.09375 0.3125 0.09375 0.11328 0 0.21875-0.03125 0.3125-0.09375 0.09375-0.054688 0.15625-0.13281 0.1875-0.23438 0.03125-0.10547 0.046875-0.28906 0.046875-0.54688v-0.71875zm-1.6562 0v0.89062c0 0.15625 0.003906 0.26562 0.015625 0.32812 0.019531 0.11328 0.050781 0.20703 0.09375 0.28125 0.050781 0.070312 0.11719 0.12891 0.20312 0.17188 0.082031 0.050781 0.17969 0.078125 0.29688 0.078125 0.13281 0 0.25-0.039062 0.34375-0.10938 0.10156-0.0625 0.17578-0.15625 0.21875-0.28125 0.039062-0.125 0.0625-0.30469 0.0625-0.53125v-0.82812z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.0156 0.14062 0.0625 0.4375c-0.27344 0.007813-0.46094 0.0625-0.5625 0.15625-0.10547 0.09375-0.15625 0.21875-0.15625 0.375 0 0.125 0.023437 0.22656 0.078125 0.3125 0.0625 0.082031 0.14062 0.14062 0.23438 0.17188s0.23828 0.046875 0.4375 0.046875h2.4688v0.48438h-2.4375c-0.30469 0-0.53906-0.039062-0.70312-0.10938-0.15625-0.074219-0.28125-0.1875-0.375-0.34375-0.082031-0.15625-0.125-0.34375-0.125-0.5625 0-0.3125 0.085938-0.55469 0.26562-0.71875 0.1875-0.16797 0.45703-0.25 0.8125-0.25z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.0938 0.45312h0.5v0.5h-0.5zm-2.0938 0h0.5v0.5h-0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9375 0.89062c0.070312-0.1875 0.16406-0.32812 0.28125-0.42188 0.125-0.085938 0.27344-0.125 0.45312-0.125 0.25781 0 0.47656 0.09375 0.65625 0.28125 0.17578 0.1875 0.26562 0.44141 0.26562 0.76562 0 0.3125-0.09375 0.5625-0.28125 0.75-0.17969 0.1875-0.39844 0.28125-0.65625 0.28125-0.16797 0-0.3125-0.042969-0.4375-0.125-0.11719-0.085937-0.21094-0.21484-0.28125-0.39062-0.074219 0.21875-0.1875 0.38281-0.34375 0.5-0.15625 0.11328-0.35156 0.17188-0.57812 0.17188-0.30469 0-0.55859-0.10938-0.76562-0.32812-0.21094-0.21875-0.3125-0.50781-0.3125-0.85938 0-0.35547 0.10156-0.64062 0.3125-0.85938 0.20703-0.21875 0.46875-0.32812 0.78125-0.32812 0.23828 0 0.4375 0.054687 0.59375 0.17188 0.15625 0.125 0.25781 0.29688 0.3125 0.51562zm0.75-0.09375c-0.16797 0-0.30859 0.050781-0.42188 0.15625-0.10547 0.11328-0.15625 0.25781-0.15625 0.4375 0 0.16406 0.050781 0.30078 0.15625 0.40625 0.10156 0.11328 0.23438 0.17188 0.39062 0.17188 0.16406 0 0.30078-0.058594 0.40625-0.17188 0.11328-0.10547 0.17188-0.24219 0.17188-0.40625 0-0.16797-0.058594-0.30859-0.17188-0.42188-0.10547-0.11719-0.23047-0.17188-0.375-0.17188zm-1.6562-0.14062c-0.125 0-0.24609 0.03125-0.35938 0.09375-0.11719 0.0625-0.21094 0.14844-0.28125 0.26562-0.0625 0.11328-0.09375 0.23828-0.09375 0.375 0 0.21875 0.066406 0.39453 0.20312 0.53125 0.13281 0.13281 0.30469 0.20312 0.51562 0.20312 0.20703 0 0.37891-0.074219 0.51562-0.21875 0.14453-0.13672 0.21875-0.3125 0.21875-0.53125 0-0.21094-0.070312-0.38281-0.20312-0.51562-0.13672-0.13672-0.30859-0.20312-0.51562-0.20312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.0625 0 3.7031 1.0469v0.34375l-3.7031-1.0312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.82812 0.28125 0.03125 0.42188c-0.19922 0.03125-0.34375 0.097656-0.4375 0.20312-0.085937 0.10156-0.125 0.23438-0.125 0.39062 0 0.13281 0.03125 0.25391 0.09375 0.35938 0.0625 0.10156 0.14453 0.1875 0.25 0.25 0.10156 0.0625 0.24219 0.11328 0.42188 0.15625 0.17578 0.050781 0.35156 0.078125 0.53125 0.078125h0.09375c-0.14844-0.09375-0.26172-0.21875-0.34375-0.375-0.085938-0.14844-0.125-0.30859-0.125-0.48438 0-0.30469 0.10156-0.55859 0.3125-0.76562 0.21875-0.21094 0.50391-0.3125 0.85938-0.3125 0.36328 0 0.65625 0.10938 0.875 0.32812s0.32812 0.48828 0.32812 0.8125c0 0.22656-0.0625 0.44141-0.1875 0.64062-0.125 0.19531-0.30859 0.34375-0.54688 0.4375-0.23047 0.10156-0.5625 0.15625-1 0.15625-0.46094 0-0.82422-0.054687-1.0938-0.15625-0.27344-0.09375-0.48047-0.24219-0.625-0.4375-0.13672-0.19922-0.20312-0.43359-0.20312-0.70312 0-0.28125 0.078125-0.51172 0.23438-0.6875 0.15625-0.17969 0.375-0.28125 0.65625-0.3125zm1.5781 1.7969c0.25 0 0.44531-0.070313 0.59375-0.20312 0.15625-0.125 0.23438-0.28906 0.23438-0.48438 0-0.19922-0.085937-0.37109-0.25-0.51562-0.15625-0.14844-0.35938-0.21875-0.60938-0.21875-0.23047 0-0.41797 0.066406-0.5625 0.20312-0.13672 0.14453-0.20312 0.32031-0.20312 0.53125 0 0.19531 0.066406 0.35938 0.20312 0.48438 0.14453 0.13281 0.34375 0.20312 0.59375 0.20312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.1094 0.23438h0.42188v2.3281h-0.34375c-0.24219-0.23047-0.5625-0.46094-0.96875-0.6875-0.39844-0.21875-0.80859-0.39062-1.2344-0.51562-0.30469-0.085937-0.63281-0.13672-0.98438-0.15625v-0.46875c0.28125 0.007813 0.61719 0.066406 1.0156 0.17188 0.40625 0.10156 0.78906 0.25391 1.1562 0.45312 0.375 0.20703 0.6875 0.42188 0.9375 0.64062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.42188 2.5312h-0.42188v-2.375c0.10156-0.011719 0.20703 0.003906 0.3125 0.046875 0.15625 0.0625 0.3125 0.15625 0.46875 0.28125 0.15625 0.13281 0.33594 0.33203 0.54688 0.59375 0.3125 0.38281 0.5625 0.64453 0.75 0.78125 0.1875 0.14453 0.36328 0.21875 0.53125 0.21875 0.17578 0 0.32031-0.0625 0.4375-0.1875 0.125-0.125 0.1875-0.29297 0.1875-0.5 0-0.21094-0.070313-0.38281-0.20312-0.51562-0.125-0.125-0.29688-0.1875-0.51562-0.1875l0.046875-0.45312c0.33203 0.03125 0.58594 0.14453 0.76562 0.34375 0.17578 0.20703 0.26562 0.48438 0.26562 0.82812s-0.10156 0.61328-0.29688 0.8125c-0.1875 0.20703-0.42188 0.3125-0.70312 0.3125-0.13672 0-0.27734-0.03125-0.42188-0.09375-0.13672-0.0625-0.28125-0.16406-0.4375-0.29688-0.14844-0.13672-0.35547-0.35938-0.625-0.67188-0.21875-0.27344-0.37109-0.44531-0.45312-0.51562-0.074219-0.074219-0.15234-0.13672-0.23438-0.1875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.0469 1.1719c0.30469-0.24219 0.65625-0.44922 1.0625-0.625 0.41406-0.16797 0.84375-0.25 1.2812-0.25 0.38281 0 0.75391 0.066406 1.1094 0.20312 0.41406 0.14453 0.82812 0.36719 1.2344 0.67188v0.32812c-0.34375-0.19922-0.58594-0.33594-0.71875-0.40625-0.23047-0.09375-0.46484-0.17188-0.70312-0.23438-0.3125-0.0625-0.62109-0.09375-0.92188-0.09375-0.78125 0-1.5625 0.24219-2.3438 0.73438z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.0469 0.625v-0.32812c0.78125 0.5 1.5625 0.75 2.3438 0.75 0.30078 0 0.60156-0.039063 0.90625-0.10938 0.25-0.0625 0.48438-0.14062 0.70312-0.23438 0.14453-0.0625 0.39062-0.19922 0.73438-0.40625v0.32812c-0.40625 0.30078-0.82031 0.52344-1.2344 0.67188-0.35547 0.13281-0.72656 0.20312-1.1094 0.20312-0.4375 0-0.86719-0.089844-1.2812-0.26562-0.40625-0.16797-0.75781-0.37109-1.0625-0.60938z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.0625 0.25 1.0469 0.21875v-0.42188h0.35938v0.5l0.89062 0.17188v-0.67188h0.35938v0.75l1.0469 0.21875v0.35938l-1.0469-0.20312v0.76562l1.0469 0.21875v0.35938l-1.0469-0.20312v0.42188h-0.35938v-0.5l-0.89062-0.1875v0.6875h-0.35938v-0.75l-1.0469-0.21875v-0.375l1.0469 0.21875v-0.78125l-1.0469-0.20312zm1.4062 0.65625v0.78125l0.89062 0.17188v-0.76562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.39062 1.2969-0.39062 0.0625c-0.019531-0.125-0.03125-0.23438-0.03125-0.32812 0-0.16797 0.027344-0.29688 0.078125-0.39062 0.050781-0.085937 0.11328-0.14844 0.1875-0.1875 0.082031-0.03125 0.25781-0.046875 0.53125-0.046875h1.4844v-0.3125h0.34375v0.3125h0.64062l0.26562 0.45312h-0.90625v0.4375h-0.34375v-0.4375h-1.5156c-0.125 0-0.21094 0.003906-0.25 0.015625-0.03125 0.019531-0.058594 0.046875-0.078125 0.078125-0.023438 0.03125-0.03125 0.082031-0.03125 0.15625 0 0.039063 0.003906 0.10156 0.015625 0.1875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.82812 2.125-0.046875 0.45312c-0.27344-0.074219-0.48047-0.21094-0.625-0.40625-0.14844-0.19922-0.21875-0.44922-0.21875-0.75 0-0.375 0.11328-0.67969 0.34375-0.90625 0.23828-0.21875 0.57031-0.32812 1-0.32812 0.42578 0 0.75781 0.10938 1 0.32812 0.25 0.22656 0.375 0.52344 0.375 0.89062 0 0.34375-0.12109 0.625-0.35938 0.84375-0.24219 0.22656-0.57422 0.34375-1 0.34375h-0.10938v-1.9531c-0.29297 0.019531-0.51562 0.10156-0.67188 0.25-0.14844 0.14453-0.21875 0.32812-0.21875 0.54688 0 0.15625 0.039063 0.28906 0.125 0.40625 0.09375 0.11328 0.22656 0.20703 0.40625 0.28125zm0.71875-1.4531v1.4531c0.21875-0.023438 0.37891-0.078125 0.48438-0.17188 0.17578-0.13672 0.26562-0.32031 0.26562-0.54688 0-0.19922-0.070313-0.37109-0.20312-0.51562-0.13672-0.13672-0.32031-0.21094-0.54688-0.21875zm1.375 0.46875 0.67188 0.32812v0.57812l-0.67188-0.54688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-45"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 1.0156 3.5781-0.95312v0.48438l-2.3438 0.54688c-0.25 0.0625-0.49609 0.11328-0.73438 0.15625 0.38281 0.09375 0.60156 0.14453 0.65625 0.15625l2.4219 0.6875v0.57812l-1.8125 0.51562c-0.44922 0.13281-0.87109 0.22656-1.2656 0.28125 0.22656 0.039062 0.48828 0.097656 0.78125 0.17188l2.2969 0.57812v0.46875l-3.5781-0.98438v-0.45312l2.7344-0.76562c0.21875-0.0625 0.35156-0.10156 0.40625-0.10938-0.15625-0.042969-0.29297-0.078125-0.40625-0.10938l-2.7344-0.76562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.2188 4.8594v-0.3125c-0.45312-0.5-1.2812-0.95312-2.3125-0.95312s-1.875 0.45312-2.3281 0.95312v0.3125h0.015625c0.45312-0.53125 1.2656-1 2.3125-1 1 0 1.8438 0.45312 2.2969 1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.8125 1.3125v0.64062h0.3125v-0.64062h1c0.015625 0.0625 0.046875 0.09375 0.0625 0.09375l0.03125-0.42188h-1.0938v-0.75h-0.3125v0.71875c-0.71875-0.17188-1.5312-0.5-1.9688-0.82812-0.078125 0.0625-0.20312 0.14062-0.29688 0.1875 0.34375 0.25 0.92188 0.5 1.5 0.67188h-2.4688v0.32812h2.4219c-0.26562 0.17188-0.625 0.39062-0.79688 0.46875l0.26562 0.20312c0.14062-0.09375 0.73438-0.51562 0.9375-0.67188zm-0.71875 3.5v-1.25h0.90625v1.1094h0.3125v-1.1094h0.8125c0.015625 0.0625 0.03125 0.09375 0.0625 0.10938l0.03125-0.4375h-0.90625v-0.60938c0.21875 0.0625 0.42188 0.10938 0.59375 0.14062 0 0.046875 0.015625 0.09375 0.046875 0.09375l0.09375-0.40625c-0.51562-0.078125-1.2031-0.25-1.6406-0.51562-0.03125 0.09375-0.09375 0.20312-0.14062 0.28125 0.20312 0.125 0.46875 0.21875 0.73438 0.3125v0.70312h-0.90625v-1.3125h-0.3125v1.1562c-0.625-0.32812-1.25-0.85938-1.5781-1.3594-0.046875 0.09375-0.17188 0.1875-0.25 0.25 0.34375 0.45312 0.92188 0.9375 1.5469 1.2656h-1.9219v0.32812h1.9688c-0.59375 0.3125-1.1719 0.75-1.5 1.125 0.078125 0.0625 0.20312 0.1875 0.26562 0.26562 0.29688-0.42188 0.90625-0.90625 1.4688-1.2188v1.0781z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.42188 0.17188v0.3125c0.45312 0.5 1.2969 0.95312 2.3281 0.95312s1.8594-0.45312 2.3125-0.95312v-0.3125h-0.015625c-0.4375 0.53125-1.2656 1-2.2969 1-1.0156 0-1.8438-0.45312-2.3125-1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.1875 4.0156c-0.17188 0.20312-0.5 0.48438-0.71875 0.64062l0.14062 0.1875c0.23438-0.15625 0.54688-0.4375 0.71875-0.64062zm-0.29688-0.70312c-0.1875 0.20312-0.51562 0.5-0.73438 0.64062l0.15625 0.1875c0.23438-0.15625 0.54688-0.4375 0.71875-0.64062zm-0.3125-2.3281c-0.125 0.45312-0.32812 0.98438-0.51562 1.3438l0.3125 0.15625c0.17188-0.34375 0.375-0.89062 0.48438-1.3438zm-3.7812 0.1875c0.015625 0.046875 0.078125 0.078125 0.125 0.0625 0.53125 1.5156 1.4688 2.7031 2.9375 3.3906 0.0625-0.09375 0.17188-0.23438 0.23438-0.3125-1.5-0.67188-2.375-1.8125-2.9062-3.4219zm2.5156-0.73438c-0.09375 0.4375-0.29688 1.0156-0.45312 1.3594l0.3125 0.14062c0.15625-0.32812 0.35938-0.89062 0.45312-1.3438z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.5625 3.9375-0.03125-0.03125-0.34375-1.6562 0.90625-0.20312c0.03125 0.078125 0.0625 0.09375 0.09375 0.09375l-0.03125-0.42188-1.0469 0.23438-0.25-1.1562-0.28125 0.0625 0.25 1.1406-2.125 0.46875 0.0625 0.29688 2.1406-0.46875 0.29688 1.4219c-0.32812-0.14062-0.79688-0.46875-1.0625-0.76562-0.046875 0.078125-0.10938 0.20312-0.17188 0.25 0.375 0.375 0.875 0.71875 1.3906 0.90625 0 0.03125 0.015625 0.046875 0.03125 0.0625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.7344 3.7969c-0.29688 0-0.5625 0.25-0.5625 0.5625s0.26562 0.5625 0.5625 0.5625c0.3125 0 0.5625-0.25 0.5625-0.5625 0-0.29688-0.23438-0.5625-0.5625-0.5625zm-0.39062 0.5625c0-0.21875 0.17188-0.40625 0.39062-0.40625s0.40625 0.1875 0.40625 0.40625-0.1875 0.39062-0.40625 0.39062c-0.20312 0-0.39062-0.17188-0.39062-0.39062zm-3.1562 0.4375c0.9375-0.26562 2.3438-0.85938 3.2344-1.3906l-0.15625-0.32812c-0.92188 0.53125-2.3438 1.1094-3.2188 1.3438zm3.2188-3.4062c-1.25-0.17188-2.5312-0.60938-3.2031-1.1719-0.046875 0.10938-0.10938 0.25-0.1875 0.32812 0.75 0.59375 2.0156 1.0156 3.2031 1.2188 0.015625 0.078125 0.046875 0.10938 0.078125 0.125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.375 0.625c-0.17188 0.5-0.4375 1.0938-0.6875 1.4688l0.3125 0.1875c0.25-0.375 0.51562-0.98438 0.67188-1.5zm-3.5625 0.40625c0.03125 0.03125 0.078125 0.0625 0.125 0.078125 0.5625 1.7031 1.625 2.9219 3 3.5469 0.046875-0.09375 0.125-0.21875 0.20312-0.3125-1.3906-0.60938-2.375-1.7969-2.9375-3.5781z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.7344 4.7031v-0.79688h-2.0781v-0.375h4.5469v0.375h-2.0781v0.79688zm0.32812-1.8906c-0.42969 0-0.79297-0.11719-1.0938-0.34375-0.29297-0.21875-0.4375-0.48438-0.4375-0.79688s0.14453-0.57812 0.4375-0.79688c0.28906-0.21875 0.65625-0.32812 1.0938-0.32812 0.44531 0 0.8125 0.10156 1.0938 0.3125 0.28125 0.21875 0.42188 0.48828 0.42188 0.8125 0 0.3125-0.15234 0.57812-0.45312 0.79688-0.29297 0.22656-0.64844 0.34375-1.0625 0.34375zm-0.015625-0.39062c0.3125 0 0.57812-0.074219 0.79688-0.21875 0.22656-0.14844 0.34375-0.32422 0.34375-0.53125 0-0.21094-0.11719-0.38672-0.34375-0.53125-0.21875-0.14844-0.48438-0.21875-0.79688-0.21875s-0.57812 0.070313-0.79688 0.21875c-0.21875 0.14453-0.32812 0.32031-0.32812 0.53125 0 0.20703 0.10938 0.38281 0.32812 0.53125 0.21875 0.14453 0.48438 0.21875 0.79688 0.21875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.34375 4.5625v-0.39062h4.5469v0.39062zm2.4062-1.3125c-0.48047 0-0.875-0.125-1.1875-0.375-0.30469-0.24219-0.45312-0.53906-0.45312-0.89062 0-0.39844 0.14453-0.71484 0.4375-0.95312 0.30078-0.24219 0.70312-0.35938 1.2031-0.35938s0.89453 0.11719 1.1875 0.35938c0.28906 0.23828 0.4375 0.55469 0.4375 0.95312 0 0.36328-0.15234 0.66406-0.45312 0.90625-0.30469 0.23828-0.69531 0.35938-1.1719 0.35938zm-0.015625-0.42188c0.34375 0 0.63281-0.078125 0.875-0.23438 0.23828-0.15625 0.35938-0.35938 0.35938-0.60938 0-0.26172-0.12109-0.47656-0.35938-0.64062-0.24219-0.16797-0.53125-0.25-0.875-0.25-0.33594 0-0.62109 0.082031-0.85938 0.25-0.24219 0.16406-0.35938 0.37891-0.35938 0.64062 0 0.23828 0.11328 0.4375 0.34375 0.59375 0.23828 0.16406 0.53125 0.25 0.875 0.25z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.34375 4.5625v-0.375h4.5469v0.375zm1.2812-1.0938c-0.0625-0.39844-0.12109-0.89844-0.17188-1.5-0.054687-0.59375-0.078125-1.043-0.078125-1.3438h2.9531v2.6406h-0.39062v-2.2344h-0.78125v2.125h-0.39062v-2.125h-0.96875c0.019531 0.91406 0.09375 1.7266 0.21875 2.4375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.5625 4.5625v-0.375h2.6562v0.375zm0.015625-0.75v-0.39062h1.0625v-0.67188h0.375v0.67188h1.0938v0.39062zm1.25-1.2344c-0.29297 0-0.53906-0.10547-0.73438-0.3125-0.19922-0.19922-0.29688-0.46484-0.29688-0.79688 0-0.33594 0.09375-0.60156 0.28125-0.79688 0.1875-0.19922 0.42969-0.29688 0.73438-0.29688 0.30078 0 0.54688 0.10156 0.73438 0.3125 0.19531 0.20703 0.29688 0.46875 0.29688 0.78125 0 0.32031-0.10156 0.58594-0.29688 0.79688-0.19922 0.20703-0.4375 0.3125-0.71875 0.3125zm0-0.39062c0.17578 0 0.32812-0.074219 0.45312-0.21875 0.125-0.13672 0.1875-0.30469 0.1875-0.5 0-0.19922-0.0625-0.37109-0.1875-0.51562-0.125-0.13672-0.27734-0.20312-0.45312-0.20312-0.17969 0-0.33594 0.066406-0.46875 0.20312-0.125 0.14453-0.1875 0.31641-0.1875 0.51562 0 0.19531 0.0625 0.36328 0.1875 0.5 0.13281 0.14453 0.28906 0.21875 0.46875 0.21875zm-3.1406 2h1.25v-2.9062h0.39062v3.2812h-1.6406z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.0938 2.6406c-0.27344 0.14453-0.54297 0.41016-0.8125 0.79688-0.26172 0.38281-0.4375 0.76562-0.53125 1.1406-0.13672-0.14844-0.27344-0.24609-0.40625-0.29688 0.13281-0.33594 0.32031-0.67969 0.5625-1.0312 0.25-0.34375 0.5-0.60938 0.75-0.79688-0.625-0.41797-1.0742-0.98438-1.3438-1.7031 0.13281-0.085938 0.23828-0.17969 0.3125-0.28125 0.19531 0.57031 0.48438 1.0195 0.85938 1.3438 0.375 0.32031 0.78125 0.48438 1.2188 0.48438l-0.09375 0.5625c-0.10547-0.074219-0.27734-0.14844-0.51562-0.21875zm-2.8281 2.1094v-4.4688h0.39062v4.4688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.625 4.1406c-0.85547 0.00781-1.7578-0.09375-2.7031-0.3125 0-0.074219 0.007813-0.22656 0.03125-0.45312 0.25781 0.082031 0.625 0.15625 1.0938 0.21875-0.15625-1.3672-0.24219-2.2461-0.25-2.6406l0.48438-0.09375c-0.011719 0.64453 0.03125 1.5703 0.125 2.7812 0.34375 0.03125 0.61328 0.046875 0.8125 0.046875v-2.7344h0.40625zm-3.5156 0.60938v-4.4375h0.39062v2h1.0781v0.39062h-1.0781v2.0469z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.34375 4.5625v-0.375h4.5469v0.375zm0.51562-3.8438h2.1562v2.2031h0.96875v-2.2031h0.40625v2.6094h-1.7656v-2.2031h-1.3594c0.039063 0.92578 0.16016 1.7852 0.35938 2.5781l-0.40625 0.015625c-0.1875-0.77344-0.30859-1.7734-0.35938-3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.34375 4.1719h2.375v-1.5h0.39062v1.5h1.7812v0.39062h-4.5469zm0.75-1.3281c0.38281-0.44922 0.91016-0.80859 1.5781-1.0781-0.69922-0.27344-1.2734-0.65234-1.7188-1.1406 0.1875-0.125 0.30469-0.23438 0.35938-0.32812 0.25 0.375 0.625 0.67969 1.125 0.92188 0.50781 0.23828 0.96875 0.35938 1.375 0.35938l0.39062-0.015625c0.11328 0 0.20312-0.00781 0.26562-0.015625l-0.0625 0.53125c-0.1875-0.09375-0.54688-0.14062-1.0781-0.14062-0.074219 0-0.23047 0.050781-0.46875 0.15625-0.24219 0.11328-0.44531 0.22266-0.60938 0.32812-0.15625 0.11328-0.30469 0.23438-0.4375 0.35938-0.13672 0.125-0.25 0.25391-0.34375 0.39062-0.10547-0.15625-0.23047-0.26562-0.375-0.32812z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.2188 4.1719c-0.21875 0-0.41406-0.16406-0.57812-0.48438-0.15625-0.3125-0.23438-0.70312-0.23438-1.1719 0-0.49219 0.078125-0.89062 0.23438-1.2031 0.15625-0.30469 0.34766-0.45312 0.57812-0.45312 0.22656 0 0.42188 0.16016 0.57812 0.48438 0.16406 0.32031 0.25 0.71094 0.25 1.1719 0 0.45703-0.085937 0.84766-0.25 1.1719-0.15625 0.32031-0.35156 0.48438-0.57812 0.48438zm0-0.46875c0.125 0 0.22656-0.11719 0.3125-0.34375 0.082031-0.21875 0.125-0.5 0.125-0.84375 0-0.33594-0.042969-0.61719-0.125-0.84375-0.085938-0.23047-0.1875-0.34375-0.3125-0.34375-0.11719 0-0.21875 0.11328-0.3125 0.34375-0.085938 0.22656-0.125 0.50781-0.125 0.84375 0 0.34375 0.039062 0.625 0.125 0.84375 0.09375 0.22656 0.19531 0.34375 0.3125 0.34375zm-1.375 0.9375v-1.9375h-0.35938v-0.375h0.35938v-1.9375h0.375v4.25zm-0.4375-0.57812h-1v-2.7344h-0.32812v2.8125h-0.39062v-3.2031h1.1094v2.7344h0.23438v-2.75h0.375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.34375 4.5625v-0.375h4.5469v0.375zm0.95312-1.2812c0.375-0.49219 0.89844-0.89062 1.5781-1.2031-0.71094-0.30469-1.2891-0.73047-1.7344-1.2812 0.16406-0.125 0.27344-0.24219 0.32812-0.34375 0.25781 0.42578 0.64062 0.76953 1.1406 1.0312 0.5 0.25781 0.95312 0.39062 1.3594 0.39062 0.3125 0 0.51953-0.011719 0.625-0.03125l-0.0625 0.57812c-0.13672-0.0625-0.26172-0.10547-0.375-0.125-0.11719-0.023437-0.33984-0.03125-0.67188-0.03125-0.054687 0-0.17969 0.046875-0.375 0.14062-0.19922 0.09375-0.36719 0.17969-0.5 0.26562l-0.375 0.28125c-0.11719 0.10156-0.22656 0.21094-0.32812 0.32812-0.10547 0.11328-0.19922 0.23438-0.28125 0.35938-0.09375-0.15625-0.20312-0.27734-0.32812-0.35938z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.6875 4.7031v-0.79688h-1.125v-0.375h2.625v0.375h-1.125v0.79688zm-1.125-4 0.32812-0.26562c0.13281 0.40625 0.35938 0.77344 0.67188 1.1094 0.32031 0.34375 0.64062 0.56641 0.95312 0.67188v-1.625h0.39062v2.1719c-0.51172-0.09375-0.97656-0.32812-1.3906-0.70312-0.41797-0.36719-0.73438-0.82031-0.95312-1.3594zm-1 3.3125c-0.27344 0-0.48438-0.14062-0.64062-0.42188-0.16406-0.28125-0.25-0.64062-0.25-1.0781 0-0.46094 0.078125-0.82812 0.23438-1.1094s0.375-0.42188 0.65625-0.42188c0.25 0 0.46094 0.14062 0.64062 0.42188 0.17578 0.28906 0.26562 0.66016 0.26562 1.1094 0 0.4375-0.085938 0.79688-0.25 1.0781-0.16797 0.28125-0.38672 0.42188-0.65625 0.42188zm-0.015625-0.45312c0.15625 0 0.28125-0.10156 0.375-0.29688 0.09375-0.1875 0.14062-0.4375 0.14062-0.75 0-0.32422-0.046875-0.58594-0.14062-0.78125-0.09375-0.19922-0.21875-0.29688-0.375-0.29688-0.14844 0-0.26562 0.097656-0.35938 0.29688-0.09375 0.19531-0.14062 0.45703-0.14062 0.78125 0 0.3125 0.046875 0.5625 0.14062 0.75 0.09375 0.19531 0.21094 0.29688 0.35938 0.29688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.7031 4.7031v-0.79688h-1.1406v-0.375h2.6406v0.375h-1.1094v0.79688zm1.0156-3.75h-1.375c-0.011719 0.53125 0.039062 1.2891 0.15625 2.2812h-0.375c-0.10547-0.82422-0.16406-1.7188-0.17188-2.6875h1.7656zm-4.0312 2.5781h0.17188v-2.0625h-0.17188v-0.375h1.7188v2.8125h-1.7188zm1.3281 0v-2.0625h-0.76562v2.0625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.6719 4.625v-1.9219h-1.9844v-0.375h1.9844v-1.9375h0.40625v3.0781c0.76953 0.14453 1.2422 0.21875 1.4219 0.21875v-2.9531h0.40625v3.4062c-0.3125-0.023437-0.92188-0.11719-1.8281-0.28125v0.76562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.5469 4.5625v-0.375h0.76562v-1.0156h0.375v1.0156h0.375v-1.0156h0.375v1.0156h0.76562v0.375zm1.2812-1.8125c-0.30469 0-0.55859-0.10547-0.76562-0.3125-0.21094-0.21094-0.3125-0.49219-0.3125-0.84375 0-0.35547 0.097656-0.63672 0.29688-0.84375 0.19531-0.21094 0.45703-0.3125 0.78125-0.3125 0.30078 0 0.55469 0.10938 0.76562 0.32812 0.20703 0.21875 0.3125 0.49219 0.3125 0.82812 0 0.34375-0.10547 0.61719-0.3125 0.82812-0.21094 0.21875-0.46484 0.32812-0.76562 0.32812zm0-0.375c0.19531 0 0.36328-0.078125 0.5-0.23438 0.13281-0.14844 0.20312-0.32422 0.20312-0.53125 0-0.21875-0.070312-0.40625-0.20312-0.5625-0.13672-0.14844-0.30469-0.21875-0.5-0.21875-0.1875 0-0.35547 0.070313-0.5 0.21875-0.13672 0.15625-0.20312 0.34375-0.20312 0.5625 0 0.20703 0.066406 0.38281 0.20312 0.53125 0.14453 0.15625 0.3125 0.23438 0.5 0.23438zm-2.2812 2.2031c-0.28125 0-0.5-0.15625-0.65625-0.46875s-0.23438-0.71875-0.23438-1.2188c0-0.52344 0.078125-0.9375 0.23438-1.25s0.375-0.46875 0.65625-0.46875 0.5 0.16406 0.65625 0.5c0.16406 0.33203 0.25 0.73828 0.25 1.2188 0 0.48828-0.078125 0.89062-0.23438 1.2031-0.15625 0.32031-0.38281 0.48438-0.67188 0.48438zm0-0.40625c0.14453 0 0.26562-0.125 0.35938-0.375 0.10156-0.25 0.15625-0.55469 0.15625-0.90625 0-0.34375-0.046875-0.64844-0.14062-0.90625-0.085937-0.26172-0.21094-0.39062-0.375-0.39062-0.13672 0-0.25781 0.13281-0.35938 0.40625-0.09375 0.26953-0.14062 0.56641-0.14062 0.89062 0 0.34375 0.046875 0.64062 0.14062 0.89062 0.10156 0.25781 0.22266 0.39062 0.35938 0.39062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.6562 4.6406v-4.25h0.35938v1.9375h0.35938v-1.4531h1.5781v3.2031h-0.39062v-2.7969h-0.79688v2.8594h-0.39062v-1.4375h-0.35938v1.9375zm-1.1094-0.42188c-0.28125 0-0.5-0.15625-0.65625-0.46875s-0.23438-0.71875-0.23438-1.2188c0-0.52344 0.078125-0.9375 0.23438-1.25s0.375-0.46875 0.65625-0.46875 0.5 0.16406 0.65625 0.5c0.16406 0.33203 0.25 0.73828 0.25 1.2188 0 0.48828-0.078125 0.89062-0.23438 1.2031-0.15625 0.32031-0.38281 0.48438-0.67188 0.48438zm0.51562-1.6406c0-0.38672-0.046875-0.71094-0.14062-0.96875-0.085937-0.25-0.21094-0.375-0.375-0.375-0.13672 0-0.25781 0.13281-0.35938 0.40625-0.09375 0.26953-0.14062 0.56641-0.14062 0.89062 0 0.34375 0.046875 0.64062 0.14062 0.89062 0.10156 0.25 0.22266 0.375 0.35938 0.375 0.14453 0 0.26562-0.12109 0.35938-0.35938 0.10156-0.24219 0.15625-0.52734 0.15625-0.85938z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.34375 4.5625v-0.375h2.125v-0.625h-1.8594v-0.39062h4.0312v0.39062h-1.7812v0.625h2.0312v0.375zm3.4531-1.9219v-1.6875h-2.2969c0 0.50781 0.0625 1.1719 0.1875 1.9844h-0.39062c-0.11719-0.75-0.1875-1.5469-0.21875-2.3906h3.1094v2.0938z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.14062 4.75v-4.4375h0.39062v2h0.79688v-1.3906h1.4219v2.6875h0.625v-2.6875h0.40625v3.0781h-1.4219v-2.6719h-0.64062v2.7969h-0.39062v-1.4219h-0.79688v2.0469z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.1562 0.79688c0.14453 0.21875 0.21875 0.44531 0.21875 0.6875 0 0.28906-0.10547 0.54688-0.3125 0.76562-0.21094 0.22656-0.49219 0.34375-0.84375 0.34375-0.35547 0-0.65625-0.11719-0.90625-0.34375-0.25-0.21875-0.375-0.51172-0.375-0.875 0-0.30469 0.082031-0.5625 0.25-0.78125 0.16406-0.21875 0.41406-0.34375 0.75-0.375l0.03125 0.45312c-0.21875 0.039063-0.38672 0.11719-0.5 0.23438-0.11719 0.125-0.17188 0.28125-0.17188 0.46875 0 0.21875 0.082031 0.39453 0.25 0.53125 0.17578 0.14453 0.38281 0.21875 0.625 0.21875 0.25 0 0.44531-0.074219 0.59375-0.21875 0.14453-0.14844 0.21875-0.32812 0.21875-0.54688 0-0.28125-0.11719-0.5-0.34375-0.65625l0.046875-0.42188 1.8438 0.35938v1.7812h-0.42188v-1.4375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 1.8906v-0.45312h2.7969c-0.21094-0.21875-0.38672-0.51172-0.53125-0.875h0.4375c0.23828 0.50781 0.53516 0.85156 0.89062 1.0312v0.29688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.2188 4.1406v-3.2031h2.375v3.1562h-0.39062v-2.75h-0.59375v2.5938h-0.40625v-2.5938h-0.57812v2.7969zm-0.95312 0.60938v-4.4688h0.39062v4.4688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.34375 4.1875h4.5625v0.375h-4.5625zm0.28125-0.9375h1.7969v-0.67188h0.39062v0.67188h2v0.39062h-4.1875zm0.26562-2.6562h2.2812v1.5h0.92188v-1.5h0.39062v1.9062h-1.7031v-1.5h-1.4844c0.007813 0.53906 0.09375 1.125 0.25 1.75h-0.375c-0.16797-0.59375-0.26172-1.3125-0.28125-2.1562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.1562 4.0781v-2.7969h-1.3906v2.8438c-0.10547 0.007812-0.23438 0.007812-0.39062 0v-3.2344h2.1719v3.1875zm-2.9531 0.67188v-4.4688h0.40625v4.4688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.82812 4.1875h3.375v0.375h-3.375zm0.28125-0.85938h1.5625v-0.875h0.39062v0.875h1.0625v0.39062h-3.0156zm1.9375-1.4688c-0.23047 0.070313-0.48438 0.22656-0.76562 0.46875-0.28125 0.25-0.49609 0.49219-0.64062 0.73438-0.054687-0.13672-0.15625-0.25-0.3125-0.34375 0.25781-0.375 0.64844-0.73047 1.1719-1.0625-0.46875-0.21875-0.88281-0.57422-1.2344-1.0625 0.13281-0.085938 0.24219-0.18359 0.32812-0.29688 0.1875 0.28906 0.41016 0.53906 0.67188 0.75 0.25781 0.20703 0.5 0.34375 0.71875 0.40625 0.22656 0.0625 0.51562 0.09375 0.85938 0.09375l-0.046875 0.46875c-0.0625-0.03125-0.20312-0.070313-0.42188-0.10938-0.21094-0.03125-0.32031-0.046875-0.32812-0.046875zm-3.2812 2.7031v-3.3438h1.5312v0.39062h-1.125v2.9531z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.34375 4.1875h2.0781v-1.1406h0.39062v1.1406h2.0781v0.375h-4.5469zm1.0469-0.95312c-0.054687-0.375-0.10547-0.84375-0.15625-1.4062-0.042969-0.5625-0.0625-0.98047-0.0625-1.25h3.125v2.4375h-0.39062v-2.0312h-0.875v1.9219h-0.39062v-1.9219h-1.0625c-0.011719 0.58203 0.054687 1.332 0.20312 2.25z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9375 1.9062c-0.042969 0.21875-0.15234 0.38281-0.32812 0.5-0.16797 0.11328-0.35156 0.17188-0.54688 0.17188-0.33594 0-0.60547-0.12109-0.8125-0.35938-0.21094-0.24219-0.3125-0.52344-0.3125-0.84375 0-0.32422 0.085938-0.58984 0.26562-0.79688 0.1875-0.21094 0.42969-0.32812 0.73438-0.35938l0.0625 0.4375c-0.23047 0.050781-0.40625 0.13281-0.53125 0.25-0.11719 0.11328-0.17188 0.26953-0.17188 0.46875 0 0.19531 0.070313 0.36719 0.21875 0.51562 0.14453 0.14453 0.32031 0.21875 0.53125 0.21875 0.19531 0 0.35938-0.070313 0.48438-0.20312 0.13281-0.125 0.20312-0.29297 0.20312-0.5 0-0.085938-0.015625-0.1875-0.046875-0.3125l0.39062 0.046875c0 0.11328 0.00391 0.20703 0.015625 0.28125 0.00781 0.070313 0.035156 0.14844 0.078125 0.23438 0.050781 0.082031 0.11719 0.14844 0.20312 0.20312 0.082031 0.0625 0.17969 0.09375 0.29688 0.09375 0.17578 0 0.3125-0.0625 0.40625-0.1875 0.10156-0.11719 0.15625-0.25 0.15625-0.40625 0-0.17969-0.058594-0.32422-0.17188-0.4375-0.11719-0.11719-0.27734-0.1875-0.48438-0.21875l0.09375-0.4375c0.30078 0.0625 0.53125 0.1875 0.6875 0.375 0.15625 0.19531 0.23438 0.42969 0.23438 0.70312 0 0.30078-0.089844 0.55078-0.26562 0.75-0.17969 0.20703-0.39844 0.3125-0.65625 0.3125-0.33594 0-0.57422-0.16797-0.71875-0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.625 3.2656v-1.5h0.39062v1.5zm-1.1719 1.125-0.39062-0.375c0.15625-0.65625 0.41406-1.1641 0.78125-1.5156-0.39844-0.38672-0.66406-0.89844-0.79688-1.5312 0.19531-0.125 0.32031-0.23047 0.375-0.3125 0.125 0.70703 0.32031 1.1797 0.59375 1.4219v-1.375h0.39062v3.625h-0.39062v-1.3906c-0.28125 0.28906-0.46875 0.77344-0.5625 1.4531zm-0.875 0.25v-4.25h0.39062v4.25zm-1.0312-0.42188c-0.28125 0-0.5-0.15625-0.65625-0.46875s-0.23438-0.71875-0.23438-1.2188c0-0.52344 0.078125-0.9375 0.23438-1.25s0.375-0.46875 0.65625-0.46875 0.5 0.16406 0.65625 0.5c0.16406 0.33203 0.25 0.73828 0.25 1.2188 0 0.48828-0.078125 0.89062-0.23438 1.2031-0.15625 0.32031-0.38281 0.48438-0.67188 0.48438zm0.51562-1.6406c0-0.38672-0.046875-0.71094-0.14062-0.96875-0.085937-0.25-0.21094-0.375-0.375-0.375-0.13672 0-0.25781 0.13281-0.35938 0.40625-0.09375 0.26953-0.14062 0.56641-0.14062 0.89062 0 0.34375 0.046875 0.64062 0.14062 0.89062 0.10156 0.25 0.22266 0.375 0.35938 0.375 0.14453 0 0.26562-0.12109 0.35938-0.35938 0.10156-0.24219 0.15625-0.52734 0.15625-0.85938z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.5938 1.3906c0 0.78906-0.60938 1.1875-1.8281 1.1875-0.61719 0-1.0742-0.10547-1.375-0.3125-0.30469-0.19922-0.45312-0.49219-0.45312-0.875 0-0.78125 0.60938-1.1719 1.8281-1.1719 0.61328 0 1.0703 0.097656 1.375 0.29688 0.30078 0.20703 0.45312 0.5 0.45312 0.875zm-3.2969 0c0 0.23828 0.11328 0.42188 0.34375 0.54688 0.22656 0.125 0.60156 0.1875 1.125 0.1875 0.36328 0 0.64844-0.03125 0.85938-0.09375 0.20703-0.054688 0.35938-0.13281 0.45312-0.23438 0.10156-0.10547 0.15625-0.24219 0.15625-0.40625 0-0.24219-0.12109-0.42188-0.35938-0.54688-0.23047-0.11719-0.60156-0.17188-1.1094-0.17188-0.35547 0-0.63672 0.023437-0.84375 0.078125-0.21094 0.0625-0.36719 0.14453-0.46875 0.25-0.10547 0.10156-0.15625 0.23438-0.15625 0.39062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9375 1.9062c-0.14844 0.44531-0.45312 0.67188-0.92188 0.67188-0.30469 0-0.55859-0.10938-0.76562-0.32812-0.21094-0.21875-0.3125-0.50781-0.3125-0.85938 0-0.34375 0.10156-0.625 0.3125-0.84375 0.20703-0.21875 0.46875-0.32812 0.78125-0.32812 0.22656 0 0.42578 0.054688 0.59375 0.17188 0.16406 0.125 0.26953 0.28906 0.3125 0.5h0.015625c0.10156-0.35547 0.34375-0.53125 0.71875-0.53125 0.25781 0 0.47656 0.09375 0.65625 0.28125 0.17578 0.1875 0.26562 0.4375 0.26562 0.75s-0.09375 0.5625-0.28125 0.75c-0.17969 0.19531-0.39844 0.29688-0.65625 0.29688-0.34375 0-0.57812-0.17969-0.70312-0.53125zm0.17188-0.51562c0 0.16406 0.050781 0.30469 0.15625 0.42188 0.10156 0.11328 0.23438 0.17188 0.39062 0.17188 0.16406 0 0.30078-0.058594 0.40625-0.17188 0.11328-0.11719 0.17188-0.25781 0.17188-0.42188 0-0.16797-0.058594-0.30859-0.17188-0.42188-0.10547-0.10547-0.23047-0.15625-0.375-0.15625-0.17969 0-0.32031 0.054688-0.42188 0.17188-0.10547 0.11328-0.15625 0.25-0.15625 0.40625zm-1.8125 0c0 0.20703 0.066406 0.37891 0.20312 0.51562 0.13281 0.14453 0.30469 0.21875 0.51562 0.21875 0.21875 0 0.39453-0.074219 0.53125-0.21875 0.13281-0.13672 0.20312-0.30859 0.20312-0.51562 0-0.21875-0.074219-0.39844-0.21875-0.53125-0.13672-0.13672-0.30469-0.20312-0.5-0.20312-0.21094 0-0.38672 0.066406-0.53125 0.20312-0.13672 0.14453-0.20312 0.32031-0.20312 0.53125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.0781 1.5156v-1.3594h0.4375v1.3594z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.8438 0.65625c0.3125 0.20703 0.46875 0.5 0.46875 0.875 0 0.28906-0.10938 0.53906-0.32812 0.75-0.21094 0.20703-0.48047 0.3125-0.8125 0.3125-0.34375 0-0.63672-0.10547-0.875-0.3125-0.24219-0.21094-0.35938-0.48438-0.35938-0.82812s0.125-0.63672 0.375-0.875c0.25781-0.24219 0.71094-0.35938 1.3594-0.35938 0.63281 0 1.1133 0.10938 1.4375 0.32812 0.32031 0.21875 0.48438 0.53516 0.48438 0.95312 0 0.26953-0.078125 0.5-0.23438 0.6875-0.14844 0.1875-0.36719 0.30078-0.65625 0.34375l-0.03125-0.45312c0.375-0.074219 0.5625-0.27734 0.5625-0.60938 0-0.21875-0.11719-0.41406-0.34375-0.57812-0.21875-0.15625-0.57031-0.23438-1.0469-0.23438zm-1.5469 0.79688c0 0.19531 0.078125 0.35938 0.23438 0.48438 0.16406 0.125 0.36719 0.1875 0.60938 0.1875 0.22656 0 0.41406-0.0625 0.5625-0.1875 0.15625-0.125 0.23438-0.29297 0.23438-0.5 0-0.19922-0.074219-0.37109-0.21875-0.51562-0.13672-0.13672-0.32422-0.20312-0.5625-0.20312-0.24219 0-0.44531 0.066406-0.60938 0.20312-0.16797 0.14453-0.25 0.32031-0.25 0.53125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.85938 2.5625v-0.48438h-0.85938v-0.4375h0.85938v-1.5625h0.40625l2.3125 1.6406v0.35938h-2.3125v0.48438zm0.40625-0.92188h1.6094v-0.015625l-1.6094-1.1094z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-6-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.5 0.73438c0-0.20312-0.14062-0.28125-0.28125-0.28125-0.15625 0-0.28125 0.078125-0.28125 0.28125 0 0.1875 0.125 0.26562 0.28125 0.26562 0.14062 0 0.28125-0.078125 0.28125-0.26562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-14-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-8.4062-1.2344h8.4062v-0.95312h-8.4062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-14-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-8.3281-6.5h6.7344v0.015625l-6.8125 4.3438v0.92188h8.4062v-0.92188h-6.7969l6.7969-4.3438v-0.9375h-8.4062v0.92188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-14-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-8.4062-3.1094v1.8906h8.4062v-1.875c0-2.8125-1.25-4.5-4.2031-4.5s-4.2031 1.6875-4.2031 4.4844zm7.625 0.95312h-6.8438v-0.875c0-2.3281 0.92188-3.5625 3.4219-3.5625 2.5156 0 3.4219 1.2344 3.4219 3.5625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-14-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-8.3594-6.1406 1.9688 0.6875 5.0781 1.8125-5.0156 1.7812c-0.6875 0.23438-2.0312 0.70312-2.0312 0.70312h-0.046875v1.0312h0.046875s1.3438-0.5 2.0312-0.76562l6.3281-2.3281v-0.84375l-6.3906-2.3594-1.9688-0.73438h-0.046875v1.0156z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-14-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-8.3281-6.6562h5.1094c2.0625 0 2.5625 1.25 2.5625 2.2812 0 1.1406-0.5 2.3438-2.5625 2.3438h-5.1875v0.95312h5.2656c2.4219 0 3.3125-1.6406 3.3125-3.2969 0-1.5469-0.89062-3.25-3.3125-3.25h-5.2656v0.96875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-14-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-8.4062-4.3125v0.84375l6.4219 2.5469 1.9531 0.78125h0.03125v-1.0156l-0.046875-0.015625s-1.2969-0.5-1.9375-0.73438l-0.15625-0.0625v-3.8281l0.0625-0.015625c0.6875-0.26562 2.0469-0.78125 2.0469-0.78125h0.03125v-1.0312h-0.03125s-1.3594 0.54688-2.0469 0.8125zm1.2188 0.42188 4.2812-1.625v3.2656z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-14-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.78125-5.7969v3.6406h-7.625v0.9375h8.4062v-4.625h-0.78125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-14-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.78125-6.3594v4.2031h-3.1719v-3.875h-0.78125v3.875h-2.8906v-4.1875h-0.78125v5.125h8.4062v-5.1875h-0.78125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-14-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.40625-0.79688c0.21875-0.35938 0.51562-1.1406 0.51562-2.1719 0-1.9375-1.0156-2.9219-2.3281-2.9219-1.125 0-1.8438 0.59375-2.3281 1.8594l-0.375 1.0625c-0.28125 0.76562-0.6875 1.1406-1.4062 1.1406-0.75 0-1.3594-0.60938-1.3594-1.8125 0-0.85938 0.29688-1.5156 0.53125-1.875v-0.03125h-0.95312c-0.1875 0.32812-0.39062 1-0.39062 1.9531 0 1.7031 0.96875 2.7344 2.2656 2.7344 0.95312 0 1.7344-0.5625 2.1719-1.7344l0.375-1.0469c0.34375-0.90625 0.79688-1.2969 1.5469-1.2969 0.71875 0 1.4375 0.53125 1.4375 1.9219 0 1.0156-0.375 1.8125-0.67188 2.2031v0.015625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-14-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0-0.25v-0.90625l-8.3594-4.375h-0.046875v0.90625l8.375 4.375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-14-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-8.4062-3.9062v2.6875h8.4062v-0.9375h-3.5v-1.75c0-1.875-0.875-2.8906-2.4531-2.8906s-2.4531 1.0156-2.4531 2.8906zm4.1406 1.75h-3.375v-1.7031c0-1.2969 0.48438-1.9531 1.6875-1.9531s1.6875 0.65625 1.6875 1.9531z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-14-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-7.625-4.4844c0-1.0938 0.39062-1.7812 0.70312-2.0625v-0.046875h-1c-0.26562 0.35938-0.5625 1.0781-0.5625 2.1406 0 2.0781 1.5469 3.8125 4.2812 3.8125s4.2812-1.7344 4.2812-3.8125c0-1.0625-0.29688-1.7812-0.5625-2.1406h-0.98438v0.046875c0.3125 0.28125 0.70312 0.96875 0.70312 2.0625 0 1.5469-1.125 2.8438-3.4375 2.8438-2.2969 0-3.4219-1.2969-3.4219-2.8438z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-14-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-8.4062-8.5312v0.95312l4.7344 2.6875-4.7344 2.7188v0.9375h8.4062v-0.95312h-6.7969v-0.015625l4.6406-2.6406v-0.078125l-4.6406-2.6406v-0.015625h6.7969v-0.95312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-14-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-8.4062-5.875v5.7812h0.78125v-2.4219h7.625v-0.9375h-7.625v-2.4219z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-14-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-4.3281-5.2031c-0.125-0.5625-0.57812-1.5469-1.9531-1.5469-1.5312 0-2.125 1.1094-2.125 2.6875v2.8438h8.4062v-2.7969c0-1.6719-0.625-2.8906-2.25-2.8906-1.3438 0-1.9531 0.82812-2.0625 1.7031zm-3.3594 1.25c0-1.2031 0.46875-1.875 1.4844-1.875 0.9375 0 1.5312 0.5625 1.5312 1.875v1.7969h-3.0156zm6.9688 1.7969h-3.2344v-1.7656c0-1.4219 0.51562-2.0469 1.625-2.0469 1.0156 0 1.6094 0.57812 1.6094 2.0469z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m283.61 567.08v-0.14844h-283.31v-566.63h283.16v566.78h0.14844v-0.14844 0.14844h0.15234v-567.08h-283.77v567.23h283.77v-0.15234",
    fill: "#eb262a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m69.969 269.99v-0.125h-56.57v-104.63h56.445v104.76h0.125v-0.125 0.125h0.125v-105.01h-56.945v105.13h56.945v-0.125",
    fill: "#eb262a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m30.281 255.82h22.676v-76.535h-22.676z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m52.957 179.28v-0.125h-22.801v76.785h22.926v-76.785h-0.125v0.125h-0.125v76.41h-22.426v-76.285h22.551v-0.125h-0.125",
    fill: "#231f20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m20.723 149.61h42.551v-107.71h-42.551z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#231f20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m63.273 149.61v-0.14062h-42.41v-107.43h42.27v107.57h0.14062v-0.14062 0.14062h0.14063v-107.85h-42.832v107.99h42.832v-0.14063"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m70.578 44.781v1.582l1.2891-0.48438c0.39063-0.14844 0.71094-0.2539 0.96875-0.33203-0.30468-0.0664-0.60156-0.14844-0.89453-0.25391zm-1.9023-1.3359 4.6367 1.7812v0.67187l-4.6367 1.8945v-0.69921l1.4062-0.53907v-1.9531l-1.4062-0.50391"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.266 48.898v1.3164c0 0.28516 0.0273 0.5 0.0859 0.66016 0.0586 0.15625 0.15234 0.27343 0.27734 0.35546 0.13281 0.0859 0.26953 0.125 0.41797 0.125 0.22266 0 0.40234-0.082 0.54297-0.23828 0.14062-0.15625 0.21094-0.40625 0.21094-0.75v-1.4688zm-2.5898-0.61328h4.6367v2.0547c0 0.41406-0.0391 0.72656-0.125 0.94141-0.082 0.21484-0.23047 0.38671-0.44141 0.51562s-0.44141 0.19531-0.69531 0.19531c-0.33203 0-0.60938-0.10937-0.83203-0.32031-0.22657-0.21484-0.3711-0.54297-0.4336-0.98437-0.0781 0.16015-0.15625 0.28515-0.23047 0.36718-0.16406 0.17969-0.37109 0.34766-0.61718 0.50782l-1.2617 0.80468v-0.76953l0.96484-0.61328c0.27734-0.17578 0.48828-0.32422 0.64063-0.44141 0.14843-0.11718 0.25-0.21875 0.30859-0.3125 0.0586-0.0898 0.10156-0.18359 0.12109-0.27734 0.0156-0.0703 0.0234-0.18359 0.0234-0.34375v-0.71094h-2.0586"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.676 54.133h4.0938v-1.5274h0.54297v3.6719h-0.54297v-1.5273h-4.0938"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.676 57h0.64843v0.64843h-0.64843zm2.7148 0h0.64844v0.64843h-0.64844z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m75.082 360.18h0.15625v-254.11h7.3242v253.96h-7.4805v0.15625h0.15625-0.15625v0.15234h7.7891v-254.57h-7.9414v254.57h0.15235"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.727 108.78h3.6094v1.0938l-2.4609 0.65234 2.4609 0.64844v1.0938h-3.6094v-0.67578h2.8438l-2.8438-0.71875v-0.70313l2.8438-0.71094h-2.8438"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.727 112.99h3.6094v2.6758h-0.60937v-1.9453h-0.80078v1.8125h-0.60938v-1.8125h-0.98047v2.0156h-0.60937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.727 117.08h-2.3906v0.54687c0 0.20313 0.0117 0.34766 0.0352 0.4375 0.0273 0.1211 0.0781 0.21485 0.14844 0.29297 0.0703 0.0781 0.1875 0.14453 0.34765 0.19531 0.16407 0.0469 0.38282 0.0703 0.66407 0.0703 0.27734 0 0.49218-0.0234 0.64062-0.0703 0.14844-0.0508 0.26563-0.12109 0.35156-0.20703 0.082-0.0898 0.14063-0.20312 0.16797-0.33984 0.0234-0.10156 0.0352-0.30078 0.0352-0.59766zm0.60937-0.73047v1.3359c0 0.29687-0.0234 0.52734-0.0664 0.6875-0.0625 0.21093-0.17578 0.39062-0.33203 0.54296-0.16016 0.14844-0.35547 0.26563-0.58594 0.34375-0.23047 0.0781-0.51563 0.1211-0.85547 0.1211-0.29688 0-0.55078-0.0391-0.76563-0.11328-0.26171-0.0898-0.47656-0.21875-0.64062-0.38672-0.12109-0.125-0.21875-0.29688-0.28516-0.51172-0.0547-0.16016-0.0781-0.37891-0.0781-0.64453v-1.375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.727 120.71h3.6133v-0.73047h-3.6133z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.727 122.12h-2.3906v0.54687c0 0.20313 0.0117 0.34766 0.0352 0.4375 0.0273 0.12109 0.0781 0.21875 0.14844 0.29688 0.0703 0.0781 0.1875 0.14062 0.34765 0.1914 0.16407 0.0469 0.38282 0.0742 0.66407 0.0742 0.27734 0 0.49218-0.0273 0.64062-0.0742 0.14844-0.0508 0.26563-0.11719 0.35156-0.20703 0.082-0.0898 0.14063-0.20312 0.16797-0.33984 0.0234-0.10157 0.0352-0.30078 0.0352-0.59766zm0.60937-0.72657v1.332c0 0.30079-0.0234 0.52735-0.0664 0.6875-0.0625 0.21094-0.17578 0.39063-0.33203 0.54297-0.16016 0.14844-0.35547 0.26563-0.58594 0.34375-0.23047 0.082-0.51563 0.1211-0.85547 0.1211-0.29688 0-0.55078-0.0391-0.76563-0.11328-0.26171-0.0898-0.47656-0.21875-0.64062-0.38672-0.12109-0.125-0.21875-0.29688-0.28516-0.51172-0.0547-0.16016-0.0781-0.375-0.0781-0.64453v-1.3711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.156 126.96 1.3398-0.5-1.3398-0.48438zm-1.4297 1.3398v-0.78906l0.82031-0.31641v-1.4453l-0.82031-0.29688v-0.77343l3.6094 1.4062v0.76953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.664 129.52 3.7344 0.89844v0.51563l-3.7344-0.90235z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.727 133.52h3v-1.0742h0.60937v2.8711h-0.60937v-1.0703h-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.156 137.32 1.3398-0.4961-1.3398-0.48828zm-1.4297 1.3438v-0.79297l0.82031-0.31641v-1.4414l-0.82031-0.29688v-0.77344l3.6094 1.4062v0.76954"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.727 139.04h3.6094v1.0898l-2.4609 0.65234 2.4609 0.64844v1.0938h-3.6094v-0.67578h2.8438l-2.8438-0.71875v-0.69922l2.8438-0.71484h-2.8438"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.156 145.16 1.3398-0.4961-1.3398-0.48828zm-1.4297 1.3438v-0.79297l0.82031-0.31641v-1.4414l-0.82031-0.30078v-0.76954l3.6094 1.4062v0.76954"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.727 146.9h3.6094v0.70703l-2.4102 1.4805h2.4102v0.67578h-3.6094v-0.73047l2.3555-1.457h-2.3555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.727 150.54h3.6094v0.73047h-1.418v1.4258h1.418v0.73047h-3.6094v-0.73047h1.5781v-1.4258h-1.5781"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.535 154.78c-0.41015 0-0.71875 0.0977-0.92969 0.28515-0.21093 0.1875-0.3164 0.42578-0.3164 0.71875 0 0.28906 0.10547 0.52735 0.3125 0.71485 0.21094 0.1875 0.52344 0.27734 0.9414 0.27734 0.41407 0 0.72266-0.0898 0.92969-0.26953 0.20313-0.1836 0.30469-0.42188 0.30469-0.72266s-0.10547-0.54297-0.30859-0.72656c-0.20704-0.18359-0.51954-0.27734-0.9336-0.27734m-0.0234-0.75c0.36719 0 0.67579 0.0547 0.92579 0.16406 0.18359 0.082 0.34765 0.19531 0.49218 0.33594 0.14844 0.14453 0.25391 0.30078 0.32422 0.46875 0.0977 0.22265 0.14453 0.48046 0.14453 0.77734 0 0.53125-0.16406 0.95703-0.49609 1.2773-0.32813 0.32032-0.78516 0.48047-1.375 0.48047-0.58203 0-1.0391-0.16015-1.3672-0.47656-0.32812-0.31641-0.49609-0.74219-0.49609-1.2734 0-0.53515 0.16406-0.96094 0.49219-1.2773 0.32812-0.31641 0.78125-0.47656 1.3555-0.47656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.664 159.13 3.7344 0.89453v0.51953l-3.7344-0.90625z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.902 162.12 0.0703 0.71094c-0.23828 0.0391-0.41406 0.1289-0.52734 0.25781-0.10938 0.12891-0.16797 0.30469-0.16797 0.52734 0 0.23438 0.0508 0.41016 0.15234 0.53125 0.0977 0.11719 0.21485 0.17969 0.34766 0.17969l0.21484-0.0742c0.0625-0.0547 0.11328-0.14062 0.16016-0.26562 0.0273-0.0859 0.082-0.27735 0.15625-0.58203 0.0977-0.39063 0.21484-0.66407 0.35547-0.82032 0.19922-0.22265 0.4414-0.33593 0.72656-0.33593 0.18359 0 0.35547 0.0547 0.51563 0.15625 0.16015 0.10546 0.28515 0.2539 0.36718 0.45312 0.0859 0.19531 0.125 0.43359 0.125 0.70703 0 0.45313-0.0976 0.79688-0.29687 1.0274-0.19922 0.22656-0.46485 0.34765-0.79688 0.35937l-0.0312-0.73047c0.1836-0.0312 0.32032-0.0977 0.39844-0.19922 0.082-0.10156 0.125-0.25781 0.125-0.46093 0-0.21094-0.0469-0.37891-0.13281-0.5-0.0547-0.0781-0.12891-0.11329-0.22266-0.11329l-0.21875 0.10938c-0.0781 0.0898-0.16015 0.3125-0.24219 0.66797-0.082 0.35547-0.17187 0.61719-0.25781 0.78906-0.0937 0.16797-0.21484 0.30078-0.36719 0.39453-0.15625 0.0977-0.34765 0.14844-0.57812 0.14844-0.20703 0-0.39844-0.0586-0.57813-0.17578-0.18359-0.11328-0.3164-0.27735-0.40234-0.48828-0.0898-0.21094-0.13281-0.46875-0.13281-0.78516 0-0.45703 0.10547-0.80469 0.3164-1.0508 0.21094-0.24609 0.51563-0.39063 0.92188-0.4375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.727 166.38h3.6133v-0.73047h-3.6133z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.727 166.76h0.66015l2.3398 1.8945v-1.6797h0.60937v2.6406h-0.5625l-2.4375-1.9766v2.0547h-0.60937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.727 170.15h3.6094v2.6758h-0.60937v-1.9453h-0.80078v1.8125h-0.60938v-1.8125h-0.98047v2.0156h-0.60937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.664 174.54 3.7344 0.89454v0.51953l-3.7344-0.90625z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.727 178.53h3v-1.0703h0.60937v2.8711h-0.60937v-1.0703h-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.156 182.34 1.3398-0.49609-1.3398-0.48829zm-1.4297 1.3438v-0.79297l0.82031-0.31641v-1.4414l-0.82031-0.30078v-0.77344l3.6094 1.4062v0.76953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.727 184.78h3.6133v-0.73047h-3.6133z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.727 185.49h3.582v0.73047h-2.9727v1.8125h-0.60937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.727 188.57h3.582v0.73047h-2.9727v1.8125h-0.60937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.727 191.63h3.6094v2.6758h-0.60937v-1.9492h-0.80078v1.8125h-0.60938v-1.8125h-0.98047v2.0195h-0.60937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.664 196.02 3.7344 0.89453v0.51954l-3.7344-0.90625z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.727 199.19h3.6094v1.0898l-2.4609 0.65234 2.4609 0.64844v1.0938h-3.6094v-0.67578h2.8438l-2.8438-0.71875v-0.69922l2.8438-0.71485h-2.8438"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.156 205.31 1.3398-0.4961-1.3398-0.48828zm-1.4297 1.3438v-0.79297l0.82031-0.31641v-1.4414l-0.82031-0.29687v-0.77344l3.6094 1.4062v0.76953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.156 208.96 1.3398-0.5-1.3398-0.48438zm-1.4297 1.3398v-0.79297l0.82031-0.3164v-1.4414l-0.82031-0.29688v-0.77343l3.6094 1.4062v0.76953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.727 211.12h3v-1.0703h0.60937v2.8672h-0.60937v-1.0703h-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.664 214.42 3.7344 0.89454v0.51953l-3.7344-0.90235z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.727 217.59h3.6094v1.0898l-2.4609 0.65625 2.4609 0.64843v1.0938h-3.6094v-0.67968h2.8438l-2.8438-0.71485v-0.70312l2.8438-0.71485h-2.8438"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.727 222.5h3.6133v-0.73047h-3.6133z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.902 223.02 0.0703 0.70703c-0.23828 0.043-0.41406 0.12891-0.52734 0.26172-0.10938 0.12891-0.16797 0.30469-0.16797 0.52734 0 0.23438 0.0508 0.41016 0.15234 0.53125 0.0977 0.11719 0.21485 0.17579 0.34766 0.17579l0.21484-0.0742c0.0625-0.0508 0.11328-0.13672 0.16016-0.26172 0.0273-0.0859 0.082-0.28125 0.15625-0.58203 0.0977-0.39063 0.21484-0.66797 0.35547-0.82422 0.19922-0.22266 0.4414-0.33203 0.72656-0.33203 0.18359 0 0.35547 0.0508 0.51563 0.15625 0.16015 0.10547 0.28515 0.2539 0.36718 0.44922 0.0859 0.19921 0.125 0.43359 0.125 0.71093 0 0.45313-0.0976 0.79688-0.29687 1.0234-0.19922 0.23047-0.46485 0.35156-0.79688 0.36328l-0.0312-0.73047c0.1836-0.0312 0.32032-0.0976 0.39844-0.20312 0.082-0.10156 0.125-0.25391 0.125-0.46094 0-0.21094-0.0469-0.37891-0.13281-0.49609-0.0547-0.0781-0.12891-0.11719-0.22266-0.11719l-0.21875 0.10937c-0.0781 0.0937-0.16015 0.31641-0.24219 0.66797-0.082 0.35547-0.17187 0.61719-0.25781 0.78907-0.0937 0.17187-0.21484 0.30468-0.36719 0.39843-0.15625 0.0977-0.34765 0.14453-0.57812 0.14453-0.20703 0-0.39844-0.0586-0.57813-0.17187-0.18359-0.11719-0.3164-0.27734-0.40234-0.48828-0.0898-0.21094-0.13281-0.47266-0.13281-0.78516 0-0.45703 0.10547-0.80859 0.3164-1.0547 0.21094-0.24218 0.51563-0.38671 0.92188-0.43359"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.336 226.56v0.72656h-1.9531c-0.3086 0-0.51172 0.0117-0.60547 0.0274-0.14844 0.0312-0.26563 0.10546-0.35547 0.22265-0.0898 0.11719-0.13281 0.27735-0.13281 0.48438s0.043 0.35937 0.125 0.46484c0.0859 0.10547 0.1914 0.16797 0.3125 0.19141 0.125 0.0195 0.32812 0.0312 0.61328 0.0312h1.9961v0.73047h-1.8945c-0.43359 0-0.73828-0.0195-0.91797-0.0586-0.17968-0.0391-0.33203-0.11328-0.45312-0.21875-0.125-0.10547-0.22266-0.25-0.29688-0.42578-0.0703-0.17578-0.10937-0.41016-0.10937-0.69531 0-0.34375 0.043-0.60547 0.12109-0.78516 0.0781-0.17578 0.1836-0.3164 0.3125-0.42187 0.125-0.10157 0.25781-0.17188 0.39844-0.20313 0.20703-0.0469 0.51172-0.0703 0.91797-0.0703"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.813 230.94v0.53906c0 0.34765 0.0117 0.5664 0.043 0.65234l0.15235 0.20703c0.0703 0.0469 0.16015 0.0703 0.26953 0.0703 0.12109 0 0.21875-0.0312 0.29687-0.0937 0.0742-0.0664 0.1211-0.15625 0.14063-0.27735 8e-3 -0.0586 0.0117-0.23437 0.0117-0.53125v-0.5664zm-2.0859-0.73047h3.6094v1.5352c0 0.38672-0.0312 0.66407-0.0976 0.83985-0.0625 0.17578-0.17969 0.3125-0.34375 0.42187-0.16797 0.10156-0.35547 0.15625-0.57032 0.15625-0.26953 0-0.49218-0.0781-0.66796-0.23828-0.17969-0.16016-0.28907-0.39844-0.33594-0.71484-0.0899 0.15625-0.19141 0.28515-0.30078 0.39062-0.11328 0.10156-0.3086 0.23828-0.58594 0.41406l-0.70703 0.44141v-0.87109l0.78906-0.52735c0.27734-0.1875 0.45703-0.3164 0.52734-0.38281l0.15235-0.22266c0.0273-0.0742 0.0391-0.19921 0.0391-0.36328v-0.14843h-1.5078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.727 233.85h3.6094v2.6758h-0.60937v-1.9492h-0.80078v1.8164h-0.60938v-1.8164h-0.98047v2.0195h-0.60937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.664 238.24 3.7344 0.89453v0.51953l-3.7344-0.90234z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.055 243.09h0.60938v1.5703h-1.4375c-0.14844-0.15235-0.27735-0.3711-0.39063-0.66016-0.11328-0.29297-0.17187-0.58594-0.17187-0.88281 0-0.37891 0.082-0.70703 0.23828-0.98828 0.16016-0.28125 0.38672-0.49219 0.67969-0.63281 0.29687-0.14063 0.61718-0.21094 0.96093-0.21094 0.37891 0 0.71094 0.0781 1.0039 0.23828 0.29297 0.15625 0.51563 0.38672 0.67188 0.69141 0.12109 0.23046 0.17968 0.51953 0.17968 0.86328 0 0.44922-0.0937 0.79687-0.28125 1.0508-0.1875 0.25-0.44922 0.41406-0.78125 0.48437l-0.13281-0.72265c0.17578-0.0508 0.31641-0.14453 0.41797-0.28516 0.10547-0.14062 0.15625-0.31641 0.15625-0.52734 0-0.32032-0.10156-0.57032-0.30469-0.75782-0.20312-0.1875-0.5-0.28515-0.89844-0.28515-0.42968 0-0.75 0.0976-0.96484 0.28515-0.21484 0.19141-0.32031 0.44141-0.32031 0.75 0 0.15235 0.0312 0.30469 0.0898 0.45704 0.0586 0.15625 0.13281 0.28906 0.21875 0.39843h0.45703"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.813 246.07v0.53906c0 0.34766 0.0117 0.56641 0.043 0.65234l0.15235 0.20704c0.0703 0.0469 0.16015 0.0742 0.26953 0.0742 0.12109 0 0.21875-0.0351 0.29687-0.0976 0.0742-0.0664 0.1211-0.15625 0.14063-0.27344 8e-3 -0.0625 0.0117-0.23828 0.0117-0.53516v-0.5664zm-2.0859-0.73047h3.6094v1.5352c0 0.38671-0.0312 0.66406-0.0976 0.83984-0.0625 0.17578-0.17969 0.3125-0.34375 0.42187-0.16797 0.10157-0.35547 0.15625-0.57032 0.15625-0.26953 0-0.49218-0.0781-0.66796-0.23828-0.17969-0.16015-0.28907-0.39843-0.33594-0.71484-0.0899 0.15625-0.19141 0.28906-0.30078 0.39062-0.11328 0.10157-0.3086 0.23829-0.58594 0.41407l-0.70703 0.4414v-0.87109l0.78906-0.52734c0.27734-0.1875 0.45703-0.31641 0.52734-0.38282l0.15235-0.21875c0.0273-0.0781 0.0391-0.20312 0.0391-0.36718v-0.14844h-1.5078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.137 250.31h-0.59375v-0.59375h0.59375zm0 1.0586h-0.59375v-0.59375h0.59375zm-2.6016-1.7852c-0.41015 0-0.71875 0.0937-0.92969 0.28515-0.21093 0.1875-0.3164 0.42969-0.3164 0.71875 0 0.29297 0.10547 0.52735 0.3125 0.71485 0.21094 0.1875 0.52344 0.28125 0.9414 0.28125 0.41407 0 0.72266-0.0937 0.92579-0.27344 0.20703-0.17969 0.30859-0.42188 0.30859-0.72266s-0.10547-0.54297-0.30859-0.72656c-0.20704-0.18359-0.51954-0.27734-0.9336-0.27734m-0.0234-0.75c0.36719 0 0.67579 0.0547 0.92579 0.16406 0.18359 0.082 0.34765 0.19531 0.49218 0.33594 0.14844 0.14453 0.25782 0.30078 0.32813 0.46875 0.0937 0.22265 0.14062 0.48437 0.14062 0.77734 0 0.53125-0.16406 0.95703-0.49609 1.2773-0.32813 0.32032-0.78906 0.48047-1.375 0.48047-0.58203 0-1.0391-0.16015-1.3672-0.47656-0.32812-0.31641-0.49609-0.74219-0.49609-1.2695 0-0.53906 0.16406-0.96484 0.49219-1.2812 0.32812-0.32031 0.78125-0.47656 1.3555-0.47656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.902 252.72 0.0703 0.70703c-0.23828 0.043-0.41406 0.1289-0.52734 0.26172-0.10938 0.1289-0.16797 0.30468-0.16797 0.52734 0 0.23437 0.0508 0.41406 0.15234 0.53125 0.0977 0.11719 0.21485 0.17969 0.34766 0.17969l0.21484-0.0781c0.0625-0.0469 0.11328-0.13281 0.16016-0.25781 0.0273-0.0859 0.082-0.28125 0.15625-0.58594 0.0977-0.39062 0.21484-0.66406 0.35547-0.82422 0.19922-0.21875 0.4414-0.33203 0.72656-0.33203 0.18359 0 0.35547 0.0547 0.51563 0.16016 0.16015 0.10156 0.28515 0.2539 0.36718 0.44922 0.0859 0.19531 0.125 0.42968 0.125 0.71093 0 0.45313-0.0976 0.79297-0.29687 1.0234-0.19922 0.23047-0.46485 0.34766-0.79688 0.35938l-0.0312-0.73047c0.1836-0.0312 0.32032-0.0977 0.39844-0.19922 0.082-0.10156 0.125-0.25781 0.125-0.46484 0-0.21094-0.0469-0.375-0.13281-0.4961-0.0547-0.0742-0.12891-0.11328-0.22266-0.11328l-0.21875 0.10547c-0.0781 0.0937-0.16015 0.31641-0.24219 0.67187-0.082 0.35547-0.17187 0.61719-0.25781 0.78516-0.0937 0.17188-0.21484 0.30469-0.36719 0.40234-0.15625 0.0937-0.34765 0.14063-0.57812 0.14063-0.20703 0-0.39844-0.0547-0.57813-0.17188-0.18359-0.11328-0.3164-0.27734-0.40234-0.48828-0.0898-0.21093-0.13281-0.46875-0.13281-0.78515 0-0.45313 0.10547-0.80469 0.3164-1.0508 0.21094-0.24219 0.51563-0.39063 0.92188-0.4375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.727 256.27h3.6094v2.6797h-0.60937v-1.9492h-0.80078v1.8125h-0.60938v-1.8125h-0.98047v2.0195h-0.60937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.664 260.66 3.7344 0.89453v0.51953l-3.7344-0.90235z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.727 263.82h3.6094v1.0938l-2.4609 0.65235 2.4609 0.64844v1.0938h-3.6094v-0.67579h2.8438l-2.8438-0.71875v-0.70312l2.8438-0.71094h-2.8438"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.727 268.04h3.6094v2.6797h-0.60937v-1.9492h-0.80078v1.8125h-0.60938v-1.8125h-0.98047v2.0156h-0.60937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.727 272.21h3v-1.0742h0.60937v2.8711h-0.60937v-1.0703h-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.727 275.21h-1.0234v0.39844c0 0.28516 0.0195 0.48047 0.0547 0.57422 0.0391 0.0977 0.0976 0.17578 0.17969 0.23047 0.0781 0.0547 0.17187 0.082 0.28125 0.082 0.1289 0 0.23828-0.0391 0.32421-0.11719 0.082-0.0781 0.13672-0.17187 0.16016-0.29297 0.0156-0.0859 0.0234-0.26172 0.0234-0.52343zm-3-0.73047h3.6094v1.1719c0 0.44141-0.0156 0.73047-0.0547 0.86719-0.0508 0.20312-0.17188 0.3789-0.35157 0.51562-0.18359 0.14063-0.41406 0.21094-0.70312 0.21094-0.22266 0-0.40625-0.0391-0.5586-0.12109-0.15234-0.0781-0.26953-0.1836-0.35546-0.30469-0.0859-0.125-0.14454-0.25-0.17188-0.37891-0.0352-0.17578-0.0508-0.42578-0.0508-0.75781v-0.47266h-1.3633"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.535 278.45c-0.41015 0-0.71875 0.0937-0.92969 0.28125-0.21093 0.19141-0.3164 0.42969-0.3164 0.71875 0 0.28907 0.10547 0.53125 0.3125 0.71485 0.21094 0.1875 0.52344 0.28125 0.9414 0.28125 0.41407 0 0.72266-0.0899 0.92969-0.27344 0.20313-0.17969 0.30469-0.42187 0.30469-0.72266 0-0.30078-0.10547-0.54296-0.30859-0.72656-0.20704-0.18359-0.51954-0.27344-0.9336-0.27344m-0.0234-0.7539c0.36719 0 0.67579 0.0586 0.92579 0.16797 0.18359 0.082 0.34765 0.1914 0.49218 0.33593 0.14844 0.14063 0.25391 0.29688 0.32422 0.46485 0.0977 0.22656 0.14453 0.48437 0.14453 0.77734 0 0.53125-0.16406 0.95703-0.49609 1.2774-0.32813 0.32031-0.78516 0.48046-1.375 0.48046-0.58203 0-1.0391-0.15625-1.3672-0.47656-0.32812-0.3164-0.49609-0.73828-0.49609-1.2695 0-0.53516 0.16406-0.96484 0.49219-1.2812 0.32812-0.31641 0.78125-0.47656 1.3555-0.47656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.664 282.8 3.7344 0.89063v0.51953l-3.7344-0.90235z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.738 286.7h-0.83594v0.48047c0 0.28125 4e-3 0.45703 0.0117 0.52734 0.0156 0.125 0.0586 0.22266 0.1289 0.29297 0.0703 0.0742 0.16407 0.10938 0.28125 0.10938 0.11329 0 0.20313-0.0312 0.27344-0.0937 0.0703-0.0625 0.11328-0.15235 0.12891-0.27344 8e-3 -0.0742 0.0117-0.28125 0.0117-0.625zm-1.4375 0h-0.96485v0.67578c0 0.26172 8e-3 0.42969 0.0234 0.5 0.0195 0.10938 0.0664 0.19531 0.14453 0.26563 0.0742 0.0664 0.17578 0.10156 0.30469 0.10156 0.10937 0 0.19922-0.0273 0.27734-0.0781 0.0742-0.0547 0.12891-0.1289 0.16407-0.23046 0.0351-0.0977 0.0508-0.3125 0.0508-0.64454zm2.0352-0.72656v1.4414c0 0.28516-0.0117 0.5-0.0351 0.64063-0.0234 0.13672-0.0703 0.26562-0.14844 0.375-0.0742 0.10937-0.17578 0.20312-0.30078 0.27734-0.125 0.0742-0.26563 0.10938-0.42188 0.10938-0.16797 0-0.32422-0.043-0.46484-0.13672-0.14453-0.0898-0.24609-0.21484-0.32031-0.37109-0.0625 0.22265-0.17188 0.39062-0.32422 0.50781-0.15625 0.12109-0.33594 0.17969-0.54688 0.17969-0.16406 0-0.32422-0.0391-0.47656-0.11719-0.15625-0.0742-0.28125-0.17969-0.375-0.3125-0.0937-0.13281-0.14844-0.29297-0.17187-0.48828-0.0117-0.1211-0.0195-0.41407-0.0234-0.87891v-1.2266"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.727 289.61h3.6094v2.6797h-0.60937v-1.9492h-0.80078v1.8125h-0.60938v-1.8125h-0.98047v2.0156h-0.60937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.727 293.71h-2.3906v0.54297c0 0.20312 0.0117 0.35156 0.0352 0.4414 0.0273 0.11719 0.0781 0.21485 0.14844 0.29297 0.0703 0.0781 0.1875 0.14063 0.34765 0.19141 0.16407 0.0469 0.38282 0.0742 0.66407 0.0742 0.27734 0 0.49218-0.0274 0.64062-0.0742 0.14844-0.0508 0.26563-0.11719 0.35156-0.20703 0.082-0.0899 0.14063-0.20313 0.16797-0.33594 0.0234-0.10547 0.0352-0.30078 0.0352-0.60156zm0.60937-0.73047v1.332c0 0.30078-0.0234 0.52734-0.0664 0.6875-0.0625 0.21094-0.17578 0.39062-0.33203 0.54297-0.16016 0.15234-0.35547 0.26562-0.58594 0.34375-0.23047 0.082-0.51563 0.12109-0.85547 0.12109-0.29688 0-0.55078-0.0391-0.76563-0.11328-0.26171-0.0898-0.47656-0.21875-0.64062-0.38672-0.12109-0.125-0.21875-0.29687-0.28516-0.51172-0.0547-0.16015-0.0781-0.375-0.0781-0.64453v-1.3711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.727 296.62h3.6094v2.6797h-0.60937v-1.9492h-0.80078v1.8125h-0.60938v-1.8125h-0.98047v2.0156h-0.60937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.727 299.99h3.6094v0.70703l-2.4102 1.4805h2.4102v0.67578h-3.6094v-0.73046l2.3555-1.457h-2.3555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.664 304.65 3.7344 0.89453v0.51953l-3.7344-0.90234z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.813 308.56v0.53906c0 0.35156 0.0117 0.57031 0.043 0.65625l0.15235 0.20312c0.0703 0.0508 0.16015 0.0742 0.26953 0.0742 0.12109 0 0.21875-0.0312 0.29687-0.0976 0.0742-0.0664 0.1211-0.15625 0.14063-0.27344 8e-3 -0.0586 0.0117-0.23828 0.0117-0.53125v-0.57031zm-2.0859-0.72657h3.6094v1.5312c0 0.38672-0.0312 0.66797-0.0976 0.84375-0.0625 0.17188-0.17969 0.3125-0.34375 0.41797-0.16797 0.10547-0.35547 0.15625-0.57032 0.15625-0.26953 0-0.49218-0.0781-0.66796-0.23828-0.17969-0.16016-0.28907-0.39844-0.33594-0.71094-0.0899 0.15235-0.19141 0.28516-0.30078 0.38672-0.11328 0.10156-0.3086 0.24219-0.58594 0.41406l-0.70703 0.44141v-0.87109l0.78906-0.52735c0.27734-0.1875 0.45703-0.3164 0.52734-0.38281l0.15235-0.21875c0.0273-0.0781 0.0391-0.19922 0.0391-0.36719v-0.14843h-1.5078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.535 312.08c-0.41015 0-0.71875 0.0937-0.92969 0.28125-0.21093 0.19141-0.3164 0.42969-0.3164 0.71875s0.10547 0.53125 0.3125 0.71484c0.21094 0.1875 0.52344 0.28125 0.9414 0.28125 0.41407 0 0.72266-0.0898 0.92969-0.27343 0.20313-0.17969 0.30469-0.42188 0.30469-0.72266s-0.10547-0.54297-0.30859-0.72656c-0.20704-0.1836-0.51954-0.27344-0.9336-0.27344m-0.0234-0.75391c0.36719 0 0.67579 0.0586 0.92579 0.16797 0.18359 0.082 0.34765 0.19141 0.49218 0.33594 0.14844 0.14063 0.25391 0.29688 0.32422 0.46484 0.0977 0.22657 0.14453 0.48438 0.14453 0.77735 0 0.53125-0.16406 0.95703-0.49609 1.2773-0.32813 0.32031-0.78516 0.48047-1.375 0.48047-0.58203 0-1.0391-0.15625-1.3672-0.47656-0.32812-0.31641-0.49609-0.73828-0.49609-1.2695 0-0.53516 0.16406-0.96485 0.49219-1.2812 0.32812-0.31641 0.78125-0.47657 1.3555-0.47657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.727 315.09h0.66015l2.3398 1.8945v-1.6836h0.60937v2.6445h-0.5625l-2.4375-1.9766v2.0547h-0.60937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.727 318.47h3.6094v1.0898l-2.4609 0.65625 2.4609 0.64844v1.0898h-3.6094v-0.67578h2.8438l-2.8438-0.71875v-0.69922l2.8438-0.71484h-2.8438"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.727 323.39h3.6133v-0.73046h-3.6133z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.156 325.99 1.3398-0.49609-1.3398-0.48828zm-1.4297 1.3438v-0.79297l0.82031-0.3164v-1.4414l-0.82031-0.30078v-0.76953l3.6094 1.4023v0.77344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.813 328.45v0.53906c0 0.35157 0.0117 0.57032 0.043 0.65625l0.15235 0.20313c0.0703 0.0508 0.16015 0.0742 0.26953 0.0742 0.12109 0 0.21875-0.0312 0.29687-0.0977 0.0742-0.0625 0.1211-0.15625 0.14063-0.27344 8e-3 -0.0586 0.0117-0.23828 0.0117-0.53125v-0.57031zm-2.0859-0.72656h3.6094v1.5312c0 0.38672-0.0312 0.66797-0.0976 0.84375-0.0625 0.17187-0.17969 0.3125-0.34375 0.41797-0.16797 0.10547-0.35547 0.15625-0.57032 0.15625-0.26953 0-0.49218-0.0781-0.66796-0.23828-0.17969-0.16016-0.28907-0.39454-0.33594-0.71094-0.0899 0.15625-0.19141 0.28515-0.30078 0.38672-0.11328 0.10547-0.3086 0.24218-0.58594 0.41797l-0.70703 0.4414v-0.875l0.78906-0.52734c0.27734-0.1836 0.45703-0.3125 0.52734-0.38281l0.15235-0.21875c0.0273-0.0781 0.0391-0.19922 0.0391-0.36719v-0.14844h-1.5078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.664 332.39 3.7344 0.89453v0.51953l-3.7344-0.90234z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.727 335.56h3.6094v1.0898l-2.4609 0.65625 2.4609 0.64844v1.0938h-3.6094v-0.67969h2.8438l-2.8438-0.71484v-0.70313l2.8438-0.71484h-2.8438"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.156 341.68 1.3398-0.49609-1.3398-0.48829zm-1.4297 1.3398v-0.79297l0.82031-0.3125v-1.4414l-0.82031-0.30078v-0.77344l3.6094 1.4062v0.77344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.902 343.23 0.0703 0.71094c-0.23828 0.043-0.41406 0.1289-0.52734 0.25781-0.10938 0.13281-0.16797 0.30859-0.16797 0.53125 0 0.23437 0.0508 0.41015 0.15234 0.53125 0.0977 0.11719 0.21485 0.17578 0.34766 0.17578l0.21484-0.0742c0.0625-0.0508 0.11328-0.13672 0.16016-0.26172 0.0273-0.0859 0.082-0.28125 0.15625-0.58594 0.0977-0.39062 0.21484-0.66406 0.35547-0.82031 0.19922-0.22265 0.4414-0.33594 0.72656-0.33594 0.18359 0 0.35547 0.0547 0.51563 0.16016 0.16015 0.10156 0.28515 0.25391 0.36718 0.44922 0.0859 0.19531 0.125 0.43359 0.125 0.71094 0 0.45312-0.0976 0.79297-0.29687 1.0234-0.19922 0.23047-0.46485 0.34766-0.79688 0.36329l-0.0312-0.73047c0.1836-0.0312 0.32032-0.10157 0.39844-0.20313 0.082-0.10156 0.125-0.2539 0.125-0.46094 0-0.21093-0.0469-0.3789-0.13281-0.49609-0.0547-0.0781-0.12891-0.11719-0.22266-0.11719l-0.21875 0.10938c-0.0781 0.0937-0.16015 0.3164-0.24219 0.66797-0.082 0.35547-0.17187 0.61718-0.25781 0.78906-0.0937 0.16797-0.21484 0.30078-0.36719 0.39844-0.15625 0.0937-0.34765 0.14453-0.57812 0.14453-0.20703 0-0.39844-0.0586-0.57813-0.17188-0.18359-0.11328-0.3164-0.27734-0.40234-0.48828-0.0898-0.21094-0.13281-0.47265-0.13281-0.78515 0-0.45704 0.10547-0.8086 0.3164-1.0547 0.21094-0.24219 0.51563-0.39063 0.92188-0.4375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.336 346.77v0.73047h-1.9531c-0.3086 0-0.51172 8e-3 -0.60547 0.0273-0.14844 0.0312-0.26563 0.10547-0.35547 0.22266-0.0898 0.11718-0.13281 0.27734-0.13281 0.48046 0 0.20704 0.043 0.36329 0.125 0.46875 0.0859 0.10547 0.1914 0.16797 0.3125 0.19141 0.125 0.0195 0.32812 0.0312 0.61328 0.0312h1.9961v0.72656h-1.8945c-0.43359 0-0.73828-0.0156-0.91797-0.0586-0.17968-0.0391-0.33203-0.10938-0.45312-0.21484-0.125-0.10547-0.22266-0.25-0.29688-0.42579-0.0703-0.17968-0.10937-0.41015-0.10937-0.69531 0-0.34375 0.043-0.60547 0.12109-0.78515 0.0781-0.17579 0.1836-0.32032 0.3125-0.42188 0.125-0.10547 0.25781-0.17187 0.39844-0.20312 0.20703-0.0469 0.51172-0.0742 0.91797-0.0742"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.813 351.15v0.53907c0 0.35156 0.0117 0.57031 0.043 0.65625l0.15235 0.20312c0.0703 0.0508 0.16015 0.0742 0.26953 0.0742 0.12109 0 0.21875-0.0312 0.29687-0.0977 0.0742-0.0625 0.1211-0.15625 0.14063-0.27343 8e-3 -0.0586 0.0117-0.23438 0.0117-0.53125v-0.57032zm-2.0859-0.72656h3.6094v1.5352c0 0.38281-0.0312 0.66406-0.0976 0.83984-0.0625 0.17578-0.17969 0.3125-0.34375 0.41797-0.16797 0.10547-0.35547 0.16016-0.57032 0.16016-0.26953 0-0.49218-0.082-0.66796-0.24219-0.17969-0.15625-0.28907-0.39453-0.33594-0.71094-0.0899 0.15625-0.19141 0.28516-0.30078 0.39063-0.11328 0.10156-0.3086 0.23828-0.58594 0.41406l-0.70703 0.4414v-0.87109l0.78906-0.52734c0.27734-0.1875 0.45703-0.31641 0.52734-0.38672l0.15235-0.21875c0.0273-0.0781 0.0391-0.19922 0.0391-0.36719v-0.14844h-1.5078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.156 355.97 1.3398-0.49609-1.3398-0.48828zm-1.4297 1.3438v-0.79297l0.82031-0.3164v-1.4414l-0.82031-0.29687v-0.77344l3.6094 1.4062v0.76953"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-358.41 -87.504)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 157.14799,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 161.552,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 162.92,
    xlinkHref: "#glyph-0-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 167.618,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 171.32001,
    xlinkHref: "#glyph-0-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 175.35201,
    xlinkHref: "#glyph-0-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 178.718,
    xlinkHref: "#glyph-0-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 182.42,
    xlinkHref: "#glyph-0-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 185.45599,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 186.82401,
    xlinkHref: "#glyph-0-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 188.192,
    xlinkHref: "#glyph-0-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 192.224,
    xlinkHref: "#glyph-0-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 196.256,
    xlinkHref: "#glyph-0-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 197.62399,
    xlinkHref: "#glyph-0-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 201.326,
    xlinkHref: "#glyph-0-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 202.694,
    xlinkHref: "#glyph-0-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 206.726,
    xlinkHref: "#glyph-0-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 210.758,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 214.46001,
    xlinkHref: "#glyph-0-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 217.496,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 218.864,
    xlinkHref: "#glyph-0-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 220.23199,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 221.60001,
    xlinkHref: "#glyph-0-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 224.966,
    xlinkHref: "#glyph-0-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 229.334,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 233.036,
    xlinkHref: "#glyph-0-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 236.07201,
    xlinkHref: "#glyph-0-19"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 240.104,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 243.806,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 245.174,
    xlinkHref: "#glyph-0-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 249.20599,
    xlinkHref: "#glyph-0-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 252.908,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 254.276,
    xlinkHref: "#glyph-0-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 258.974,
    xlinkHref: "#glyph-0-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 262.67599,
    xlinkHref: "#glyph-0-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 266.37799,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 270.07999,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 271.448,
    xlinkHref: "#glyph-0-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 272.81601,
    xlinkHref: "#glyph-0-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 276.84799,
    xlinkHref: "#glyph-0-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 280.88,
    xlinkHref: "#glyph-0-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 282.24799,
    xlinkHref: "#glyph-0-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 285.95001,
    xlinkHref: "#glyph-0-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 287.31799,
    xlinkHref: "#glyph-0-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 291.35001,
    xlinkHref: "#glyph-0-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 295.38199,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 299.08401,
    xlinkHref: "#glyph-0-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 302.12,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 303.48801,
    xlinkHref: "#glyph-0-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 304.85599,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 306.224,
    xlinkHref: "#glyph-0-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 309.92599,
    xlinkHref: "#glyph-0-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 312.96201,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 316.664,
    xlinkHref: "#glyph-0-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 320.69601,
    xlinkHref: "#glyph-0-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 324.39801,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 325.76599,
    xlinkHref: "#glyph-0-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 330.46399,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 334.16599,
    xlinkHref: "#glyph-0-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 337.53201,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 338.89999,
    xlinkHref: "#glyph-0-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 340.26801,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 341.63599,
    xlinkHref: "#glyph-0-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 345.33801,
    xlinkHref: "#glyph-0-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 349.04001,
    xlinkHref: "#glyph-0-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 352.40601,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 353.77399,
    xlinkHref: "#glyph-0-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 357.806,
    xlinkHref: "#glyph-0-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 361.508,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 362.87601,
    xlinkHref: "#glyph-0-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 366.242,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 369.944,
    xlinkHref: "#glyph-0-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 373.646,
    xlinkHref: "#glyph-0-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 376.68201,
    xlinkHref: "#glyph-0-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 380.384,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 381.75201,
    xlinkHref: "#glyph-0-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 383.12,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 384.48801,
    xlinkHref: "#glyph-0-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 388.19,
    xlinkHref: "#glyph-0-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 391.22601,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 394.92801,
    xlinkHref: "#glyph-0-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 398.95999,
    xlinkHref: "#glyph-0-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 402.66199,
    xlinkHref: "#glyph-0-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 407.35999,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 411.06201,
    xlinkHref: "#glyph-0-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 414.42801,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 415.79599,
    xlinkHref: "#glyph-0-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 417.164,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 418.53201,
    xlinkHref: "#glyph-0-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 421.89801,
    xlinkHref: "#glyph-0-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 426.26599,
    xlinkHref: "#glyph-0-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 429.96799,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 433.67001,
    xlinkHref: "#glyph-0-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 438.03799,
    xlinkHref: "#glyph-0-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 441.07401,
    xlinkHref: "#glyph-0-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 442.44199,
    xlinkHref: "#glyph-0-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 446.14401,
    xlinkHref: "#glyph-0-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 449.51001,
    xlinkHref: "#glyph-0-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 452.87601,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 456.578,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 457.94601,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 461.64801,
    xlinkHref: "#glyph-0-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 466.34601,
    xlinkHref: "#glyph-0-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 470.048,
    xlinkHref: "#glyph-0-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 474.07999,
    xlinkHref: "#glyph-0-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 475.448,
    xlinkHref: "#glyph-0-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 479.48001,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 483.18201,
    xlinkHref: "#glyph-0-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 487.21399,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 490.91599,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 492.284,
    xlinkHref: "#glyph-0-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 493.65201,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 495.01999,
    xlinkHref: "#glyph-0-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 498.72198,
    xlinkHref: "#glyph-0-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 501.758,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 505.45999,
    xlinkHref: "#glyph-0-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 508.82599,
    xlinkHref: "#glyph-0-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 512.19202,
    xlinkHref: "#glyph-0-26"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 513.89001,
    xlinkHref: "#glyph-0-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 517.59198,
    xlinkHref: "#glyph-0-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 521.29401,
    xlinkHref: "#glyph-0-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 524.65997,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 526.02802,
    xlinkHref: "#glyph-0-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 527.396,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 528.76398,
    xlinkHref: "#glyph-0-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 532.07599,
    xlinkHref: "#glyph-0-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 535.77802,
    xlinkHref: "#glyph-0-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 539.14398,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 540.51202,
    xlinkHref: "#glyph-0-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 543.87799,
    xlinkHref: "#glyph-0-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 547.58002,
    xlinkHref: "#glyph-0-31"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 551.28198,
    xlinkHref: "#glyph-0-32"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 555.31403,
    xlinkHref: "#glyph-0-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 559.01599,
    xlinkHref: "#glyph-0-33"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 562.38202,
    xlinkHref: "#glyph-0-34"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 566.75,
    xlinkHref: "#glyph-0-35"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 571.448,
    xlinkHref: "#glyph-0-31"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 575.15002,
    xlinkHref: "#glyph-0-36"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 579.18201,
    xlinkHref: "#glyph-0-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 582.54797,
    xlinkHref: "#glyph-0-37"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 583.91602,
    xlinkHref: "#glyph-0-38"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 587.61798,
    xlinkHref: "#glyph-0-34"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 591.98602,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.47699,
    y: 593.354,
    xlinkHref: "#glyph-0-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 165.0799,
    xlinkHref: "#glyph-0-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 169.11189,
    xlinkHref: "#glyph-0-39"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 174.8119,
    xlinkHref: "#glyph-0-40"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 178.5139,
    xlinkHref: "#glyph-0-40"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 182.2159,
    xlinkHref: "#glyph-0-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 185.91789,
    xlinkHref: "#glyph-0-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 189.6199,
    xlinkHref: "#glyph-0-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 193.3219,
    xlinkHref: "#glyph-0-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 197.3539,
    xlinkHref: "#glyph-0-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 201.05589,
    xlinkHref: "#glyph-0-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 202.4239,
    xlinkHref: "#glyph-0-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 206.1259,
    xlinkHref: "#glyph-0-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 209.4919,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 210.77953,
    xlinkHref: "#glyph-0-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 212.14752,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 213.43579,
    xlinkHref: "#glyph-0-41"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 219.13579,
    xlinkHref: "#glyph-0-42"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 224.83578,
    xlinkHref: "#glyph-0-43"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 230.5358,
    xlinkHref: "#glyph-0-44"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 236.23579,
    xlinkHref: "#glyph-0-42"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 241.93579,
    xlinkHref: "#glyph-0-45"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 247.63579,
    xlinkHref: "#glyph-0-46"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 253.33578,
    xlinkHref: "#glyph-0-47"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 259.0358,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 260.32407,
    xlinkHref: "#glyph-0-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 261.69205,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 262.98032,
    xlinkHref: "#glyph-0-48"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 268.68033,
    xlinkHref: "#glyph-0-49"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 274.38031,
    xlinkHref: "#glyph-0-50"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 280.08032,
    xlinkHref: "#glyph-0-51"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 285.78033,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 287.06857,
    xlinkHref: "#glyph-0-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 288.43658,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 289.72406,
    xlinkHref: "#glyph-0-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 293.42606,
    xlinkHref: "#glyph-0-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 297.79407,
    xlinkHref: "#glyph-0-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 301.82608,
    xlinkHref: "#glyph-0-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 305.85806,
    xlinkHref: "#glyph-0-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 309.56006,
    xlinkHref: "#glyph-0-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 312.92606,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 316.62805,
    xlinkHref: "#glyph-0-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 320.33008,
    xlinkHref: "#glyph-0-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 323.36606,
    xlinkHref: "#glyph-0-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 327.06805,
    xlinkHref: "#glyph-0-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 330.43405,
    xlinkHref: "#glyph-0-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 333.80008,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 335.08813,
    xlinkHref: "#glyph-0-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 336.45615,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 337.44205,
    xlinkHref: "#glyph-0-52"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 341.52805,
    xlinkHref: "#glyph-0-53"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 343.80804,
    xlinkHref: "#glyph-0-54"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 346.4241,
    xlinkHref: "#glyph-0-55"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 348.84012,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 350.20813,
    xlinkHref: "#glyph-0-56"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 353.07062,
    xlinkHref: "#glyph-0-57"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 354.4086,
    xlinkHref: "#glyph-0-58"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 356.92862,
    xlinkHref: "#glyph-0-59"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 358.56555,
    xlinkHref: "#glyph-0-60"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 362.58429,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 363.9523,
    xlinkHref: "#glyph-0-61"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 366.82629,
    xlinkHref: "#glyph-0-59"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 368.46359,
    xlinkHref: "#glyph-0-62"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 372.86087,
    xlinkHref: "#glyph-0-63"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 377.66437,
    xlinkHref: "#glyph-0-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 379.03235,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 380.31982,
    xlinkHref: "#glyph-0-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 385.01782,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 388.71985,
    xlinkHref: "#glyph-0-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 392.75183,
    xlinkHref: "#glyph-0-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 396.11783,
    xlinkHref: "#glyph-0-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 399.81982,
    xlinkHref: "#glyph-0-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 402.85583,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 404.14404,
    xlinkHref: "#glyph-0-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 405.51205,
    xlinkHref: "#glyph-0-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 409.54404,
    xlinkHref: "#glyph-0-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 413.57605,
    xlinkHref: "#glyph-0-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 414.94406,
    xlinkHref: "#glyph-0-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 418.64606,
    xlinkHref: "#glyph-0-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 420.01404,
    xlinkHref: "#glyph-0-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 424.04605,
    xlinkHref: "#glyph-0-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 428.07806,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 431.78006,
    xlinkHref: "#glyph-0-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 434.81604,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 436.10422,
    xlinkHref: "#glyph-0-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 437.47223,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 438.76047,
    xlinkHref: "#glyph-0-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 442.46246,
    xlinkHref: "#glyph-0-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 446.16446,
    xlinkHref: "#glyph-0-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 449.53046,
    xlinkHref: "#glyph-0-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 453.89847,
    xlinkHref: "#glyph-0-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 457.60046,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 461.30246,
    xlinkHref: "#glyph-0-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 464.33847,
    xlinkHref: "#glyph-0-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 467.37445,
    xlinkHref: "#glyph-0-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 471.07645,
    xlinkHref: "#glyph-0-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 474.77844,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 476.06668,
    xlinkHref: "#glyph-0-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 477.43469,
    xlinkHref: "#glyph-0-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 481.46671,
    xlinkHref: "#glyph-0-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 485.49869,
    xlinkHref: "#glyph-0-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 486.8667,
    xlinkHref: "#glyph-0-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 490.5687,
    xlinkHref: "#glyph-0-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 491.93671,
    xlinkHref: "#glyph-0-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 495.96869,
    xlinkHref: "#glyph-0-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 500.0007,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 503.7027,
    xlinkHref: "#glyph-0-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 506.73871,
    xlinkHref: "#glyph-0-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 510.4407,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 511.72882,
    xlinkHref: "#glyph-0-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 513.0968,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 514.38507,
    xlinkHref: "#glyph-0-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 518.08704,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 521.78906,
    xlinkHref: "#glyph-0-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 525.82104,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 529.52307,
    xlinkHref: "#glyph-0-40"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 533.22504,
    xlinkHref: "#glyph-0-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 537.59308,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 538.88116,
    xlinkHref: "#glyph-0-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 543.57916,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 547.28113,
    xlinkHref: "#glyph-0-19"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 551.31317,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 555.01514,
    xlinkHref: "#glyph-0-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 556.38312,
    xlinkHref: "#glyph-0-26"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 558.08112,
    xlinkHref: "#glyph-0-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 561.44714,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 565.14917,
    xlinkHref: "#glyph-0-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 568.85114,
    xlinkHref: "#glyph-0-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 465.47699,
    y: 570.21912,
    xlinkHref: "#glyph-0-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 456.27301,
    y: 173.8187,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 456.27301,
    y: 182.46561,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 456.27301,
    y: 205.1801,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 456.27301,
    y: 207.7793,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 456.27301,
    y: 239.7677,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 456.27301,
    y: 249.0473,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 456.27301,
    y: 275.59219,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 456.27301,
    y: 278.19141,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 456.27301,
    y: 294.8183,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 456.27301,
    y: 301.24789,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 456.27301,
    y: 318.22821,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 456.27301,
    y: 320.82739,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 456.27301,
    y: 348.98541,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 456.27301,
    y: 357.63229,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 456.27301,
    y: 384.4964,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 456.27301,
    y: 387.09561,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 456.27301,
    y: 429.94821,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 456.27301,
    y: 436.37781,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 456.27301,
    y: 458.14041,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 456.27301,
    y: 460.73959,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 456.27301,
    y: 479.2988,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 456.27301,
    y: 485.72839,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 456.27301,
    y: 509.07559,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 456.27301,
    y: 511.6748,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 456.27301,
    y: 551.01617,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 456.27301,
    y: 557.4458,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 456.27301,
    y: 581.77338,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 450.27301,
    y: 174.63959,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 450.27301,
    y: 196.31328,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 450.27301,
    y: 198.84691,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 450.27301,
    y: 220.21976,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 450.27301,
    y: 233.61696,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 450.27301,
    y: 257.5661,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 450.27301,
    y: 260.1004,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 450.27301,
    y: 296.84048,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 450.27301,
    y: 299.37424,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 450.27301,
    y: 323.63699,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 450.27301,
    y: 326.17111,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 450.27301,
    y: 346.59698,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 450.27301,
    y: 352.96048,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 450.27301,
    y: 379.12634,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 450.27301,
    y: 381.66055,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 450.27301,
    y: 416.13998,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 450.27301,
    y: 432.73547,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 450.27301,
    y: 441.31735,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 450.27301,
    y: 463.96698,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 450.27301,
    y: 466.50128,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 450.27301,
    y: 477.64838,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 450.27301,
    y: 482.39984,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 450.27301,
    y: 508.56552,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 450.27301,
    y: 511.09937,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 450.27301,
    y: 540.17865,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 450.27301,
    y: 557.72607,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 450.27301,
    y: 560.25952,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 450.27301,
    y: 590.88922,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 444.27301,
    y: 344.36298,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 444.27301,
    y: 346.96219,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 444.27301,
    y: 386.6171,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 444.27301,
    y: 391.74707,
    xlinkHref: "#glyph-1-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 436.33801,
    xlinkHref: "#glyph-3-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 439.40869,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 442.76596,
    xlinkHref: "#glyph-3-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 446.39493,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 449.47473,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 451.57211,
    xlinkHref: "#glyph-3-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 455.20355,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 459.11667,
    xlinkHref: "#glyph-3-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 463.3064,
    xlinkHref: "#glyph-3-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 466.66119,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 468.75861,
    xlinkHref: "#glyph-3-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 472.1134,
    xlinkHref: "#glyph-3-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 475.4682,
    xlinkHref: "#glyph-3-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 478.44727,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 481.80453,
    xlinkHref: "#glyph-3-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 485.43353,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 488.7908,
    xlinkHref: "#glyph-3-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 490.18906,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 492.28644,
    xlinkHref: "#glyph-3-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 495.64124,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 497.03705,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 500.39432,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 501.79257,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 503.46915,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 506.45288,
    xlinkHref: "#glyph-3-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 509.34546,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 510.74371,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 512.84113,
    xlinkHref: "#glyph-3-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 516.47253,
    xlinkHref: "#glyph-3-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 517.87079,
    xlinkHref: "#glyph-3-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 521.22559,
    xlinkHref: "#glyph-3-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 524.85706,
    xlinkHref: "#glyph-3-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 527.55396,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 530.91119,
    xlinkHref: "#glyph-3-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 534.54266,
    xlinkHref: "#glyph-3-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 535.94092,
    xlinkHref: "#glyph-3-19"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 539.854,
    xlinkHref: "#glyph-3-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 543.48547,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 544.88373,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 546.98108,
    xlinkHref: "#glyph-3-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 550.33594,
    xlinkHref: "#glyph-3-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 553.96735,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 555.3656,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 557.46301,
    xlinkHref: "#glyph-3-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 558.86127,
    xlinkHref: "#glyph-3-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 562.49268,
    xlinkHref: "#glyph-3-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 566.12415,
    xlinkHref: "#glyph-3-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 567.5224,
    xlinkHref: "#glyph-3-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 570.59552,
    xlinkHref: "#glyph-3-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 573.95038,
    xlinkHref: "#glyph-3-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 577.30518,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 422.01901,
    y: 578.70343,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 436.33554,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 439.66766,
    xlinkHref: "#glyph-3-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 443.18488,
    xlinkHref: "#glyph-3-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 446.23288,
    xlinkHref: "#glyph-3-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 449.56253,
    xlinkHref: "#glyph-3-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 450.93561,
    xlinkHref: "#glyph-3-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 454.26529,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 458.15323,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 460.4433,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 464.63992,
    xlinkHref: "#glyph-3-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 468.24622,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 472.13419,
    xlinkHref: "#glyph-3-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 475.74341,
    xlinkHref: "#glyph-3-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 479.35318,
    xlinkHref: "#glyph-3-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 482.96008,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 488.2739,
    xlinkHref: "#glyph-3-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 491.88019,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 493.25327,
    xlinkHref: "#glyph-3-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 494.62637,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 495.99945,
    xlinkHref: "#glyph-3-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 498.49182,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 500.78189,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 504.11401,
    xlinkHref: "#glyph-3-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 505.76376,
    xlinkHref: "#glyph-3-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 508.53513,
    xlinkHref: "#glyph-3-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 511.30649,
    xlinkHref: "#glyph-3-26"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 514.07788,
    xlinkHref: "#glyph-3-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 516.84924,
    xlinkHref: "#glyph-3-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 519.62061,
    xlinkHref: "#glyph-3-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 522.39197,
    xlinkHref: "#glyph-3-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 525.16333,
    xlinkHref: "#glyph-3-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 529.11066,
    xlinkHref: "#glyph-3-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 531.90973,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 535.24188,
    xlinkHref: "#glyph-3-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 538.57153,
    xlinkHref: "#glyph-3-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 542.18091,
    xlinkHref: "#glyph-3-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 543.55402,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 547.44196,
    xlinkHref: "#glyph-3-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 552.19049,
    xlinkHref: "#glyph-3-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 554.96185,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 558.84979,
    xlinkHref: "#glyph-3-31"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 562.73773,
    xlinkHref: "#glyph-3-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 564.11084,
    xlinkHref: "#glyph-3-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 567.44049,
    xlinkHref: "#glyph-3-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 570.48853,
    xlinkHref: "#glyph-3-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 571.86157,
    xlinkHref: "#glyph-3-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.61862,
    y: 575.4707,
    xlinkHref: "#glyph-3-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 436.33755,
    xlinkHref: "#glyph-3-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 439.05862,
    xlinkHref: "#glyph-3-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 441.77969,
    xlinkHref: "#glyph-3-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 446.53055,
    xlinkHref: "#glyph-3-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 449.52338,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 452.80521,
    xlinkHref: "#glyph-3-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 456.35876,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 460.5563,
    xlinkHref: "#glyph-3-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 464.11234,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 467.94995,
    xlinkHref: "#glyph-3-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 472.06427,
    xlinkHref: "#glyph-3-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 476.53638,
    xlinkHref: "#glyph-3-32"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 479.81577,
    xlinkHref: "#glyph-3-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 483.36929,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 486.65109,
    xlinkHref: "#glyph-3-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 489.93048,
    xlinkHref: "#glyph-3-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 491.25082,
    xlinkHref: "#glyph-3-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 494.96881,
    xlinkHref: "#glyph-3-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 497.66998,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 499.06824,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 500.18484,
    xlinkHref: "#glyph-3-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 502.90594,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 504.3042,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 505.42078,
    xlinkHref: "#glyph-3-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 507.76962,
    xlinkHref: "#glyph-3-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 510.70673,
    xlinkHref: "#glyph-3-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 514.26025,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 518.45789,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 520.97351,
    xlinkHref: "#glyph-3-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 524.52954,
    xlinkHref: "#glyph-3-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 528.08551,
    xlinkHref: "#glyph-3-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 531.36487,
    xlinkHref: "#glyph-3-33"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 533.80426,
    xlinkHref: "#glyph-3-34"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 535.12708,
    xlinkHref: "#glyph-3-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 537.84814,
    xlinkHref: "#glyph-3-26"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 540.56921,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 541.88953,
    xlinkHref: "#glyph-3-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 544.6106,
    xlinkHref: "#glyph-3-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 547.33167,
    xlinkHref: "#glyph-3-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 550.05273,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 551.37311,
    xlinkHref: "#glyph-3-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 554.09418,
    xlinkHref: "#glyph-3-35"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 556.81525,
    xlinkHref: "#glyph-3-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 559.53632,
    xlinkHref: "#glyph-3-36"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 560.85675,
    xlinkHref: "#glyph-3-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 563.57782,
    xlinkHref: "#glyph-3-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 566.29889,
    xlinkHref: "#glyph-3-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 569.01996,
    xlinkHref: "#glyph-3-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 571.74103,
    xlinkHref: "#glyph-3-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 573.34045,
    xlinkHref: "#glyph-3-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 411.2186,
    y: 576.06152,
    xlinkHref: "#glyph-3-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 405.8186,
    y: 436.34268,
    xlinkHref: "#glyph-3-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 405.8186,
    y: 440.73358,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 405.8186,
    y: 444.8479,
    xlinkHref: "#glyph-3-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 405.8186,
    y: 448.68161,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 405.8186,
    y: 456.42395,
    xlinkHref: "#glyph-3-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 405.8186,
    y: 460.26025,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 405.8186,
    y: 464.37454,
    xlinkHref: "#glyph-3-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 405.8186,
    y: 468.76544,
    xlinkHref: "#glyph-3-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 405.8186,
    y: 476.78214,
    xlinkHref: "#glyph-3-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 405.8186,
    y: 480.33813,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 405.8186,
    y: 481.93512,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 405.8186,
    y: 485.49356,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 405.8186,
    y: 487.09299,
    xlinkHref: "#glyph-3-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 405.8186,
    y: 490.64899,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 405.8186,
    y: 496.70865,
    xlinkHref: "#glyph-3-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 405.8186,
    y: 500.26465,
    xlinkHref: "#glyph-3-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 405.8186,
    y: 501.86407,
    xlinkHref: "#glyph-3-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 405.8186,
    y: 510.15863,
    xlinkHref: "#glyph-3-37"
  }), /*#__PURE__*/React.createElement("use", {
    x: 405.8186,
    y: 513.15631,
    xlinkHref: "#glyph-3-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 405.8186,
    y: 516.15405,
    xlinkHref: "#glyph-3-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 405.8186,
    y: 519.15173,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 405.8186,
    y: 520.75116,
    xlinkHref: "#glyph-3-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 405.8186,
    y: 523.7489,
    xlinkHref: "#glyph-3-37"
  }), /*#__PURE__*/React.createElement("use", {
    x: 405.8186,
    y: 526.74658,
    xlinkHref: "#glyph-3-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 405.8186,
    y: 529.74432,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 405.8186,
    y: 531.34375,
    xlinkHref: "#glyph-3-38"
  }), /*#__PURE__*/React.createElement("use", {
    x: 405.8186,
    y: 534.34143,
    xlinkHref: "#glyph-3-39"
  }), /*#__PURE__*/React.createElement("use", {
    x: 405.8186,
    y: 537.33917,
    xlinkHref: "#glyph-3-37"
  }), /*#__PURE__*/React.createElement("use", {
    x: 405.8186,
    y: 537.9527,
    xlinkHref: "#glyph-4-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 405.8186,
    y: 543.0528,
    xlinkHref: "#glyph-4-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 405.8186,
    y: 548.15289,
    xlinkHref: "#glyph-4-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 405.8186,
    y: 550.93427,
    xlinkHref: "#glyph-3-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 405.8186,
    y: 552.53369,
    xlinkHref: "#glyph-3-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 405.8186,
    y: 555.80804,
    xlinkHref: "#glyph-3-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 405.8186,
    y: 559.2179,
    xlinkHref: "#glyph-4-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 405.8186,
    y: 563.91559,
    xlinkHref: "#glyph-4-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 405.8186,
    y: 568.76318,
    xlinkHref: "#glyph-4-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 405.8186,
    y: 573.91241,
    xlinkHref: "#glyph-4-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.41861,
    y: 436.34262,
    xlinkHref: "#glyph-3-40"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.41861,
    y: 438.01752,
    xlinkHref: "#glyph-3-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.41861,
    y: 440.81403,
    xlinkHref: "#glyph-3-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.41861,
    y: 443.61053,
    xlinkHref: "#glyph-3-39"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.41861,
    y: 446.40704,
    xlinkHref: "#glyph-3-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.41861,
    y: 449.20358,
    xlinkHref: "#glyph-3-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.41861,
    y: 450.87845,
    xlinkHref: "#glyph-3-37"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.41861,
    y: 453.67496,
    xlinkHref: "#glyph-3-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.41861,
    y: 456.4715,
    xlinkHref: "#glyph-3-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.41861,
    y: 459.26801,
    xlinkHref: "#glyph-3-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.41861,
    y: 460.9429,
    xlinkHref: "#glyph-3-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.41861,
    y: 463.73941,
    xlinkHref: "#glyph-3-38"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.41861,
    y: 466.53592,
    xlinkHref: "#glyph-3-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.41861,
    y: 469.33243,
    xlinkHref: "#glyph-3-41"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.41861,
    y: 471.00732,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.41861,
    y: 472.40558,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.41861,
    y: 473.95975,
    xlinkHref: "#glyph-3-42"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.41861,
    y: 476.75626,
    xlinkHref: "#glyph-3-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.41861,
    y: 480.38773,
    xlinkHref: "#glyph-3-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.41861,
    y: 484.01917,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.41861,
    y: 485.57333,
    xlinkHref: "#glyph-3-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.41861,
    y: 488.36984,
    xlinkHref: "#glyph-3-26"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.41861,
    y: 491.16635,
    xlinkHref: "#glyph-3-35"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.41861,
    y: 493.96286,
    xlinkHref: "#glyph-3-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.41861,
    y: 496.7594,
    xlinkHref: "#glyph-3-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.41861,
    y: 499.55591,
    xlinkHref: "#glyph-3-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.41861,
    y: 502.35242,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.41861,
    y: 503.75067,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.41861,
    y: 505.30478,
    xlinkHref: "#glyph-5-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.41861,
    y: 510.33447,
    xlinkHref: "#glyph-5-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.41861,
    y: 515.3642,
    xlinkHref: "#glyph-5-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.41861,
    y: 520.39386,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.41861,
    y: 525.42358,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.41861,
    y: 530.45331,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.41861,
    y: 535.48297,
    xlinkHref: "#glyph-5-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.41861,
    y: 540.5127,
    xlinkHref: "#glyph-5-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.41861,
    y: 545.54236,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.41861,
    y: 547.09802,
    xlinkHref: "#glyph-5-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.41861,
    y: 552.12775,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.41861,
    y: 557.15741,
    xlinkHref: "#glyph-5-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.41861,
    y: 562.18713,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.41861,
    y: 563.74176,
    xlinkHref: "#glyph-5-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.41861,
    y: 568.77142,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.41861,
    y: 573.80115,
    xlinkHref: "#glyph-5-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 400.41861,
    y: 578.83087,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.01822,
    y: 436.34222,
    xlinkHref: "#glyph-5-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.01822,
    y: 441.37192,
    xlinkHref: "#glyph-5-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.01822,
    y: 446.40161,
    xlinkHref: "#glyph-5-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.01822,
    y: 451.4313,
    xlinkHref: "#glyph-5-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.01822,
    y: 456.46103,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.01822,
    y: 458.24646,
    xlinkHref: "#glyph-5-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.01822,
    y: 461.04297,
    xlinkHref: "#glyph-5-19"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.01822,
    y: 463.83948,
    xlinkHref: "#glyph-5-19"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.01822,
    y: 466.63599,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.01822,
    y: 468.42184,
    xlinkHref: "#glyph-5-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.01822,
    y: 473.45154,
    xlinkHref: "#glyph-5-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.01822,
    y: 478.48126,
    xlinkHref: "#glyph-5-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.01822,
    y: 483.51096,
    xlinkHref: "#glyph-5-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.01822,
    y: 488.54065,
    xlinkHref: "#glyph-5-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.01822,
    y: 493.57034,
    xlinkHref: "#glyph-5-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.01822,
    y: 498.60007,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.01822,
    y: 500.38544,
    xlinkHref: "#glyph-5-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.01822,
    y: 503.18195,
    xlinkHref: "#glyph-5-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.01822,
    y: 505.97849,
    xlinkHref: "#glyph-5-26"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.01822,
    y: 511.00818,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.01822,
    y: 512.79327,
    xlinkHref: "#glyph-5-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.01822,
    y: 515.58978,
    xlinkHref: "#glyph-5-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.01822,
    y: 518.38629,
    xlinkHref: "#glyph-5-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.01822,
    y: 521.1828,
    xlinkHref: "#glyph-5-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.01822,
    y: 522.85767,
    xlinkHref: "#glyph-5-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.01822,
    y: 525.65417,
    xlinkHref: "#glyph-5-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.01822,
    y: 528.45068,
    xlinkHref: "#glyph-5-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.01822,
    y: 531.24719,
    xlinkHref: "#glyph-5-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.01822,
    y: 532.92212,
    xlinkHref: "#glyph-5-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.01822,
    y: 535.71863,
    xlinkHref: "#glyph-5-31"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.01822,
    y: 538.51514,
    xlinkHref: "#glyph-5-31"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.01822,
    y: 541.31165,
    xlinkHref: "#glyph-5-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.01822,
    y: 544.10846,
    xlinkHref: "#glyph-6-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.01822,
    y: 545.57208,
    xlinkHref: "#glyph-6-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.01822,
    y: 547.71002,
    xlinkHref: "#glyph-3-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.01822,
    y: 551.89728,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.01822,
    y: 555.25458,
    xlinkHref: "#glyph-3-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.01822,
    y: 556.92944,
    xlinkHref: "#glyph-3-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.01822,
    y: 561.1167,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.01822,
    y: 564.474,
    xlinkHref: "#glyph-3-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.01822,
    y: 568.10541,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.01822,
    y: 572.01855,
    xlinkHref: "#glyph-3-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.01822,
    y: 575.64996,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.01822,
    y: 577.43555,
    xlinkHref: "#glyph-3-34"
  }), /*#__PURE__*/React.createElement("use", {
    x: 395.01822,
    y: 578.8338,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.61823,
    y: 436.34247,
    xlinkHref: "#glyph-3-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.61823,
    y: 439.66208,
    xlinkHref: "#glyph-3-43"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.61823,
    y: 441.02512,
    xlinkHref: "#glyph-3-44"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.61823,
    y: 444.94012,
    xlinkHref: "#glyph-3-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.61823,
    y: 448.44479,
    xlinkHref: "#glyph-3-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.61823,
    y: 451.48273,
    xlinkHref: "#glyph-3-45"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.61823,
    y: 457.3479,
    xlinkHref: "#glyph-3-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.61823,
    y: 461.49997,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.61823,
    y: 464.82205,
    xlinkHref: "#glyph-3-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.61823,
    y: 468.41827,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.61823,
    y: 472.29617,
    xlinkHref: "#glyph-3-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.61823,
    y: 477.04709,
    xlinkHref: "#glyph-3-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.61823,
    y: 478.41013,
    xlinkHref: "#glyph-3-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.61823,
    y: 482.60022,
    xlinkHref: "#glyph-3-34"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.61823,
    y: 485.11542,
    xlinkHref: "#glyph-3-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.61823,
    y: 487.87674,
    xlinkHref: "#glyph-3-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.61823,
    y: 490.63803,
    xlinkHref: "#glyph-3-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.61823,
    y: 493.39935,
    xlinkHref: "#glyph-3-39"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.61823,
    y: 496.16064,
    xlinkHref: "#glyph-3-39"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.61823,
    y: 498.92194,
    xlinkHref: "#glyph-3-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.61823,
    y: 501.68326,
    xlinkHref: "#glyph-3-39"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.61823,
    y: 504.44455,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.61823,
    y: 506.95956,
    xlinkHref: "#glyph-3-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.61823,
    y: 508.32257,
    xlinkHref: "#glyph-3-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.61823,
    y: 512.47711,
    xlinkHref: "#glyph-3-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.61823,
    y: 515.79669,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.61823,
    y: 519.67462,
    xlinkHref: "#glyph-3-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.61823,
    y: 523.17944,
    xlinkHref: "#glyph-3-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.61823,
    y: 525.84027,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.61823,
    y: 529.16235,
    xlinkHref: "#glyph-3-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.61823,
    y: 532.75854,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.61823,
    y: 537.78882,
    xlinkHref: "#glyph-3-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.61823,
    y: 541.1084,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.61823,
    y: 544.98633,
    xlinkHref: "#glyph-3-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.61823,
    y: 549.73724,
    xlinkHref: "#glyph-3-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.61823,
    y: 552.77271,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.61823,
    y: 556.09479,
    xlinkHref: "#glyph-3-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.61823,
    y: 559.68854,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.61823,
    y: 563.88525,
    xlinkHref: "#glyph-3-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.61823,
    y: 567.48151,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.61823,
    y: 571.35938,
    xlinkHref: "#glyph-3-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 389.61823,
    y: 575.51392,
    xlinkHref: "#glyph-3-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384.21823,
    y: 436.34238,
    xlinkHref: "#glyph-3-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384.21823,
    y: 440.68298,
    xlinkHref: "#glyph-3-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384.21823,
    y: 444.18869,
    xlinkHref: "#glyph-3-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384.21823,
    y: 447.6944,
    xlinkHref: "#glyph-3-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384.21823,
    y: 449.24353,
    xlinkHref: "#glyph-3-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384.21823,
    y: 453.02588,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384.21823,
    y: 457.08987,
    xlinkHref: "#glyph-3-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384.21823,
    y: 460.87137,
    xlinkHref: "#glyph-3-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384.21823,
    y: 464.37704,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384.21823,
    y: 465.92374,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384.21823,
    y: 469.43188,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384.21823,
    y: 473.21313,
    xlinkHref: "#glyph-3-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384.21823,
    y: 476.99545,
    xlinkHref: "#glyph-3-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384.21823,
    y: 482.73181,
    xlinkHref: "#glyph-3-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384.21823,
    y: 486.51413,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384.21823,
    y: 488.06326,
    xlinkHref: "#glyph-3-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384.21823,
    y: 491.10641,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384.21823,
    y: 492.65555,
    xlinkHref: "#glyph-3-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384.21823,
    y: 496.16125,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384.21823,
    y: 500.22525,
    xlinkHref: "#glyph-3-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384.21823,
    y: 504.00757,
    xlinkHref: "#glyph-3-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384.21823,
    y: 505.5567,
    xlinkHref: "#glyph-3-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384.21823,
    y: 509.06241,
    xlinkHref: "#glyph-3-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384.21823,
    y: 512.84473,
    xlinkHref: "#glyph-3-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384.21823,
    y: 516.06879,
    xlinkHref: "#glyph-3-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384.21823,
    y: 521.80481,
    xlinkHref: "#glyph-3-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384.21823,
    y: 524.75226,
    xlinkHref: "#glyph-3-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384.21823,
    y: 527.69965,
    xlinkHref: "#glyph-3-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384.21823,
    y: 532.88031,
    xlinkHref: "#glyph-3-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384.21823,
    y: 536.66266,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384.21823,
    y: 540.72668,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384.21823,
    y: 544.50604,
    xlinkHref: "#glyph-3-38"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384.21823,
    y: 547.45343,
    xlinkHref: "#glyph-3-26"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384.21823,
    y: 550.40082,
    xlinkHref: "#glyph-3-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384.21823,
    y: 555.58154,
    xlinkHref: "#glyph-3-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384.21823,
    y: 559.36383,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384.21823,
    y: 563.42786,
    xlinkHref: "#glyph-3-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384.21823,
    y: 566.37524,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384.21823,
    y: 570.43927,
    xlinkHref: "#glyph-3-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384.21823,
    y: 574.22162,
    xlinkHref: "#glyph-3-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384.21823,
    y: 575.76825,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 436.34225,
    xlinkHref: "#glyph-3-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 437.62985,
    xlinkHref: "#glyph-3-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 441.15063,
    xlinkHref: "#glyph-3-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 444.67505,
    xlinkHref: "#glyph-3-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 448.20007,
    xlinkHref: "#glyph-3-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 451.44421,
    xlinkHref: "#glyph-3-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 454.40671,
    xlinkHref: "#glyph-3-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 457.92749,
    xlinkHref: "#glyph-3-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 459.21265,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 462.45926,
    xlinkHref: "#glyph-3-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 466.18756,
    xlinkHref: "#glyph-3-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 469.05814,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 472.30478,
    xlinkHref: "#glyph-3-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 474.99063,
    xlinkHref: "#glyph-3-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 477.67648,
    xlinkHref: "#glyph-3-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 480.92065,
    xlinkHref: "#glyph-3-33"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 483.32486,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 488.13004,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 491.37668,
    xlinkHref: "#glyph-3-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 494.0657,
    xlinkHref: "#glyph-3-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 497.58405,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 500.83066,
    xlinkHref: "#glyph-3-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 503.51651,
    xlinkHref: "#glyph-3-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 507.03732,
    xlinkHref: "#glyph-3-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 508.32245,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 512.29602,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 515.54266,
    xlinkHref: "#glyph-3-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 518.50519,
    xlinkHref: "#glyph-3-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 522.02692,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 525.27356,
    xlinkHref: "#glyph-3-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 528.5177,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 532.32013,
    xlinkHref: "#glyph-3-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 535.28265,
    xlinkHref: "#glyph-3-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 538.24268,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 541.48932,
    xlinkHref: "#glyph-3-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 544.17822,
    xlinkHref: "#glyph-3-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 547.69904,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 551.50146,
    xlinkHref: "#glyph-3-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 554.01727,
    xlinkHref: "#glyph-3-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 557.5415,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 558.82904,
    xlinkHref: "#glyph-3-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 561.427,
    xlinkHref: "#glyph-3-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 563.94226,
    xlinkHref: "#glyph-3-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 566.62811,
    xlinkHref: "#glyph-3-39"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 569.31683,
    xlinkHref: "#glyph-3-26"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 572.00275,
    xlinkHref: "#glyph-3-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 574.68848,
    xlinkHref: "#glyph-3-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 378.81784,
    y: 577.37427,
    xlinkHref: "#glyph-3-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.41782,
    y: 436.34216,
    xlinkHref: "#glyph-3-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.41782,
    y: 439.9736,
    xlinkHref: "#glyph-3-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.41782,
    y: 441.37186,
    xlinkHref: "#glyph-3-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.41782,
    y: 445.0033,
    xlinkHref: "#glyph-3-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.41782,
    y: 448.63229,
    xlinkHref: "#glyph-3-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.41782,
    y: 451.98956,
    xlinkHref: "#glyph-3-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.41782,
    y: 455.621,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.41782,
    y: 457.01926,
    xlinkHref: "#glyph-3-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.41782,
    y: 460.6507,
    xlinkHref: "#glyph-3-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.41782,
    y: 464.00549,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.41782,
    y: 465.40378,
    xlinkHref: "#glyph-3-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.41782,
    y: 469.59351,
    xlinkHref: "#glyph-3-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.41782,
    y: 472.9483,
    xlinkHref: "#glyph-3-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.41782,
    y: 476.30313,
    xlinkHref: "#glyph-3-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.41782,
    y: 477.70139,
    xlinkHref: "#glyph-3-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.41782,
    y: 481.33282,
    xlinkHref: "#glyph-3-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.41782,
    y: 485.24594,
    xlinkHref: "#glyph-3-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.41782,
    y: 486.6442,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.41782,
    y: 488.04245,
    xlinkHref: "#glyph-3-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.41782,
    y: 491.67389,
    xlinkHref: "#glyph-3-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.41782,
    y: 494.74704,
    xlinkHref: "#glyph-3-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.41782,
    y: 498.37848,
    xlinkHref: "#glyph-3-34"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.41782,
    y: 499.77673,
    xlinkHref: "#glyph-3-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.41782,
    y: 502.84988,
    xlinkHref: "#glyph-3-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.41782,
    y: 506.48132,
    xlinkHref: "#glyph-3-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.41782,
    y: 510.67108,
    xlinkHref: "#glyph-3-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.41782,
    y: 513.46759,
    xlinkHref: "#glyph-3-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.41782,
    y: 516.2641,
    xlinkHref: "#glyph-3-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.41782,
    y: 519.06061,
    xlinkHref: "#glyph-3-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.41782,
    y: 521.85712,
    xlinkHref: "#glyph-3-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.41782,
    y: 524.65363,
    xlinkHref: "#glyph-3-37"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.41782,
    y: 527.45013,
    xlinkHref: "#glyph-3-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.41782,
    y: 530.80493,
    xlinkHref: "#glyph-3-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.41782,
    y: 534.15979,
    xlinkHref: "#glyph-3-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.41782,
    y: 536.9563,
    xlinkHref: "#glyph-3-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 373.41782,
    y: 538.35455,
    xlinkHref: "#glyph-3-3"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m283.61 567.08v-0.125h-283.34v-566.68h283.21v566.81h0.125v-0.125 0.125h0.125v-567.06h-283.71v567.18h283.71v-0.125",
    fill: "#eb262a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m265.19 22.828c-2.3516 0-4.2539-1.9023-4.2539-4.2539 0-2.3477 1.9023-4.25 4.2539-4.25 2.3477 0 4.25 1.9023 4.25 4.25 0 2.3516-1.9023 4.2539-4.25 4.2539",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m265.19 22.828v-0.125c-1.1406 0-2.1719-0.46484-2.9219-1.2109-0.7461-0.74609-1.207-1.7773-1.207-2.918 0-1.1406 0.46093-2.1719 1.207-2.918 0.75-0.7461 1.7812-1.207 2.9219-1.207 1.1367 0 2.168 0.46093 2.918 1.207 0.74609 0.74609 1.207 1.7773 1.207 2.918 0 1.1406-0.46094 2.1719-1.207 2.918-0.75 0.7461-1.7812 1.2109-2.918 1.2109v0.25c2.418 0 4.375-1.9609 4.375-4.3789s-1.957-4.375-4.375-4.375c-2.4219 0-4.3789 1.957-4.3789 4.375s1.957 4.3789 4.3789 4.3789",
    fill: "#eb262a"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m265.19 552.91c-2.3516 0-4.2539-1.9024-4.2539-4.25 0-2.3516 1.9023-4.2539 4.2539-4.2539 2.3477 0 4.25 1.9023 4.25 4.2539 0 2.3476-1.9023 4.25-4.25 4.25",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m265.19 552.91v-0.125c-1.1406 0-2.1719-0.46094-2.9219-1.207-0.7461-0.75-1.207-1.7773-1.207-2.918 0-1.1406 0.46093-2.1719 1.207-2.918 0.75-0.75 1.7812-1.2109 2.9219-1.2109 1.1367 0 2.168 0.46094 2.918 1.2109 0.74609 0.74609 1.207 1.7773 1.207 2.918 0 1.1406-0.46094 2.168-1.207 2.918-0.75 0.7461-1.7812 1.207-2.918 1.207v0.25c2.418 0 4.375-1.957 4.375-4.375s-1.957-4.3789-4.375-4.3789c-2.4219 0-4.3789 1.9609-4.3789 4.3789s1.957 4.375 4.3789 4.375",
    fill: "#eb262a"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m18.574 22.828c-2.3476 0-4.25-1.9023-4.25-4.2539 0-2.3477 1.9024-4.25 4.25-4.25 2.3516 0 4.2539 1.9023 4.2539 4.25 0 2.3516-1.9023 4.2539-4.2539 4.2539",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m18.574 22.828v-0.125c-1.1406 0-2.1719-0.46484-2.918-1.2109-0.7461-0.74609-1.207-1.7773-1.207-2.918 0-1.1406 0.46094-2.1719 1.207-2.918 0.74609-0.7461 1.7773-1.207 2.918-1.207 1.1406 0 2.1719 0.46093 2.918 1.207 0.7461 0.74609 1.2109 1.7773 1.2109 2.918 0 1.1406-0.46484 2.1719-1.2109 2.918-0.74609 0.7461-1.7773 1.2109-2.918 1.2109v0.25c2.418 0 4.3789-1.9609 4.3789-4.3789s-1.9609-4.375-4.3789-4.375-4.375 1.957-4.375 4.375 1.957 4.3789 4.375 4.3789",
    fill: "#eb262a"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m18.574 552.91c-2.3476 0-4.25-1.9024-4.25-4.25 0-2.3516 1.9024-4.2539 4.25-4.2539 2.3516 0 4.2539 1.9023 4.2539 4.2539 0 2.3476-1.9023 4.25-4.2539 4.25",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m18.574 552.91v-0.125c-1.1406 0-2.1719-0.46094-2.918-1.207-0.7461-0.75-1.207-1.7773-1.207-2.918 0-1.1406 0.46094-2.1719 1.207-2.918 0.74609-0.75 1.7773-1.2109 2.918-1.2109 1.1406 0 2.1719 0.46094 2.918 1.2109 0.7461 0.74609 1.2109 1.7773 1.2109 2.918 0 1.1406-0.46484 2.168-1.2109 2.918-0.74609 0.7461-1.7773 1.207-2.918 1.207v0.25c2.418 0 4.3789-1.957 4.3789-4.375s-1.9609-4.3789-4.3789-4.3789-4.375 1.9609-4.375 4.3789 1.957 4.375 4.375 4.375",
    fill: "#eb262a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#231f20"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m115.06 542.97h-4.6875v1.5391h4.6875zm1.5976 3.1367h-14.148v-1.5586h6.2539v-1.5898h-6.2617v-1.5781h14.156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.66 539.81h-1.5625v-1.5508h-4.7226v1.5273h-1.582v-1.5312h-4.7266v1.5352h-1.582v-3.1289h14.176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.48 550.83v-3.1484h14.176v3.1484h-1.5742v-1.5547h-11.023v1.5547"
  })))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m57.105 553.01c0.21485 0.0703 0.40235 0.125 0.58985 0.19141 0.0898 0.0352 0.14062 0.0117 0.20703-0.0547 0.41797-0.41406 0.83984-0.82812 1.2578-1.2422l0.082-0.0937c-0.21875-0.0391-0.42187-0.082-0.625-0.10938l-0.18359 0.0586c-0.24219 0.21875-0.47656 0.44532-0.71484 0.66797-0.19532 0.1875-0.39454 0.375-0.61329 0.58203m2.0078-16.117c-0.22657-0.0703-0.41407-0.1211-0.59375-0.1836l-0.19922 0.0469c-0.4336 0.4375-0.875 0.875-1.3164 1.3086l-0.0664 0.0859c0.24609 0.0469 0.47656 0.0898 0.71093 0.12891l0.0937-0.043c0.44922-0.4375 0.89844-0.87891 1.3711-1.3438m-3.5274 15.465c0.21875 0.10547 0.45703 0.21484 0.69532 0.33594l0.17968-0.0273c0.375-0.35156 0.75782-0.70312 1.1328-1.0508l0.16406-0.15625c-0.30078-0.12109-0.58203-0.23047-0.86719-0.33984l-0.10937 0.0195c-0.40235 0.40234-0.79297 0.80859-1.1953 1.2188m2.8829-13.863c0.26171 0.10547 0.52343 0.20312 0.78125 0.31641l0.19531-0.0391c0.36719-0.375 0.74219-0.73828 1.1133-1.1055l0.0859-0.0977c-0.26953-0.12891-0.52344-0.25-0.78125-0.36328l-0.14063 0.0273c-0.13281 0.11719-0.2539 0.24219-0.375 0.36719-0.28906 0.29687-0.57812 0.58984-0.8789 0.89453m-2.1016 12.375c-0.27343-0.16016-0.5664-0.33594-0.85937-0.51563l-0.1875 0.0195c-0.34375 0.34765-0.69141 0.6875-1.0352 1.0273l-0.0703 0.0859c0.31641 0.21484 0.62109 0.42578 0.9375 0.64062 0.40625-0.42187 0.80859-0.83984 1.2148-1.2578m3.4531-11.805c0.30469 0.19141 0.6289 0.38281 0.95703 0.58203 0.42578-0.40625 0.84375-0.80859 1.2695-1.2226-0.33984-0.22266-0.65625-0.42969-0.98437-0.64453-0.41797 0.43359-0.82813 0.85546-1.2422 1.2852m-2.5938 2.6797c0.0156-0.23828 0.0234-0.47656 0.0508-0.71094 0.0117-0.12109-0.0156-0.15625-0.14063-0.17187-0.59375-0.0586-1.1836-0.12891-1.7734-0.20313-0.1211-0.0117-0.26172-0.0937-0.35157-0.0547-0.0937 0.043-0.13671 0.19141-0.20312 0.29688-0.10938 0.1875-0.21875 0.37109-0.33594 0.56641 0.91406 0.2539 1.8203 0.30078 2.7539 0.27734m-5.7227-3.5117-0.0859 0.0977c-1.2266 1.2891-1.7656 2.8516-1.8008 4.6055-0.0195 1.1602 0.19922 2.2812 0.60547 3.3672 0.65235 1.7344 1.7031 3.1992 3.0664 4.4453 0.20312 0.18359 0.41406 0.35546 0.58594 0.50781 0.42578-0.40235 0.83203-0.79297 1.25-1.1875l-0.15625-0.12891c-1.0312-0.8164-1.8867-1.7852-2.5352-2.9297-0.65234-1.1445-1.0664-2.3594-1.1211-3.6875-0.0391-1.0586 0.15625-2.0664 0.70312-2.9844 0.19141-0.31641 0.41797-0.60547 0.70313-0.89063 0.41796 0.41407 0.82421 0.82422 1.2266 1.2188v-3.5898h-3.6016c0.39453 0.39063 0.77343 0.76953 1.1602 1.1562m9.6328 6.0664c0.14844-0.33594 0.29297-0.65625 0.44141-0.98828-0.44922-0.26172-0.88281-0.51563-1.332-0.77735 0.15625-0.13672 0.29687-0.26172 0.44531-0.38672 0.47656 0.31641 0.94531 0.625 1.4258 0.94141 0.16016-0.31641 0.31641-0.62109 0.47657-0.9375-0.41407-0.23438-0.81641-0.46094-1.2266-0.69531l0.13672-0.25c-0.22265-0.13282-0.43359-0.26172-0.64844-0.38672-0.125-0.0742-0.26171-0.21094-0.3789-0.19922-0.11719 0.0156-0.22266 0.17578-0.32813 0.27734l-0.23047 0.21094c-0.21484 0.20703-0.43359 0.41406-0.66015 0.625-0.14453-0.12891-0.28125-0.24219-0.41016-0.36719l-0.0742-0.16406c-8e-3 -0.17187 0-0.34766 0-0.50391h-1.2344c0.0273 0.45704 0.0469 0.89063 0.0703 1.3281h-3.668v1.1523h3.7734c0.0273 0.1836 0.0469 0.33594 0.0664 0.49219-0.10547 0.0352-0.19922 0.0664-0.29297 0.10156 0.0664 0.29297 0.1289 0.57813 0.19531 0.875h-2.168l-0.0273-0.20312c0.61718-0.11328 1.2148-0.23047 1.8281-0.34375-0.0391-0.25-0.0703-0.48047-0.10937-0.71875-0.69532 0.082-1.375 0.16797-2.0586 0.25 0.0195 0.13281 0.0352 0.2539 0.0586 0.40625h-1.2266c0.1836 0.91015 0.36329 1.793 0.54297 2.6797 0.44532-0.0156 0.8711-0.0312 1.3125-0.0469-0.0508-0.28125-0.10547-0.53906-0.16015-0.82031h2.6289v0.75l-0.1875 0.0195c-0.88281 0.10547-1.7734 0.19922-2.6562 0.32031-0.45703 0.0664-0.88672 0.23438-1.2344 0.55469-0.48828 0.44922-0.4375 1.0508 0.13672 1.375 0.26172 0.15234 0.5664 0.22656 0.85156 0.33203 0.10937 0.0391 0.20703 8e-3 0.3125-0.0391 0.33984-0.15235 0.67969-0.29688 1.0234-0.44531l0.11328-0.0586c-0.1875-0.0781-0.3711-0.14844-0.53906-0.23828l-0.19532-0.19141 0.23047-0.14843c0.29297-0.0742 0.58985-0.14844 0.89453-0.19532 0.38672-0.0586 0.77735-0.0937 1.1992-0.14062v1.3242h1.2695c-0.0195-0.44922-0.0351-0.87891-0.0508-1.3281 0.49219 0.0234 0.96875 0.0391 1.4453 0.0664l0.0859 0.0898c0.0312 0.16016 0.0391 0.32032 0.0664 0.47657 0.0312 0.22265 0.0742 0.4414 0.11328 0.67578 0.46484-0.16797 0.89844-0.32813 1.332-0.48828-0.28516-1.293-0.42187-2.5859-0.46094-3.9141h-3.8242l-4e-3 -0.0312c0.45703-0.18359 0.91797-0.37109 1.3828-0.55859-0.0781-0.27344-0.15234-0.53906-0.23437-0.80859-0.16797 0.043-0.31641 0.0859-0.48047 0.13281-0.0195-0.25-0.0312-0.47656-0.0469-0.73438 0.78125 0.56641 1.5274 1.1094 2.2891 1.6524m-1.8008 9.2109h-9.75v-17.09h7.1719l-0.0937 0.11719c-0.52344 0.52734-1.0469 1.0508-1.5781 1.5703l-0.13672 0.0664 0.0508 0.0586c0.25-0.0312 0.5-0.0586 0.74609-0.0977l0.12891-0.0781c0.5-0.48828 0.99609-0.97656 1.4961-1.4688l0.0703-0.0859c-0.17969-0.0312-0.34765-0.0586-0.51172-0.082h9.6953v9.8359l-0.0234-0.0977c-0.0664-0.94531-0.30469-1.8476-0.64844-2.7266-0.72266-1.8438-1.9141-3.3477-3.4102-4.625l-0.19531-0.15625c-0.42187 0.41797-0.83203 0.82422-1.2461 1.2344l8e-3 0.0117 0.0977 0.082c0.76953 0.60547 1.4453 1.3008 2.0156 2.0977 0.98047 1.3672 1.6133 2.8633 1.6875 4.5664 0.0469 1.2383-0.23047 2.3789-0.98047 3.3828-0.11328 0.14844-0.23828 0.28906-0.38672 0.46094-0.41796-0.42188-0.8125-0.82422-1.2226-1.2383v3.6094h3.6523c-0.41797-0.41797-0.80859-0.80469-1.1992-1.1953l0.0469-0.0586c0.82422-0.85156 1.3594-1.8633 1.6211-3.0156 0.0781-0.34766 0.1211-0.70313 0.1836-1.0586v5.9805h-7.2031l0.0977-0.11328c0.50781-0.50781 1.0156-1.0117 1.5234-1.5156l0.12891-0.14063c-0.26953 0.0312-0.50391 0.0586-0.73437 0.0977l-0.10938 0.0781c-0.47266 0.46875-0.94141 0.94141-1.4141 1.4102l-0.0859 0.10156c0.17969 0.0274 0.34375 0.0547 0.50781 0.082",
    fill: "#fff"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#231f20",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m66.625 547.53c-0.0625 0.35546-0.10547 0.71093-0.1836 1.0625-0.26172 1.1484-0.79687 2.1602-1.6211 3.0117l-0.0469 0.0586c0.39063 0.39062 0.78125 0.77734 1.1992 1.1953h-3.6523v-3.6055c0.41015 0.41406 0.80859 0.8125 1.2226 1.2344 0.14844-0.17188 0.27344-0.3086 0.38672-0.46094 0.75-1.0039 1.0312-2.1445 0.97657-3.3828-0.0703-1.7031-0.70704-3.1992-1.6836-4.5664-0.57031-0.79687-1.2461-1.4922-2.0156-2.0977l-0.0977-0.082-8e-3 -0.0117c0.41406-0.41015 0.82422-0.8164 1.2461-1.2344l0.19531 0.15625c1.4922 1.2773 2.6836 2.7812 3.4102 4.625 0.34375 0.87891 0.58203 1.7852 0.64844 2.7266l0.0234 0.0977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.93 536.42c0.16407 0.0234 0.33203 0.0547 0.51172 0.082l-0.0742 0.0899c-0.49609 0.48828-0.99609 0.97656-1.4961 1.4688l-0.12891 0.0781c-0.24609 0.0352-0.49218 0.0625-0.74218 0.0937l-0.0508-0.0586 0.13672-0.0664c0.53125-0.51953 1.0547-1.043 1.5781-1.5703l0.0937-0.11719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.336 553.51c-0.16406-0.0273-0.32812-0.0508-0.51172-0.082l0.0937-0.10156c0.46875-0.46875 0.9375-0.94141 1.4102-1.4062l0.10938-0.082c0.23046-0.0391 0.46484-0.0664 0.73437-0.0977l-0.12891 0.14063c-0.51171 0.5039-1.0156 1.0078-1.5234 1.5156l-0.0977 0.11328"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.508 546.56h1.3828v-0.70703h-1.418c0.0117 0.23437 0.0195 0.46094 0.0352 0.70703m1.6289-2.2578c-0.75781-0.54688-1.5078-1.0898-2.2891-1.6524 0.0156 0.25782 0.0312 0.48047 0.0469 0.73047 0.16406-0.043 0.3125-0.0859 0.48437-0.1289 0.0742 0.26953 0.15235 0.53515 0.23047 0.80859-0.46484 0.1875-0.92578 0.375-1.3828 0.55859l4e-3 0.0312h3.8242c0.0391 1.3281 0.17578 2.6211 0.46094 3.9141-0.4375 0.16015-0.86719 0.3164-1.332 0.48828-0.0391-0.23438-0.082-0.45313-0.11328-0.67578-0.0274-0.15625-0.0391-0.31641-0.0664-0.47657l-0.0898-0.0898c-0.47266-0.0273-0.94922-0.043-1.4414-0.0664 0.0156 0.44532 0.0312 0.88282 0.0508 1.3281h-1.2695v-1.3242c-0.42578 0.0469-0.8125 0.082-1.1992 0.14062-0.30078 0.0469-0.60156 0.11719-0.89843 0.19532l-0.22657 0.14843 0.19141 0.19141c0.17187 0.0898 0.35547 0.16016 0.53906 0.23828l-0.10937 0.0586c-0.34375 0.14843-0.6875 0.29296-1.0234 0.44531-0.10547 0.0469-0.20703 0.0781-0.3125 0.0391-0.28516-0.10547-0.59375-0.17969-0.85156-0.32812-0.57422-0.32813-0.625-0.92969-0.13672-1.3789 0.34765-0.32031 0.77734-0.49219 1.2344-0.55469 0.88282-0.12109 1.7734-0.21484 2.6562-0.32031l0.1875-0.0195v-0.75h-2.6289c0.0547 0.28125 0.10547 0.53906 0.16015 0.82031-0.4414 0.0156-0.86718 0.0312-1.3125 0.0469-0.17968-0.88672-0.35937-1.7695-0.54297-2.6797h1.2227c-0.0195-0.15235-0.0391-0.27344-0.0547-0.40625 0.6836-0.082 1.3633-0.16797 2.0586-0.25 0.0351 0.23828 0.0703 0.46875 0.10937 0.71875-0.61328 0.11328-1.2109 0.23047-1.8281 0.34375l0.0273 0.20312h2.168c-0.0664-0.29687-0.12891-0.58203-0.19531-0.8789 0.0937-0.0312 0.1875-0.0625 0.28906-0.0977-0.0156-0.15625-0.0391-0.30859-0.0625-0.49219h-3.7734v-1.1523h3.668c-0.0234-0.44141-0.043-0.87109-0.0703-1.3281h1.2344c0 0.15625-8e-3 0.33204 0 0.50391l0.0742 0.16406c0.12891 0.125 0.26563 0.23828 0.41016 0.36719 0.22656-0.21484 0.4414-0.42187 0.66015-0.625l0.23047-0.21484c0.10547-0.0977 0.21094-0.25782 0.32813-0.26953 0.11719-0.0156 0.2539 0.12109 0.3789 0.19531 0.21485 0.125 0.42579 0.2539 0.64844 0.38672l-0.14062 0.25c0.41406 0.23047 0.8164 0.46093 1.2305 0.69531-0.16016 0.31641-0.31641 0.62109-0.47657 0.93359-0.48047-0.3164-0.94922-0.625-1.4258-0.9414-0.14844 0.125-0.28906 0.2539-0.44922 0.39062 0.45313 0.26172 0.88672 0.51563 1.332 0.77735-0.14453 0.33203-0.28906 0.65234-0.4375 0.98828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.504 538.23c-0.38672-0.38672-0.76953-0.76562-1.1602-1.1562h3.6016v3.5938c-0.40235-0.40234-0.8086-0.80859-1.2266-1.2227-0.28516 0.28516-0.51563 0.57032-0.70313 0.89063-0.54687 0.91797-0.74219 1.9258-0.70312 2.9844 0.0508 1.3281 0.46875 2.543 1.1211 3.6875 0.65234 1.1445 1.5039 2.1172 2.5352 2.9258l0.15625 0.13281c-0.41797 0.39453-0.82422 0.78125-1.2461 1.1836-0.17969-0.14844-0.39062-0.32031-0.58594-0.5039-1.3672-1.2461-2.418-2.707-3.0703-4.4453-0.40625-1.0859-0.625-2.207-0.60547-3.3672 0.0352-1.7539 0.57422-3.3125 1.8008-4.6055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.227 541.75c-0.9336 0.0195-1.8398-0.0234-2.7539-0.28125 0.11719-0.19922 0.22656-0.37891 0.33594-0.56641 0.0625-0.10156 0.10937-0.25391 0.20312-0.29688 0.0899-0.0391 0.23047 0.043 0.35157 0.0547 0.58984 0.0742 1.1797 0.14453 1.7734 0.20313 0.125 0.0156 0.15235 0.0547 0.14063 0.17187-0.0273 0.23438-0.0352 0.47266-0.0508 0.71485"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.82 539.07c0.41406-0.42969 0.82422-0.85156 1.2422-1.2852 0.32812 0.21484 0.64843 0.42578 0.98437 0.64453-0.42578 0.41406-0.84375 0.8164-1.2695 1.2226-0.32813-0.19922-0.64844-0.39453-0.95703-0.58203"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.367 550.88c-0.40625 0.41796-0.80859 0.83203-1.2148 1.2539-0.31641-0.21484-0.62109-0.42187-0.9375-0.64062l0.0703-0.0859c0.34766-0.33984 0.69141-0.67969 1.0352-1.0234l0.1875-0.0273c0.29297 0.18359 0.58594 0.35937 0.85937 0.52344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.469 538.5c0.30078-0.3086 0.58984-0.60547 0.8789-0.89844 0.1211-0.125 0.24219-0.25 0.375-0.36719l0.14063-0.0273c0.25781 0.11328 0.51172 0.23437 0.78125 0.36328l-0.0859 0.0977c-0.37109 0.36719-0.74609 0.73047-1.1133 1.1016l-0.19922 0.043c-0.25781-0.11329-0.51563-0.21094-0.77734-0.3125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.586 552.36c0.39844-0.41016 0.79297-0.81641 1.1914-1.2188l0.11328-0.0195c0.28516 0.10547 0.56641 0.21875 0.86719 0.33984l-0.16406 0.15625c-0.375 0.34766-0.75782 0.69532-1.1328 1.0508l-0.18359 0.0273c-0.23438-0.1211-0.47266-0.23047-0.69141-0.33594"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.113 536.89c-0.47266 0.46484-0.92188 0.90625-1.3711 1.3438l-0.0937 0.043c-0.23437-0.0391-0.46484-0.082-0.71093-0.12891l0.0703-0.0859c0.4375-0.43359 0.8789-0.87109 1.3125-1.3086l0.19922-0.0469c0.17968 0.0625 0.36718 0.11328 0.59375 0.1836"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.105 553.01c0.21875-0.20703 0.41797-0.39453 0.61329-0.58203 0.23828-0.22265 0.47265-0.44922 0.71484-0.66797l0.18359-0.0586c0.20313 0.0273 0.40625 0.0703 0.625 0.10938l-0.082 0.0937c-0.41797 0.41406-0.83984 0.82812-1.2578 1.2422-0.0664 0.0664-0.11719 0.0899-0.20703 0.0547-0.1875-0.0664-0.375-0.12109-0.58985-0.19141"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m59.508 546.56c-0.0156-0.24609-0.0234-0.47266-0.0352-0.70703h1.418v0.70703",
    fill: "#fff",
    fillRule: "evenodd"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#231f20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m100.18 22.027 1.1758 1.2266-0.59375 0.0156 8e-3 1.0547 8e-3 1.0508 0.0625 0.18359c0.0352 0.10156 0.10157 0.23438 0.14453 0.29688 0.26172 0.38281 0.75 0.47656 1.2656 0.23828 0.0742-0.0312 0.69141-0.38282 1.375-0.78125 0.68359-0.39453 1.25-0.71094 1.2578-0.70313l0.53125 0.94141c-8e-3 4e-3 -0.5625 0.32422-1.2383 0.71484-1.3711 0.79297-1.4961 0.86328-1.8125 0.96485-1.2188 0.41015-2.2148-0.082-2.5547-1.2539-0.10156-0.35938-0.10547-0.39844-0.12109-1.5703l-0.0117-1.125-0.68359-0.0234"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.727 17.957c0.13281-0.76563 0.5-1.3242 1.0391-1.5859 0.23438-0.10937 0.39063-0.14453 0.69922-0.15625 0.32422-0.0156 0.54687 0.0195 0.89453 0.13672 0.29297 0.0977 0.52734 0.21484 1.3281 0.67969 0.36718 0.21484 0.67187 0.38672 0.67187 0.38281l0.31641-0.51172 0.46093 1.6328-1.6406 0.40235 0.26562-0.58203c-0.0898-0.0703-1.4258-0.83204-1.5391-0.88282-0.19531-0.0859-0.39453-0.125-0.58203-0.11328-0.40234 0.0234-0.66406 0.24219-0.8125 0.67188l-0.0547 0.17187-8e-3 1.5625-8e-3 1.5586h-1.0742v-1.5703c0-1.4062 8e-3 -1.5976 0.043-1.7969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.2 18.516c0.0195-0.0195 2.3711 1.332 2.6289 1.5117 0.28906 0.19531 0.59766 0.49609 0.76563 0.74219 0.10156 0.14844 0.23437 0.44531 0.28125 0.63281 0.12109 0.47656-4e-3 1.0273-0.33204 1.4727-0.16015 0.21875-0.50781 0.53906-0.75781 0.70703-0.12109 0.0781-0.53906 0.32422-0.92578 0.55078-0.38672 0.21875-0.70703 0.40625-0.71094 0.41016l0.28125 0.52343-1.6406-0.41015 0.46094-1.6211 0.35156 0.54297c0.0312 0 1.4688-0.83984 1.6133-0.9375 0.37109-0.26172 0.55859-0.64844 0.49609-0.98828-0.0547-0.26953-0.23828-0.53516-0.5-0.71484-0.0664-0.0469-0.66406-0.39844-1.3242-0.78125-0.66015-0.38282-1.2031-0.70703-1.207-0.71875 0.15625-0.3125 0.32813-0.62891 0.51953-0.92188"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.81 21.516h-0.50781v-1.9688h0.38281l0.75391 0.69531c0.51953 0.48047 0.65625 0.5625 0.90234 0.5625 0.25 0 0.40625-0.16796 0.40625-0.49218 0-0.33985-0.13281-0.57813-0.24609-0.69922v-8e-3h0.61328c0.0859 0.13671 0.1914 0.41406 0.1914 0.79296 0 0.65235-0.375 1.0547-0.91406 1.0547-0.41797 0-0.70703-0.17187-1.2305-0.69531l-0.35156-0.35156v1.082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.81 23.812h-0.50781v-1.9648h0.38281l0.75391 0.69532c0.51953 0.48046 0.65625 0.5625 0.90234 0.5625 0.25 0 0.40625-0.17188 0.40625-0.49219 0-0.33985-0.13281-0.57813-0.24609-0.69922v-8e-3h0.61328c0.0859 0.13672 0.1914 0.41406 0.1914 0.78906 0 0.65625-0.375 1.0586-0.91406 1.0586-0.41797 0-0.70703-0.17187-1.2305-0.69531l-0.35156-0.35156v1.082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.664 19.34-0.0156 0.20313c0 0.3125 0.15235 0.5039 0.42188 0.5039 0.2539 0 0.39062-0.17578 0.39062-0.46484 0-0.11719-8e-3 -0.19922-0.0195-0.24219zm1.0703-0.41797c0.0273 0.14844 0.0469 0.35938 0.0469 0.64063 0 0.30859-0.0625 0.53125-0.1875 0.67968-0.11329 0.13672-0.29297 0.22657-0.50782 0.22657-0.21484 0-0.39453-0.0703-0.51953-0.19922-0.16406-0.16797-0.24609-0.42969-0.24609-0.72656l0.0156-0.20313h-0.86328v-0.41797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.438 21.867 0.5664-0.18359c0.13672-0.043 0.29688-0.0781 0.42578-0.11328v-8e-3c-0.1289-0.0352-0.29297-0.0703-0.42578-0.10938l-0.5664-0.17578zm-0.31641-0.66015-0.64844-0.19531v-0.4336l2.293 0.73828v0.53125l-2.293 0.75v-0.44922l0.64844-0.21093"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.664 23.492-0.0156 0.20704c0 0.3125 0.15235 0.5039 0.42188 0.5039 0.2539 0 0.39062-0.17578 0.39062-0.46875 0-0.11328-8e-3 -0.19531-0.0195-0.24219zm1.0703-0.41406c0.0273 0.14844 0.0469 0.35938 0.0469 0.64063 0 0.30859-0.0625 0.53125-0.1875 0.67968-0.11329 0.13672-0.29297 0.22657-0.50782 0.22657-0.21484 0-0.39453-0.0703-0.51953-0.19922-0.16406-0.16797-0.24609-0.42969-0.24609-0.72656l0.0156-0.20704h-0.86328v-0.41406"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-358.41 -87.504)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 541.87097,
    y: 487.51999,
    xlinkHref: "#glyph-14-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 541.87097,
    y: 484.23203,
    xlinkHref: "#glyph-14-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 541.87097,
    y: 475.72403,
    xlinkHref: "#glyph-14-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 541.87097,
    y: 467.61203,
    xlinkHref: "#glyph-14-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 541.87097,
    y: 464.32404,
    xlinkHref: "#glyph-14-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 541.87097,
    y: 457.16003,
    xlinkHref: "#glyph-14-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 541.87097,
    y: 453.87207,
    xlinkHref: "#glyph-14-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 541.87097,
    y: 445.76007,
    xlinkHref: "#glyph-14-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 541.87097,
    y: 437.57593,
    xlinkHref: "#glyph-14-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 541.87097,
    y: 429.91989,
    xlinkHref: "#glyph-14-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 541.87097,
    y: 424.08801,
    xlinkHref: "#glyph-14-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 541.87097,
    y: 417.20004,
    xlinkHref: "#glyph-14-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 541.87097,
    y: 408.52408,
    xlinkHref: "#glyph-14-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 541.87097,
    y: 400.44806,
    xlinkHref: "#glyph-14-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 541.87097,
    y: 393.45206,
    xlinkHref: "#glyph-14-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 541.87097,
    y: 387.60809,
    xlinkHref: "#glyph-14-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 541.87097,
    y: 380.21613,
    xlinkHref: "#glyph-14-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 541.87097,
    y: 373.07614,
    xlinkHref: "#glyph-14-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 541.87097,
    y: 366.18814,
    xlinkHref: "#glyph-14-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 541.87097,
    y: 356.56412,
    xlinkHref: "#glyph-14-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 541.87097,
    y: 349.46024,
    xlinkHref: "#glyph-14-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 541.87097,
    y: 343.88019,
    xlinkHref: "#glyph-14-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 541.87097,
    y: 335.20294,
    xlinkHref: "#glyph-14-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 541.87097,
    y: 327.12692,
    xlinkHref: "#glyph-14-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 541.87097,
    y: 320.62296,
    xlinkHref: "#glyph-14-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 541.87097,
    y: 313.73495,
    xlinkHref: "#glyph-14-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 541.87097,
    y: 305.61075,
    xlinkHref: "#glyph-14-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 541.87097,
    y: 297.49872,
    xlinkHref: "#glyph-14-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 541.87097,
    y: 288.33054,
    xlinkHref: "#glyph-14-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 541.87097,
    y: 283.03836,
    xlinkHref: "#glyph-14-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 541.87097,
    y: 275.38235,
    xlinkHref: "#glyph-14-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 541.87097,
    y: 267.84634,
    xlinkHref: "#glyph-14-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 541.87097,
    y: 262.01453,
    xlinkHref: "#glyph-14-7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m259.33 256.02h-11.965v-2.0156h11.965zm-0.50391 14.738c0.54688 0.6211 0.74219 1.3633 0.74219 2.3203 0 0.95312-0.19531 1.6914-0.74219 2.3164-0.85547 0.99219-2.3047 1.5195-5.5 1.5195s-4.6445-0.52734-5.5039-1.5195c-0.54296-0.625-0.73828-1.3633-0.73828-2.3164 0-0.95703 0.19532-1.6992 0.73828-2.3203 0.85938-0.97656 2.3086-1.5195 5.5039-1.5195s4.6445 0.54297 5.5 1.5195m-3.8359 25-0.0391 0.0312-4.8242-1.7578 4.8633-1.7656zm-1.6172 4.8086v1.8867h-6.0078v-1.6524c0-1.5312 0.89063-2.3125 2.8789-2.3125 1.8789 0 3.0195 0.75782 3.1289 2.0781m1.6172 11.414-0.0391 0.0273-4.8242-1.7539 4.8633-1.7695zm1.0352-66.184c1.9883 0 3.3047 1.168 3.3047 4.0898v2.1523h-5.8867v-0.77734c0-1.4805 0.76172-2.3164 1.9844-2.3164v-0.27343h-4.5v0.27343c1.2656 0 2.0352 0.83594 2.0352 2.3164v0.77734h-5.5977v-2.2188c0-2.2773 1.1367-3.1914 2.8516-3.1914v-0.27735h-3.3281v11.902l9.5469 3.2969-9.5469 3.5547v3.8438h0.47656v-1.5859h4.1602c-2.8438 0.6875-4.918 2.957-4.918 5.7148 0 2.8594 2.2461 5.1992 5.2578 5.7812h-4.5v-1.668h-0.47656v5.2812h0.47656v-1.6719h5.5977v5.6719h-5.5977v-1.668h-0.47656v5.2812h0.47656v-1.668h11.734l-12.41 4.5156-0.0703 0.0273v0.32031l8.3203 3.0274-0.0156 0.0156c-0.55469 0.39453-0.94922 0.94922-1.1992 1.6602-0.13672 0.38672-0.22656 0.82031-0.26953 1.293-0.0274-0.082-0.0508-0.17188-0.082-0.26563-0.15625-0.47656-0.39063-1.0117-0.7461-1.4922-0.61719-0.83593-1.4219-1.2617-2.3828-1.2617-1.4297 0-2.4883 0.83985-3.0039 2.2891-0.21484 0.59765-0.33593 1.2969-0.35156 2.082v5.8867h0.47656v-1.8555h11.68l-12.355 4.4961-0.0703 0.0234v0.32422l8.5195 3.1016 0.35156 0.125 0.36719 0.13281v4e-3c1.3867 0.53125 2.2891 1.082 2.8398 1.8438 0.55469 0.76562 0.62891 1.7461 0.62891 3.1367v1.3828l-12.086-6.9766-0.35156-0.20703v9.2266h4.6797v-0.35156h-0.0898c-1.2656 0-2.207-0.41016-2.9609-1.1602-0.375-0.375-0.66407-0.80859-0.85157-1.3125-0.19921-0.5-0.30078-1.0664-0.30078-1.6797v-1.8945l12.09 6.9805 0.35156 0.20313v-10.035h-4.3164v-3.7188l3.8359-1.3984v1.5938h0.48047v-7.9141h-0.48047v1.8672h-5.6016v-2.2734c0-1.0273 0.42578-2.2539 2.3594-2.2539h1.168c1.0664 0 2.8633-0.36328 2.8633-2.8125 0-0.67578-0.17968-1.2109-0.52734-1.5508l-0.0664-0.0664-0.24609 0.21484 0.0586 0.0703c0.17969 0.23047 0.32422 0.41406 0.32422 0.85938 0 0.64453-0.625 1.0312-1.6562 1.0312h-0.95312c-0.38282 0-0.94532 0.0547-1.5234 0.30859l-4e-3 4e-3 -0.0312-0.0117v-3.8906l3.8359-1.3984v1.5938h0.48047v-5.8047h-4e-3v-1.668h-0.47265v1.668h-5.8867v-5.6719h5.8867v1.6719h0.47265v-5.2812h-0.47265v1.668h-4.543c3.0117-0.58203 5.2578-2.9219 5.2578-5.7812 0-2.7578-2.0781-5.0274-4.918-5.7148h4.2031v1.6406h0.47656v-3.7578h-0.47656v1.6406h-11.594l12.375-4.5195v-0.0586l-12.602-4.3438h11.82v1.7148h0.47656v-14.156h-3.7812"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m267.89 289.21v-0.0156l-1.9375-1.2305v-1.0547l2.0703 1.3125 2.7617-1.4609v1.0938l-1.9805 0.99609 0.54688 0.35938h1.4336v0.97265h-4.832v-0.97265"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265.95 286.34h4.832v-0.97265h-4.832z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m270.07 283.02c0-0.17187-0.0273-0.30859-0.0859-0.41406-0.0586-0.10156-0.15625-0.1875-0.29296-0.24609-0.13282-0.0625-0.3125-0.10157-0.53125-0.1211-0.22266-0.0234-0.4961-0.0312-0.82813-0.0312-0.27344 0-0.51562 8e-3 -0.72266 0.0274-0.20703 0.0156-0.3789 0.0547-0.51953 0.10937-0.13672 0.0586-0.23828 0.14063-0.30859 0.25-0.0703 0.11328-0.10547 0.25781-0.10547 0.44531v0.41407h3.3945zm-4.1133-0.1914c0-0.33594 0.0586-0.60938 0.16797-0.81641s0.26953-0.37109 0.47266-0.48437c0.20703-0.11719 0.45312-0.19141 0.74218-0.23438 0.28907-0.0391 0.60938-0.0625 0.96485-0.0625 0.42578 0 0.79297 0.0273 1.1055 0.0781 0.3164 0.0547 0.57421 0.14453 0.77734 0.26953 0.20312 0.125 0.35156 0.29687 0.45312 0.50781 0.0977 0.21094 0.14844 0.48047 0.14844 0.80469v1.5352h-4.832"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m269.42 279.65c0.11329 0 0.21485-0.0117 0.3086-0.0273 0.0937-0.0195 0.17187-0.0547 0.23437-0.10156l0.14844-0.20313c0.0352-0.082 0.0547-0.18359 0.0547-0.3125 0-0.14844-0.0508-0.28125-0.14453-0.40234-0.10157-0.1211-0.25-0.17969-0.45313-0.17969-0.10937 0-0.19922 0.0156-0.28125 0.043l-0.21094 0.14453c-0.0625 0.0703-0.12109 0.16016-0.17187 0.26953-0.0547 0.10938-0.10547 0.2461-0.16016 0.41016-0.0742 0.21484-0.15234 0.40234-0.23828 0.5625-0.0859 0.15625-0.18359 0.28906-0.30078 0.39453-0.11328 0.10547-0.24609 0.18359-0.39844 0.23437-0.15234 0.0469-0.32422 0.0742-0.52343 0.0742-0.47657 0-0.83594-0.13281-1.0703-0.40234-0.23437-0.26563-0.35156-0.62891-0.35156-1.0938 0-0.21875 0.0234-0.41797 0.0703-0.59766 0.0508-0.18359 0.125-0.34375 0.23047-0.47656s0.24219-0.23437 0.40625-0.30859c0.16406-0.0742 0.36328-0.11328 0.59375-0.11328h0.13281v0.93354c-0.23046 0-0.40625 0.043-0.53125 0.12109-0.12109 0.082-0.18359 0.21875-0.18359 0.40625 0 0.10938 0.0156 0.19922 0.0469 0.27344l0.125 0.17188 0.17968 0.0859 0.21094 0.0234c0.14844 0 0.27344-0.0312 0.375-0.0937s0.19531-0.19922 0.27734-0.40625l0.32813-0.75c0.0781-0.18359 0.16406-0.33594 0.25-0.45312 0.0898-0.11719 0.18359-0.21094 0.28516-0.28125 0.10156-0.0703 0.21484-0.11719 0.33593-0.14454 0.1211-0.0273 0.25782-0.043 0.40625-0.043 0.50782 0 0.87891 0.14843 1.1133 0.44531 0.23047 0.29297 0.34766 0.70703 0.34766 1.2344 0 0.55078-0.12109 0.94141-0.35937 1.1797-0.23829 0.23828-0.58204 0.35547-1.0274 0.35547h-0.19531v-0.97266"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m90.637 7.9141v17.617c0 5.0469-4.1523 9.1562-9.2578 9.1562l-53.102 8e-3 -4e-3 -17.621c0-5.0469 4.1524-9.1523 9.2578-9.1523",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m30.398 21.172 4e-3 11.398 31.844-8e-3c3.9336 0 7.1328-3.1524 7.1328-7.0274l-4e-3 -11.398-31.844 8e-3c-3.9336 0-7.1328 3.1523-7.1328 7.0273",
    fill: "#231f20"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m31.109 21.172c-4e-3 -3.4844 2.8789-6.3203 6.4219-6.3203l31.137-4e-3v10.688c0 3.4844-2.8828 6.3203-6.4219 6.3203l-31.137 4e-3",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m37.531 14.141c-3.9336 4e-3 -7.1328 3.1562-7.1328 7.0312l4e-3 11.395h22.676l-4.543-9.2109 4.5391-9.2148",
    fill: "#231f20"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m31.109 21.172c-4e-3 -3.4844 2.8789-6.3203 6.4219-6.3203l14.406-4e-3 -4.1914 8.5078 4.1914 8.5-20.828 4e-3",
    fill: "#231f20"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m35.445 27.438v-0.45313l-8e-3 -0.10547c2.3438 0.21094 5.9688 0.53516 7.6094 0.69141 0.16406 0.0195 0.3125-0.10547 0.32813-0.27344 0.0195-0.16797-0.10547-0.3164-0.26954-0.33203-2.5234-0.24219-9.7148-0.87891-9.7891-0.88672-0.12109-0.0117-0.21875-0.1289-0.21875-0.26953v-4.9102c0-0.13671 0.0977-0.2539 0.21875-0.26562 0.0742-8e-3 7.2656-0.64844 9.7852-0.89063 0.16797-0.0156 0.29297-0.16015 0.27344-0.33203-0.0156-0.16797-0.16407-0.28906-0.33204-0.27343-1.6367 0.15625-5.2578 0.48437-7.6055 0.69531l8e-3 -0.10938v-0.44922c0-0.28906-0.23438-0.52734-0.52735-0.52734h-1.9023c-0.28906 0-0.52734 0.23828-0.52734 0.52734v0.44922c0 0.21875 0.13281 0.41016 0.32422 0.48828-0.19922 0.16016-0.32422 0.41016-0.32422 0.6875v4.9102c0 0.28125 0.125 0.52734 0.32422 0.69141-0.19141 0.0781-0.32422 0.26562-0.32422 0.48437v0.45313c0 0.28906 0.23828 0.52734 0.52734 0.52734h1.9023c0.29297 0 0.52735-0.23828 0.52735-0.52734"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.828 27.742v-0.52734l0.62109-0.71094c0.13672-0.15625 0.21094-0.38281 0.21094-0.625v-5.0508c0-0.24219-0.0781-0.46875-0.21094-0.62109l-0.625-0.71485v-0.52734c0-0.33203-0.28125-0.60156-0.6289-0.60156h-0.80469c-0.11328 0-0.22266 0.0273-0.32031 0.082l-0.10156 0.0937c-0.0664 0.0977-0.10157 0.21094-0.10157 0.32422l4e-3 8.9805c0 0.11328 0.0312 0.22656 0.0977 0.32422l0.10156 0.0937c0.0976 0.0547 0.21094 0.082 0.32031 0.082h0.80469c0.34765 0 0.63281-0.26953 0.63281-0.60157m-1.3633 8e-3 -4e-3 -8.793h0.73438l0.0351 8e-3v0.63672l0.0742 0.19531 0.69922 0.80078c0.0312 0.0352 0.0625 0.1211 0.0625 0.23047v5.0508c0 0.10938-0.0312 0.19532-0.0625 0.23047l-0.69922 0.80078-0.0703 0.19532v0.63671l-0.0391 8e-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.789 25.879v-5.0469c0-0.14063-0.11328-0.25391-0.25-0.25391-0.14063 0-0.25391 0.11328-0.25391 0.25391l4e-3 5.0469c0 0.13672 0.10937 0.25 0.25 0.25 0.14062 0 0.25-0.11328 0.25-0.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.023 25.828c0.15235-0.0664 0.22266-0.23828 0.16016-0.39453-0.0625-0.15234-0.23828-0.22266-0.39063-0.16016-0.2539 0.10547-0.51953 0.15625-0.79687 0.15625-1.1406 0-2.0742-0.92968-2.0742-2.0742-4e-3 -1.1445 0.92969-2.0781 2.0742-2.0781s2.0781 0.93359 2.0781 2.0781l-4e-3 0.0234-0.42578-0.42968c-0.11719-0.11719-0.3086-0.11719-0.42578 0l-0.0859 0.21484 0.0859 0.21094 0.9414 0.9414c0.11719 0.11719 0.3086 0.11719 0.42578 0l0.94141-0.9414c0.11719-0.11719 0.11719-0.3086 0-0.42578-0.11719-0.11719-0.30469-0.11719-0.42188 0l-0.43359 0.43359 4e-3 -0.0273c0-1.4766-1.2031-2.6758-2.6797-2.6758-1.4727 0-2.6758 1.1992-2.6758 2.6758s1.2031 2.6758 2.6758 2.6758c0.35547 0 0.69922-0.0664 1.0273-0.20313"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#040505"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m79.477 24.359c-1.1211-0.75781-2.5938-0.11328-3.3398 0.67578-0.68359 0.71485-0.84375 1.2891-0.86328 1.3633l0.70313 0.36719-2.8828 1.0547-0.60938-2.9805 0.73438 0.39453 0.22656-0.40234c0.8164-1.2539 1.9297-1.5195 2.2773-1.6094 0.59766-0.14843 2.3828-0.37109 3.7539 1.1367"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.43 24.348c-1.2422 0.54297-1.4844 2.1328-1.2148 3.1836 0.23437 0.93359 0.62109 1.375 0.69141 1.4492l8e-3 -4e-3 0.6875-0.39844-0.65625 3.0039-2.8398-1.0898 0.71485-0.39843-0.21094-0.39453c-0.62891-1.3594-0.25781-2.4453-0.14844-2.7812 0.19141-0.58594 0.95703-2.2188 2.9688-2.5703"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.426 29.652c-1.4844-0.21094-2.1953-1.1016-2.4219-1.3789-0.39062-0.48046-1.3476-2.0039-0.5625-3.8867-0.21094 1.3398 0.9961 2.3984 2.0274 2.7461 0.92187 0.30469 1.5078 0.21484 1.5976 0.19922v-0.0117l0.0352-0.79688 2.1758 2.168-2.4453 1.8125 0.0469-0.8164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.676 20.551c0-0.6836 0.55468-1.2383 1.2383-1.2383 0.68359 0 1.2383 0.55468 1.2383 1.2383 0 0.68359-0.55469 1.2422-1.2383 1.2422-0.6836 0-1.2383-0.5586-1.2383-1.2422"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.512 22.246c0-4.4766-3.6406-8.1133-8.1172-8.1133s-8.1133 3.6406-8.1133 8.1172c0 0.23828 0.0156 0.47265 0.0351 0.70703l-0.8125 0.0547 1.4336 1.4805 1.2695-1.6602-0.85547 0.0625c-0.0195-0.21094-0.0352-0.42969-0.0352-0.64844 0-0.34375 0.0274-0.67969 0.0742-1.0117l0.21484-0.0352 6.5703-0.76954c1.2383-0.10546 1.4375 0.60157 1.2539 1.0391l-0.99218 2.4609c-0.1211 0.28516 0.11718 0.41797 0.11718 0.41797s0.2461 0.16016 0.42969-0.125c0 0 2.2188-3.3555 2.3516-4.0703 0.1836-0.97266-0.60547-1.9375-1.6367-2.1523l-5.832-1.1914c1.2266-1.0234 2.8086-1.6406 4.5274-1.6406 3.9062 0 7.082 3.1719 7.082 7.0781 0 2.0859-0.90625 3.9609-2.3438 5.2578l0.73437 0.72657c1.625-1.4844 2.6445-3.6172 2.6445-5.9844m-10.859-3.6133c0.28906 0.10547 0.27344 0.26562 0.27344 0.26562s0.0273 0.14454-0.26563 0.22266l-4.0625 1.1562c0.28125-0.96484 0.75781-1.8477 1.3906-2.5938"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#171817"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m64.316 27.934c-0.38672-0.0234-1.0195-0.0703-1.3125-0.0977-2.6914-0.2539-5.0312-0.8164-6.9609-1.668-0.79687-0.35157-1.5781-0.79688-2.0938-1.1914l1.5508-7.2539c0.14453 0.10938 0.29296 0.21094 0.41015 0.28907 2.1211 1.4062 4.9531 2.293 8.1953 2.5625 0.45704 0.0391 1.2188 0.0664 1.7617 0.0703zm0.73438 0.51953 1.7305-8.1445c0.0312-0.125-4e-3 -0.25781-0.0859-0.35547-0.082-0.0977-0.20703-0.15234-0.33594-0.14453l-0.082 4e-3c-0.39063 0.0234-1.5117-0.0117-2.1016-0.0586-3.0977-0.25781-5.7969-1.0976-7.8086-2.4336-0.23437-0.15234-0.55468-0.38672-0.73047-0.52734l-0.14843-0.11719c-0.11328-0.0898-0.26563-0.11328-0.39453-0.0664-0.13672 0.0469-0.23438 0.16016-0.26563 0.30469l-1.7383 8.1367-8e-3 0.0859c0 0.12109 0.0586 0.24609 0.15234 0.32031l0.12891 0.10547c0.5664 0.45312 1.4414 0.96093 2.3438 1.3594 2.0117 0.89063 4.4414 1.4688 7.2188 1.7344 0.37109 0.0352 1.2812 0.10156 1.5703 0.11718l0.13281 4e-3c0.20313 8e-3 0.37891-0.12891 0.42188-0.32422"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.434 24.254h-0.0469l-0.0859 0.19141c-0.0781 0.0742-0.19141 0.10937-0.31641 0.10156-0.23047-0.0156-0.41797-0.18359-0.42187-0.37109v-4e-3l0.0859-0.1875c0.0742-0.0703 0.19141-0.10547 0.3125-0.10156 0.23047 0.0195 0.42188 0.18359 0.42578 0.37109zm0.0234 0.35938c0.10156-0.0937 0.15625-0.22266 0.15625-0.35938-4e-3 -0.30859-0.28907-0.57422-0.63672-0.59765-0.1875-0.0156-0.36328 0.043-0.48438 0.16015-0.10156 0.0977-0.16015 0.22266-0.16015 0.35938v4e-3c4e-3 0.30079 0.28906 0.57032 0.63672 0.59375 0.1875 0.0156 0.36718-0.043 0.48828-0.16015"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.488 25.215 1.4531-6.6797-0.10547-0.15234-0.14843 0.10156-1.4492 6.6797-4e-3 0.0234 0.10156 0.1289"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#050606"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m58.918 11.305h-0.23828v0.97656h0.25c0.1875 0 0.29688-0.13281 0.29688-0.5 0-0.31641-0.0977-0.48438-0.3086-0.48438"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.238 14.109-0.34766-1.332h-0.22266v1.332h-0.66406v-3.3594h0.96485c0.5664 0 0.90625 0.30469 0.90625 0.99219 0 0.48828-0.16016 0.75782-0.39063 0.88672l0.44141 1.4805zm-1.5508-2.8047h-0.95704v0.80469h0.75391v0.57031h-0.75391v1.4219h-0.65625v-3.3633h1.6133zm2.3867-1.2617h-4.2188c-0.77734 0-1.4023 0.63672-1.4023 1.4023v3.3633l7.0312-4e-3v-3.3594c0-0.77734-0.63672-1.4023-1.4102-1.4023"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.875 14.16c-0.34766 0-0.6211-0.0781-0.80079-0.23047-0.17968-0.14843-0.26953-0.41015-0.26953-0.78125v-0.0977h0.67969v0.0898c0 0.17969 0.0312 0.3086 0.10156 0.39844 0.0703 0.082 0.17969 0.13281 0.34766 0.13281 0.12109 0 0.22266-0.0391 0.29297-0.10937 0.0781-0.0742 0.10937-0.17188 0.10937-0.3125 0-0.10157-0.0195-0.1875-0.0508-0.26172-0.0391-0.0664-0.10937-0.12891-0.23047-0.17578-0.39843-0.16407-0.64843-0.27344-0.73828-0.32422-0.10156-0.04688-0.17969-0.11719-0.24219-0.1875-0.0586-0.07031-0.12109-0.16016-0.16015-0.26953-0.0391-0.10156-0.0586-0.21875-0.0586-0.37109 0-0.32031 0.0899-0.55859 0.26954-0.73047 0.17968-0.16797 0.4414-0.25 0.76953-0.25 0.32812 0 0.58984 0.08203 0.76953 0.23047 0.17969 0.15234 0.26953 0.37891 0.26953 0.69141v0.07813h-0.64844c0-0.32812-0.12109-0.5-0.37109-0.5-0.25781 0-0.38672 0.13281-0.38672 0.39062 0 0.12109 0.0273 0.21875 0.0781 0.28125 0.0508 0.05859 0.14063 0.11719 0.26954 0.17969l0.51953 0.23047c0.23047 0.08984 0.39062 0.20703 0.49218 0.34766 0.0977 0.14063 0.14844 0.32031 0.14844 0.53906 0 0.69141-0.39062 1.0312-1.1719 1.0312zm-1.2695-0.0586h-1.9219v-3.3594l1.8828-0.0039v0.55078h-1.2031v0.79297h1.1328v0.55078h-1.1328v0.89844h1.25v0.55078zm2.3672-4.0625h-4.2188c-0.76953 0.0039-1.4102 0.63281-1.4102 1.4141v3.3594h7.0312v-3.3633c0-0.76953-0.63282-1.4102-1.4102-1.4102"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKıds100X200Wm);
export default __webpack_public_path__ + "static/media/KIDS100x200WM.428773a4383166f04f768e61a1db10fb.svg";
export { ForwardRef as ReactComponent };